CUSEC,municipi,districte,seccio,renda neta
0800101001,Abrera,1,1,16982
0800101002,Abrera,1,2,16030
0800101003,Abrera,1,3,21526
0800101004,Abrera,1,4,18811
0800101005,Abrera,1,5,16657
0800101007,Abrera,1,7,17424
0800101008,Abrera,1,8,18338
0800101009,Abrera,1,9,17620
0800201001,Aguilar de Segarra,1,1,20226
0800301001,Alella,1,1,23575
0800301002,Alella,1,2,25464
0800301003,Alella,1,3,28625
0800301004,Alella,1,4,25851
0800301005,Alella,1,5,23773
0800401001,Alpens,1,1,21037
0800501001,L'Ametlla del Vallès,1,1,22019
0800501002,L'Ametlla del Vallès,1,2,22532
0800501003,L'Ametlla del Vallès,1,3,24217
0800501004,L'Ametlla del Vallès,1,4,23620
0800501005,L'Ametlla del Vallès,1,5,19528
0800601001,Arenys de Mar,1,1,17210
0800601002,Arenys de Mar,1,2,17154
0800601003,Arenys de Mar,1,3,16270
0800601004,Arenys de Mar,1,4,21208
0800602001,Arenys de Mar,2,1,16104
0800602002,Arenys de Mar,2,2,17151
0800602003,Arenys de Mar,2,3,21036
0800602004,Arenys de Mar,2,4,16011
0800602005,Arenys de Mar,2,5,15364
0800701001,Arenys de Munt,1,1,16499
0800701002,Arenys de Munt,1,2,16379
0800701003,Arenys de Munt,1,3,17432
0800702001,Arenys de Munt,2,1,18506
0800702002,Arenys de Munt,2,2,16651
0800801001,Argençola,1,1,17237
0800901001,Argentona,1,1,20147
0800901002,Argentona,1,2,18091
0800901003,Argentona,1,3,13918
0800901004,Argentona,1,4,17054
0800901005,Argentona,1,5,21643
0800901006,Argentona,1,6,24494
0800902001,Argentona,2,1,17290
0800902002,Argentona,2,2,17821
0800902003,Argentona,2,3,18090
0801001001,Artés,1,1,15769
0801002001,Artés,2,1,17004
0801002002,Artés,2,2,15670
0801002003,Artés,2,3,17915
0801101001,Avià,1,1,17932
0801201001,Avinyó,1,1,16869
0801301001,Avinyonet del Penedès,1,1,17711
0801401001,Aiguafreda,1,1,19027
0801501001,Badalona,1,1,24131
0801501002,Badalona,1,2,21661
0801501003,Badalona,1,3,24288
0801501004,Badalona,1,4,23134
0801501005,Badalona,1,5,22266
0801501007,Badalona,1,7,22683
0801501008,,,,
0801502001,Badalona,2,1,17916
0801502002,Badalona,2,2,22368
0801502003,Badalona,2,3,20873
0801502004,Badalona,2,4,22124
0801502005,Badalona,2,5,13657
0801502007,Badalona,2,7,12428
0801502008,Badalona,2,8,21069
0801502009,Badalona,2,9,11021
0801502010,Badalona,2,10,12637
0801502011,Badalona,2,11,14228
0801502012,Badalona,2,12,13687
0801502013,Badalona,2,13,12473
0801502015,Badalona,2,15,12775
0801503001,Badalona,3,1,15218
0801503003,Badalona,3,3,17688
0801503004,Badalona,3,4,19837
0801503005,Badalona,3,5,18142
0801503006,Badalona,3,6,21302
0801503007,Badalona,3,7,22748
0801503008,Badalona,3,8,18658
0801503009,Badalona,3,9,19783
0801503010,Badalona,3,10,13390
0801503011,Badalona,3,11,18715
0801503013,Badalona,3,13,23295
0801503014,Badalona,3,14,21411
0801503015,Badalona,3,15,22575
0801504001,Badalona,4,1,15095
0801504002,Badalona,4,2,18346
0801504003,Badalona,4,3,18100
0801504004,Badalona,4,4,17474
0801504005,Badalona,4,5,16747
0801504006,Badalona,4,6,15704
0801504007,Badalona,4,7,17900
0801504008,Badalona,4,8,16901
0801504009,Badalona,4,9,17372
0801504010,Badalona,4,10,13918
0801504011,Badalona,4,11,16680
0801504012,Badalona,4,12,17399
0801504013,Badalona,4,13,17341
0801504014,Badalona,4,14,21157
0801504015,Badalona,4,15,15908
0801504016,Badalona,4,16,18756
0801504017,Badalona,4,17,19722
0801505001,Badalona,5,1,22673
0801505002,Badalona,5,2,20232
0801505003,Badalona,5,3,20874
0801505004,Badalona,5,4,18854
0801505005,Badalona,5,5,17816
0801505006,Badalona,5,6,20954
0801505007,Badalona,5,7,21201
0801505008,Badalona,5,8,22453
0801506001,Badalona,6,1,16818
0801506002,Badalona,6,2,23903
0801506003,Badalona,6,3,13293
0801506004,Badalona,6,4,12986
0801506005,Badalona,6,5,13541
0801506006,Badalona,6,6,13774
0801507001,Badalona,7,1,13065
0801507002,Badalona,7,2,17046
0801507003,Badalona,7,3,12946
0801507004,Badalona,7,4,18058
0801507005,Badalona,7,5,11798
0801507006,Badalona,7,6,18283
0801507007,Badalona,7,7,9115
0801507008,Badalona,7,8,9403
0801507009,Badalona,7,9,13337
0801507010,Badalona,7,10,11938
0801507011,Badalona,7,11,13916
0801507012,,,,
0801507013,Badalona,7,13,9328
0801507014,Badalona,7,14,13248
0801507015,Badalona,7,15,9153
0801507017,Badalona,7,17,9794
0801507018,Badalona,7,18,17068
0801507020,Badalona,7,20,12610
0801507021,Badalona,7,21,13239
0801507022,Badalona,7,22,16355
0801507023,Badalona,7,23,20417
0801507024,Badalona,7,24,15979
0801507028,Badalona,7,28,11372
0801507029,Badalona,7,29,17147
0801507030,Badalona,7,30,18547
0801507031,Badalona,7,31,16193
0801508001,Badalona,8,1,10419
0801508002,Badalona,8,2,14713
0801508003,Badalona,8,3,13981
0801508004,Badalona,8,4,14738
0801508005,Badalona,8,5,13857
0801508006,Badalona,8,6,15765
0801508007,Badalona,8,7,12014
0801508008,Badalona,8,8,14622
0801508009,Badalona,8,9,15433
0801508011,Badalona,8,11,15389
0801508012,Badalona,8,12,20933
0801508013,Badalona,8,13,17456
0801508014,Badalona,8,14,18734
0801509001,Badalona,9,1,10114
0801509002,Badalona,9,2,8428
0801509003,Badalona,9,3,11760
0801509004,Badalona,9,4,6463
0801509005,Badalona,9,5,10760
0801509006,Badalona,9,6,7702
0801509008,Badalona,9,8,11337
0801509009,Badalona,9,9,13807
0801509010,Badalona,9,10,12226
0801509011,Badalona,9,11,11872
0801509012,Badalona,9,12,11758
0801509013,Badalona,9,13,12626
0801509014,Badalona,9,14,13039
0801509015,Badalona,9,15,11163
0801509016,Badalona,9,16,13315
0801509017,Badalona,9,17,9267
0801509018,Badalona,9,18,12498
0801509019,Badalona,9,19,11474
0801509020,Badalona,9,20,15287
0801509021,Badalona,9,21,11893
0801509022,Badalona,9,22,12398
0801509023,Badalona,9,23,11537
0801509024,Badalona,9,24,13128
0801509025,Badalona,9,25,11608
0801509026,Badalona,9,26,13699
0801509027,Badalona,9,27,11594
0801509028,Badalona,9,28,12379
0801509030,Badalona,9,30,17012
0801509031,Badalona,9,31,13406
0801509032,Badalona,9,32,10466
0801509033,Badalona,9,33,13242
0801509034,Badalona,9,34,15052
0801509035,Badalona,9,35,13071
0801509036,Badalona,9,36,12997
0801509037,Badalona,9,37,7912
0801509038,Badalona,9,38,9257
0801509042,Badalona,9,42,6740
0801509043,Badalona,9,43,14794
0801509044,Badalona,9,44,11908
0801509045,Badalona,9,45,14562
0801509047,Badalona,9,47,11662
0801509049,Badalona,9,49,11792
0801509050,,,,
0801509052,Badalona,9,52,13016
0801509053,Badalona,9,53,11998
0801509054,Badalona,9,54,14250
0801509057,Badalona,9,57,13352
0801509058,Badalona,9,58,15414
0801509059,Badalona,9,59,14597
0801601001,Bagà,1,1,18158
0801701001,Balenyà,1,1,14512
0801701002,Balenyà,1,2,16291
0801701003,Balenyà,1,3,15493
0801801001,Balsareny,1,1,16909
0801801002,Balsareny,1,2,16292
0801801003,,,,
0801901001,Barcelona,Ciutat Vella,1,13210
0801901002,Barcelona,Ciutat Vella,2,12276
0801901003,Barcelona,Ciutat Vella,3,11194
0801901004,Barcelona,Ciutat Vella,4,12870
0801901005,Barcelona,Ciutat Vella,5,11436
0801901006,Barcelona,Ciutat Vella,6,12167
0801901007,Barcelona,Ciutat Vella,7,11466
0801901008,Barcelona,Ciutat Vella,8,9033
0801901009,Barcelona,Ciutat Vella,9,12142
0801901010,Barcelona,Ciutat Vella,10,9941
0801901011,Barcelona,Ciutat Vella,11,10033
0801901012,Barcelona,Ciutat Vella,12,13036
0801901013,Barcelona,Ciutat Vella,13,13013
0801901014,Barcelona,Ciutat Vella,14,11994
0801901015,Barcelona,Ciutat Vella,15,11932
0801901016,Barcelona,Ciutat Vella,16,12407
0801901017,Barcelona,Ciutat Vella,17,10226
0801901018,Barcelona,Ciutat Vella,18,11604
0801901019,Barcelona,Ciutat Vella,19,11746
0801901020,Barcelona,Ciutat Vella,20,17879
0801901021,Barcelona,Ciutat Vella,21,17303
0801901022,Barcelona,Ciutat Vella,22,18981
0801901023,Barcelona,Ciutat Vella,23,18748
0801901025,Barcelona,Ciutat Vella,25,16264
0801901026,Barcelona,Ciutat Vella,26,16610
0801901027,Barcelona,Ciutat Vella,27,16067
0801901028,Barcelona,Ciutat Vella,28,15710
0801901029,Barcelona,Ciutat Vella,29,14376
0801901030,Barcelona,Ciutat Vella,30,14134
0801901031,Barcelona,Ciutat Vella,31,12418
0801901032,Barcelona,Ciutat Vella,32,18183
0801901033,Barcelona,Ciutat Vella,33,14717
0801901034,Barcelona,Ciutat Vella,34,14969
0801901035,Barcelona,Ciutat Vella,35,14910
0801901036,Barcelona,Ciutat Vella,36,15584
0801901037,Barcelona,Ciutat Vella,37,16797
0801901038,Barcelona,Ciutat Vella,38,14390
0801901039,Barcelona,Ciutat Vella,39,16278
0801901040,Barcelona,Ciutat Vella,40,16450
0801901041,Barcelona,Ciutat Vella,41,15207
0801901042,Barcelona,Ciutat Vella,42,16225
0801901043,Barcelona,Ciutat Vella,43,21499
0801901044,Barcelona,Ciutat Vella,44,19372
0801901045,Barcelona,Ciutat Vella,45,17321
0801901046,Barcelona,Ciutat Vella,46,16357
0801901047,Barcelona,Ciutat Vella,47,16474
0801901048,Barcelona,Ciutat Vella,48,12793
0801901049,Barcelona,Ciutat Vella,49,17040
0801901050,Barcelona,Ciutat Vella,50,15822
0801901051,Barcelona,Ciutat Vella,51,15216
0801901052,Barcelona,Ciutat Vella,52,21226
0801901053,Barcelona,Ciutat Vella,53,15018
0801901054,Barcelona,Ciutat Vella,54,16807
0801901055,Barcelona,Ciutat Vella,55,21495
0801902001,Barcelona,L'Eixample,1,22513
0801902002,Barcelona,L'Eixample,2,21055
0801902003,Barcelona,L'Eixample,3,23008
0801902004,Barcelona,L'Eixample,4,18665
0801902005,Barcelona,L'Eixample,5,23183
0801902006,Barcelona,L'Eixample,6,22925
0801902007,Barcelona,L'Eixample,7,23860
0801902008,Barcelona,L'Eixample,8,22742
0801902009,Barcelona,L'Eixample,9,22478
0801902010,Barcelona,L'Eixample,10,20357
0801902011,Barcelona,L'Eixample,11,22168
0801902012,Barcelona,L'Eixample,12,17568
0801902013,Barcelona,L'Eixample,13,19237
0801902014,Barcelona,L'Eixample,14,18344
0801902015,Barcelona,L'Eixample,15,17841
0801902016,Barcelona,L'Eixample,16,22544
0801902017,Barcelona,L'Eixample,17,23396
0801902018,Barcelona,L'Eixample,18,22235
0801902019,Barcelona,L'Eixample,19,21573
0801902020,Barcelona,L'Eixample,20,19826
0801902021,Barcelona,L'Eixample,21,20603
0801902022,Barcelona,L'Eixample,22,20074
0801902023,Barcelona,L'Eixample,23,22053
0801902024,Barcelona,L'Eixample,24,19048
0801902025,Barcelona,L'Eixample,25,18726
0801902026,Barcelona,L'Eixample,26,20122
0801902027,Barcelona,L'Eixample,27,20028
0801902028,Barcelona,L'Eixample,28,20487
0801902029,Barcelona,L'Eixample,29,21577
0801902030,Barcelona,L'Eixample,30,17374
0801902031,Barcelona,L'Eixample,31,21959
0801902032,Barcelona,L'Eixample,32,21726
0801902033,Barcelona,L'Eixample,33,20766
0801902034,Barcelona,L'Eixample,34,17770
0801902035,Barcelona,L'Eixample,35,21107
0801902036,Barcelona,L'Eixample,36,22818
0801902037,Barcelona,L'Eixample,37,24072
0801902038,Barcelona,L'Eixample,38,23421
0801902039,Barcelona,L'Eixample,39,19377
0801902040,Barcelona,L'Eixample,40,18103
0801902041,Barcelona,L'Eixample,41,20873
0801902042,Barcelona,L'Eixample,42,22556
0801902043,Barcelona,L'Eixample,43,21818
0801902044,Barcelona,L'Eixample,44,17948
0801902045,Barcelona,L'Eixample,45,21702
0801902046,Barcelona,L'Eixample,46,18786
0801902047,Barcelona,L'Eixample,47,20512
0801902048,Barcelona,L'Eixample,48,19780
0801902049,Barcelona,L'Eixample,49,19211
0801902050,Barcelona,L'Eixample,50,19723
0801902051,Barcelona,L'Eixample,51,19587
0801902052,Barcelona,L'Eixample,52,20648
0801902053,Barcelona,L'Eixample,53,21104
0801902054,Barcelona,L'Eixample,54,21102
0801902055,Barcelona,L'Eixample,55,22386
0801902056,Barcelona,L'Eixample,56,22819
0801902057,Barcelona,L'Eixample,57,28251
0801902058,Barcelona,L'Eixample,58,25829
0801902059,Barcelona,L'Eixample,59,25868
0801902060,Barcelona,L'Eixample,60,24444
0801902061,Barcelona,L'Eixample,61,22519
0801902062,Barcelona,L'Eixample,62,25893
0801902063,Barcelona,L'Eixample,63,30890
0801902064,Barcelona,L'Eixample,64,30928
0801902065,Barcelona,L'Eixample,65,25469
0801902066,Barcelona,L'Eixample,66,22520
0801902067,Barcelona,L'Eixample,67,22053
0801902068,Barcelona,L'Eixample,68,22076
0801902069,Barcelona,L'Eixample,69,25993
0801902070,Barcelona,L'Eixample,70,25421
0801902071,Barcelona,L'Eixample,71,27258
0801902072,Barcelona,L'Eixample,72,27727
0801902073,Barcelona,L'Eixample,73,26919
0801902074,Barcelona,L'Eixample,74,28799
0801902075,Barcelona,L'Eixample,75,26575
0801902076,Barcelona,L'Eixample,76,30260
0801902077,Barcelona,L'Eixample,77,24902
0801902078,Barcelona,L'Eixample,78,29753
0801902079,Barcelona,L'Eixample,79,29295
0801902080,Barcelona,L'Eixample,80,29489
0801902081,Barcelona,L'Eixample,81,30649
0801902082,Barcelona,L'Eixample,82,28423
0801902083,Barcelona,L'Eixample,83,31479
0801902084,Barcelona,L'Eixample,84,25847
0801902085,Barcelona,L'Eixample,85,27508
0801902086,Barcelona,L'Eixample,86,28979
0801902087,Barcelona,L'Eixample,87,26236
0801902088,Barcelona,L'Eixample,88,26467
0801902089,Barcelona,L'Eixample,89,25384
0801902090,Barcelona,L'Eixample,90,24020
0801902091,Barcelona,L'Eixample,91,24379
0801902092,Barcelona,L'Eixample,92,23168
0801902093,Barcelona,L'Eixample,93,23975
0801902094,Barcelona,L'Eixample,94,25076
0801902095,Barcelona,L'Eixample,95,25615
0801902096,Barcelona,L'Eixample,96,22817
0801902097,Barcelona,L'Eixample,97,20677
0801902098,Barcelona,L'Eixample,98,23518
0801902099,Barcelona,L'Eixample,99,25243
0801902100,Barcelona,L'Eixample,100,24663
0801902101,Barcelona,L'Eixample,101,21377
0801902102,Barcelona,L'Eixample,102,27871
0801902103,Barcelona,L'Eixample,103,21139
0801902104,Barcelona,L'Eixample,104,27061
0801902105,Barcelona,L'Eixample,105,21530
0801902106,Barcelona,L'Eixample,106,27728
0801902107,Barcelona,L'Eixample,107,27612
0801902108,Barcelona,L'Eixample,108,29136
0801902109,Barcelona,L'Eixample,109,30151
0801902110,Barcelona,L'Eixample,110,23801
0801902111,Barcelona,L'Eixample,111,23321
0801902112,Barcelona,L'Eixample,112,28826
0801902113,Barcelona,L'Eixample,113,26861
0801902114,Barcelona,L'Eixample,114,23911
0801902115,Barcelona,L'Eixample,115,21480
0801902116,Barcelona,L'Eixample,116,27114
0801902117,Barcelona,L'Eixample,117,22014
0801902118,Barcelona,L'Eixample,118,26650
0801902119,Barcelona,L'Eixample,119,24968
0801902120,Barcelona,L'Eixample,120,22238
0801902121,Barcelona,L'Eixample,121,24607
0801902122,Barcelona,L'Eixample,122,25211
0801902123,Barcelona,L'Eixample,123,22500
0801902124,Barcelona,L'Eixample,124,23848
0801902125,Barcelona,L'Eixample,125,23154
0801902126,Barcelona,L'Eixample,126,25179
0801902127,Barcelona,L'Eixample,127,21014
0801902128,Barcelona,L'Eixample,128,20194
0801902129,Barcelona,L'Eixample,129,22528
0801902130,Barcelona,L'Eixample,130,31495
0801902131,Barcelona,L'Eixample,131,20797
0801902132,Barcelona,L'Eixample,132,23561
0801902133,Barcelona,L'Eixample,133,22931
0801902134,Barcelona,L'Eixample,134,20751
0801902135,Barcelona,L'Eixample,135,20061
0801902136,Barcelona,L'Eixample,136,22215
0801902137,Barcelona,L'Eixample,137,20446
0801902138,Barcelona,L'Eixample,138,23065
0801902139,Barcelona,L'Eixample,139,22462
0801902140,Barcelona,L'Eixample,140,22359
0801902141,Barcelona,L'Eixample,141,22591
0801902142,Barcelona,L'Eixample,142,19190
0801902143,Barcelona,L'Eixample,143,22346
0801902144,Barcelona,L'Eixample,144,22955
0801902145,Barcelona,L'Eixample,145,20707
0801902146,Barcelona,L'Eixample,146,21064
0801902147,Barcelona,L'Eixample,147,21258
0801902148,Barcelona,L'Eixample,148,23502
0801902149,Barcelona,L'Eixample,149,20239
0801902150,Barcelona,L'Eixample,150,18842
0801902151,Barcelona,L'Eixample,151,21014
0801902152,Barcelona,L'Eixample,152,23195
0801902153,Barcelona,L'Eixample,153,23330
0801902154,Barcelona,L'Eixample,154,18445
0801902155,Barcelona,L'Eixample,155,19545
0801902156,Barcelona,L'Eixample,156,20402
0801902157,Barcelona,L'Eixample,157,19826
0801902158,Barcelona,L'Eixample,158,19802
0801902159,Barcelona,L'Eixample,159,21935
0801902160,Barcelona,L'Eixample,160,23245
0801902161,Barcelona,L'Eixample,161,20580
0801902162,Barcelona,L'Eixample,162,20428
0801902163,Barcelona,L'Eixample,163,22180
0801902164,Barcelona,L'Eixample,164,21256
0801902165,Barcelona,L'Eixample,165,22077
0801902166,Barcelona,L'Eixample,166,20894
0801902167,Barcelona,L'Eixample,167,21044
0801902168,Barcelona,L'Eixample,168,19966
0801902169,Barcelona,L'Eixample,169,20873
0801902170,Barcelona,L'Eixample,170,20996
0801902171,Barcelona,L'Eixample,171,18613
0801902172,Barcelona,L'Eixample,172,19452
0801902173,Barcelona,L'Eixample,173,20886
0801903001,Barcelona,Sants-Montjuïc,1,17754
0801903002,Barcelona,Sants-Montjuïc,2,16063
0801903003,Barcelona,Sants-Montjuïc,3,14981
0801903004,Barcelona,Sants-Montjuïc,4,17612
0801903005,Barcelona,Sants-Montjuïc,5,17193
0801903006,Barcelona,Sants-Montjuïc,6,16069
0801903007,Barcelona,Sants-Montjuïc,7,16199
0801903008,Barcelona,Sants-Montjuïc,8,15267
0801903009,Barcelona,Sants-Montjuïc,9,16191
0801903010,Barcelona,Sants-Montjuïc,10,15365
0801903011,Barcelona,Sants-Montjuïc,11,13860
0801903012,Barcelona,Sants-Montjuïc,12,15645
0801903013,Barcelona,Sants-Montjuïc,13,15064
0801903014,Barcelona,Sants-Montjuïc,14,14726
0801903015,Barcelona,Sants-Montjuïc,15,15589
0801903016,Barcelona,Sants-Montjuïc,16,14913
0801903017,Barcelona,Sants-Montjuïc,17,14832
0801903018,Barcelona,Sants-Montjuïc,18,15207
0801903019,Barcelona,Sants-Montjuïc,19,15193
0801903020,Barcelona,Sants-Montjuïc,20,17875
0801903021,Barcelona,Sants-Montjuïc,21,17253
0801903022,Barcelona,Sants-Montjuïc,22,17649
0801903023,Barcelona,Sants-Montjuïc,23,15303
0801903024,Barcelona,Sants-Montjuïc,24,15685
0801903025,Barcelona,Sants-Montjuïc,25,15013
0801903026,Barcelona,Sants-Montjuïc,26,16087
0801903027,Barcelona,Sants-Montjuïc,27,17085
0801903028,Barcelona,Sants-Montjuïc,28,18935
0801903029,Barcelona,Sants-Montjuïc,29,14621
0801903030,Barcelona,Sants-Montjuïc,30,16514
0801903031,Barcelona,Sants-Montjuïc,31,15751
0801903032,Barcelona,Sants-Montjuïc,32,13301
0801903033,Barcelona,Sants-Montjuïc,33,12031
0801903034,Barcelona,Sants-Montjuïc,34,15922
0801903035,Barcelona,Sants-Montjuïc,35,16862
0801903036,Barcelona,Sants-Montjuïc,36,18294
0801903037,Barcelona,Sants-Montjuïc,37,17595
0801903038,Barcelona,Sants-Montjuïc,38,13211
0801903039,Barcelona,Sants-Montjuïc,39,12307
0801903040,Barcelona,Sants-Montjuïc,40,20464
0801903041,Barcelona,Sants-Montjuïc,41,17970
0801903042,Barcelona,Sants-Montjuïc,42,18412
0801903043,Barcelona,Sants-Montjuïc,43,19396
0801903044,Barcelona,Sants-Montjuïc,44,17663
0801903045,Barcelona,Sants-Montjuïc,45,19153
0801903046,Barcelona,Sants-Montjuïc,46,21881
0801903047,Barcelona,Sants-Montjuïc,47,17818
0801903048,Barcelona,Sants-Montjuïc,48,22041
0801903049,Barcelona,Sants-Montjuïc,49,18820
0801903050,Barcelona,Sants-Montjuïc,50,19508
0801903051,Barcelona,Sants-Montjuïc,51,16155
0801903052,Barcelona,Sants-Montjuïc,52,16889
0801903053,Barcelona,Sants-Montjuïc,53,17031
0801903054,Barcelona,Sants-Montjuïc,54,19697
0801903055,Barcelona,Sants-Montjuïc,55,18289
0801903056,Barcelona,Sants-Montjuïc,56,16978
0801903057,Barcelona,Sants-Montjuïc,57,17900
0801903058,Barcelona,Sants-Montjuïc,58,22516
0801903059,Barcelona,Sants-Montjuïc,59,17760
0801903060,Barcelona,Sants-Montjuïc,60,19687
0801903061,Barcelona,Sants-Montjuïc,61,17507
0801903062,Barcelona,Sants-Montjuïc,62,18604
0801903063,Barcelona,Sants-Montjuïc,63,17570
0801903064,Barcelona,Sants-Montjuïc,64,17067
0801903065,Barcelona,Sants-Montjuïc,65,18151
0801903066,Barcelona,Sants-Montjuïc,66,17466
0801903067,Barcelona,Sants-Montjuïc,67,18568
0801903068,Barcelona,Sants-Montjuïc,68,16397
0801903069,Barcelona,Sants-Montjuïc,69,19324
0801903070,Barcelona,Sants-Montjuïc,70,15692
0801903071,Barcelona,Sants-Montjuïc,71,15758
0801903072,Barcelona,Sants-Montjuïc,72,16890
0801903073,Barcelona,Sants-Montjuïc,73,19313
0801903074,Barcelona,Sants-Montjuïc,74,18129
0801903075,Barcelona,Sants-Montjuïc,75,16925
0801903076,Barcelona,Sants-Montjuïc,76,16885
0801903077,Barcelona,Sants-Montjuïc,77,16803
0801903078,Barcelona,Sants-Montjuïc,78,16066
0801903079,Barcelona,Sants-Montjuïc,79,16158
0801903080,Barcelona,Sants-Montjuïc,80,18451
0801903081,Barcelona,Sants-Montjuïc,81,18068
0801903082,Barcelona,Sants-Montjuïc,82,20014
0801903083,Barcelona,Sants-Montjuïc,83,19938
0801903084,Barcelona,Sants-Montjuïc,84,19482
0801903085,Barcelona,Sants-Montjuïc,85,20271
0801903086,Barcelona,Sants-Montjuïc,86,23387
0801903087,Barcelona,Sants-Montjuïc,87,21109
0801903088,Barcelona,Sants-Montjuïc,88,20059
0801903089,Barcelona,Sants-Montjuïc,89,21513
0801903090,Barcelona,Sants-Montjuïc,90,23335
0801903091,Barcelona,Sants-Montjuïc,91,20097
0801903092,Barcelona,Sants-Montjuïc,92,20142
0801903093,Barcelona,Sants-Montjuïc,93,21069
0801903094,Barcelona,Sants-Montjuïc,94,20496
0801903095,Barcelona,Sants-Montjuïc,95,19720
0801903096,Barcelona,Sants-Montjuïc,96,18266
0801903097,Barcelona,Sants-Montjuïc,97,14753
0801903098,Barcelona,Sants-Montjuïc,98,16041
0801903099,Barcelona,Sants-Montjuïc,99,18328
0801903100,Barcelona,Sants-Montjuïc,100,18308
0801903101,Barcelona,Sants-Montjuïc,101,18814
0801903102,Barcelona,Sants-Montjuïc,102,19039
0801903103,Barcelona,Sants-Montjuïc,103,19406
0801903104,Barcelona,Sants-Montjuïc,104,17102
0801903105,Barcelona,Sants-Montjuïc,105,17350
0801903106,Barcelona,Sants-Montjuïc,106,18154
0801903107,Barcelona,Sants-Montjuïc,107,19405
0801903108,Barcelona,Sants-Montjuïc,108,18170
0801903109,Barcelona,Sants-Montjuïc,109,20608
0801903110,Barcelona,Sants-Montjuïc,110,20896
0801903111,Barcelona,Sants-Montjuïc,111,21047
0801903112,Barcelona,Sants-Montjuïc,112,21184
0801903113,Barcelona,Sants-Montjuïc,113,25619
0801903114,Barcelona,Sants-Montjuïc,114,24457
0801903211,Barcelona,Sants-Montjuïc,211,16609
0801903212,Barcelona,Sants-Montjuïc,212,15070
0801903213,Barcelona,Sants-Montjuïc,213,13007
0801904001,Barcelona,Les Corts,1,22967
0801904002,Barcelona,Les Corts,2,26169
0801904003,Barcelona,Les Corts,3,24648
0801904004,Barcelona,Les Corts,4,23069
0801904005,Barcelona,Les Corts,5,22530
0801904006,Barcelona,Les Corts,6,23414
0801904007,Barcelona,Les Corts,7,19812
0801904008,Barcelona,Les Corts,8,19750
0801904009,Barcelona,Les Corts,9,23142
0801904010,Barcelona,Les Corts,10,23736
0801904011,Barcelona,Les Corts,11,26643
0801904012,Barcelona,Les Corts,12,25332
0801904013,Barcelona,Les Corts,13,27013
0801904014,Barcelona,Les Corts,14,27206
0801904015,Barcelona,Les Corts,15,24226
0801904016,Barcelona,Les Corts,16,27589
0801904017,Barcelona,Les Corts,17,27596
0801904018,Barcelona,Les Corts,18,28063
0801904019,Barcelona,Les Corts,19,31944
0801904020,Barcelona,Les Corts,20,28141
0801904021,Barcelona,Les Corts,21,30799
0801904022,Barcelona,Les Corts,22,25790
0801904023,Barcelona,Les Corts,23,39411
0801904024,Barcelona,Les Corts,24,39612
0801904025,Barcelona,Les Corts,25,25374
0801904026,Barcelona,Les Corts,26,25154
0801904027,Barcelona,Les Corts,27,25451
0801904028,Barcelona,Les Corts,28,23664
0801904029,Barcelona,Les Corts,29,29955
0801904030,Barcelona,Les Corts,30,27885
0801904031,Barcelona,Les Corts,31,22597
0801904032,Barcelona,Les Corts,32,22008
0801904033,Barcelona,Les Corts,33,20963
0801904034,Barcelona,Les Corts,34,27309
0801904035,Barcelona,Les Corts,35,25275
0801904036,Barcelona,Les Corts,36,19793
0801904037,Barcelona,Les Corts,37,22104
0801904038,Barcelona,Les Corts,38,22900
0801904039,Barcelona,Les Corts,39,20724
0801904040,Barcelona,Les Corts,40,18207
0801904041,Barcelona,Les Corts,41,19113
0801904042,Barcelona,Les Corts,42,18767
0801904043,Barcelona,Les Corts,43,25920
0801904044,Barcelona,Les Corts,44,19622
0801904045,Barcelona,Les Corts,45,19853
0801904046,Barcelona,Les Corts,46,28742
0801904047,Barcelona,Les Corts,47,23627
0801904048,Barcelona,Les Corts,48,25770
0801904049,Barcelona,Les Corts,49,31269
0801904050,Barcelona,Les Corts,50,40089
0801904051,Barcelona,Les Corts,51,28794
0801904052,Barcelona,Les Corts,52,40089
0801904053,Barcelona,Les Corts,53,27784
0801904054,Barcelona,Les Corts,54,36689
0801904055,Barcelona,Les Corts,55,40089
0801904056,Barcelona,Les Corts,56,40089
0801904084,Barcelona,Les Corts,84,27891
0801905001,Barcelona,Sarrià-Sant Gervasi,1,19565
0801905002,Barcelona,Sarrià-Sant Gervasi,2,32351
0801905003,Barcelona,Sarrià-Sant Gervasi,3,33003
0801905004,Barcelona,Sarrià-Sant Gervasi,4,40089
0801905005,Barcelona,Sarrià-Sant Gervasi,5,29523
0801905006,Barcelona,Sarrià-Sant Gervasi,6,.
0801905007,Barcelona,Sarrià-Sant Gervasi,7,31136
0801905008,Barcelona,Sarrià-Sant Gervasi,8,40089
0801905009,Barcelona,Sarrià-Sant Gervasi,9,30468
0801905010,Barcelona,Sarrià-Sant Gervasi,10,28387
0801905011,Barcelona,Sarrià-Sant Gervasi,11,29828
0801905012,Barcelona,Sarrià-Sant Gervasi,12,28685
0801905013,Barcelona,Sarrià-Sant Gervasi,13,28451
0801905014,Barcelona,Sarrià-Sant Gervasi,14,32334
0801905015,Barcelona,Sarrià-Sant Gervasi,15,29602
0801905016,Barcelona,Sarrià-Sant Gervasi,16,24120
0801905017,Barcelona,Sarrià-Sant Gervasi,17,40089
0801905018,Barcelona,Sarrià-Sant Gervasi,18,27679
0801905019,Barcelona,Sarrià-Sant Gervasi,19,37467
0801905020,Barcelona,Sarrià-Sant Gervasi,20,37629
0801905021,Barcelona,Sarrià-Sant Gervasi,21,40089
0801905022,Barcelona,Sarrià-Sant Gervasi,22,40089
0801905023,Barcelona,Sarrià-Sant Gervasi,23,27019
0801905024,Barcelona,Sarrià-Sant Gervasi,24,38209
0801905025,Barcelona,Sarrià-Sant Gervasi,25,40089
0801905026,Barcelona,Sarrià-Sant Gervasi,26,40089
0801905027,Barcelona,Sarrià-Sant Gervasi,27,40089
0801905028,Barcelona,Sarrià-Sant Gervasi,28,37138
0801905029,Barcelona,Sarrià-Sant Gervasi,29,40089
0801905030,Barcelona,Sarrià-Sant Gervasi,30,40089
0801905031,Barcelona,Sarrià-Sant Gervasi,31,40089
0801905032,Barcelona,Sarrià-Sant Gervasi,32,40089
0801905033,Barcelona,Sarrià-Sant Gervasi,33,38281
0801905034,Barcelona,Sarrià-Sant Gervasi,34,28042
0801905035,Barcelona,Sarrià-Sant Gervasi,35,40089
0801905036,Barcelona,Sarrià-Sant Gervasi,36,35386
0801905037,Barcelona,Sarrià-Sant Gervasi,37,27373
0801905038,Barcelona,Sarrià-Sant Gervasi,38,25111
0801905039,Barcelona,Sarrià-Sant Gervasi,39,37043
0801905040,Barcelona,Sarrià-Sant Gervasi,40,26653
0801905041,Barcelona,Sarrià-Sant Gervasi,41,28837
0801905042,Barcelona,Sarrià-Sant Gervasi,42,28125
0801905043,Barcelona,Sarrià-Sant Gervasi,43,27411
0801905044,Barcelona,Sarrià-Sant Gervasi,44,27958
0801905045,Barcelona,Sarrià-Sant Gervasi,45,32840
0801905046,Barcelona,Sarrià-Sant Gervasi,46,40089
0801905047,Barcelona,Sarrià-Sant Gervasi,47,35377
0801905048,Barcelona,Sarrià-Sant Gervasi,48,36177
0801905049,Barcelona,Sarrià-Sant Gervasi,49,38505
0801905050,Barcelona,Sarrià-Sant Gervasi,50,30558
0801905051,Barcelona,Sarrià-Sant Gervasi,51,.
0801905052,Barcelona,Sarrià-Sant Gervasi,52,40089
0801905053,Barcelona,Sarrià-Sant Gervasi,53,40089
0801905054,Barcelona,Sarrià-Sant Gervasi,54,40089
0801905055,Barcelona,Sarrià-Sant Gervasi,55,40089
0801905056,Barcelona,Sarrià-Sant Gervasi,56,36860
0801905057,Barcelona,Sarrià-Sant Gervasi,57,40089
0801905058,Barcelona,Sarrià-Sant Gervasi,58,40089
0801905059,Barcelona,Sarrià-Sant Gervasi,59,33229
0801905060,Barcelona,Sarrià-Sant Gervasi,60,40089
0801905061,Barcelona,Sarrià-Sant Gervasi,61,27992
0801905062,Barcelona,Sarrià-Sant Gervasi,62,36983
0801905063,Barcelona,Sarrià-Sant Gervasi,63,31746
0801905064,Barcelona,Sarrià-Sant Gervasi,64,33416
0801905065,Barcelona,Sarrià-Sant Gervasi,65,30935
0801905066,Barcelona,Sarrià-Sant Gervasi,66,35427
0801905067,Barcelona,Sarrià-Sant Gervasi,67,31646
0801905068,Barcelona,Sarrià-Sant Gervasi,68,28559
0801905069,Barcelona,Sarrià-Sant Gervasi,69,31919
0801905070,Barcelona,Sarrià-Sant Gervasi,70,29376
0801905071,Barcelona,Sarrià-Sant Gervasi,71,25980
0801905072,Barcelona,Sarrià-Sant Gervasi,72,28287
0801905073,Barcelona,Sarrià-Sant Gervasi,73,29143
0801905074,Barcelona,Sarrià-Sant Gervasi,74,33883
0801905075,Barcelona,Sarrià-Sant Gervasi,75,28168
0801905076,Barcelona,Sarrià-Sant Gervasi,76,30425
0801905077,Barcelona,Sarrià-Sant Gervasi,77,33423
0801905078,Barcelona,Sarrià-Sant Gervasi,78,28805
0801905079,Barcelona,Sarrià-Sant Gervasi,79,28403
0801905080,Barcelona,Sarrià-Sant Gervasi,80,25819
0801905081,Barcelona,Sarrià-Sant Gervasi,81,27839
0801905082,Barcelona,Sarrià-Sant Gervasi,82,25286
0801905083,Barcelona,Sarrià-Sant Gervasi,83,26866
0801905084,Barcelona,Sarrià-Sant Gervasi,84,24928
0801905085,Barcelona,Sarrià-Sant Gervasi,85,24293
0801905086,Barcelona,Sarrià-Sant Gervasi,86,26294
0801905087,Barcelona,Sarrià-Sant Gervasi,87,26437
0801905088,Barcelona,Sarrià-Sant Gervasi,88,27993
0801905089,Barcelona,Sarrià-Sant Gervasi,89,26780
0801905090,Barcelona,Sarrià-Sant Gervasi,90,24866
0801905091,Barcelona,Sarrià-Sant Gervasi,91,25593
0801905092,Barcelona,Sarrià-Sant Gervasi,92,33078
0801905093,Barcelona,Sarrià-Sant Gervasi,93,29888
0801905094,Barcelona,Sarrià-Sant Gervasi,94,31748
0801905095,Barcelona,Sarrià-Sant Gervasi,95,23912
0801905096,Barcelona,Sarrià-Sant Gervasi,96,23245
0801905097,Barcelona,Sarrià-Sant Gervasi,97,27691
0801905098,Barcelona,Sarrià-Sant Gervasi,98,22544
0801906001,Barcelona,Gràcia,1,20898
0801906002,Barcelona,Gràcia,2,21089
0801906003,Barcelona,Gràcia,3,19695
0801906004,Barcelona,Gràcia,4,21632
0801906006,Barcelona,Gràcia,6,28040
0801906007,Barcelona,Gràcia,7,24081
0801906008,Barcelona,Gràcia,8,21184
0801906009,Barcelona,Gràcia,9,31048
0801906010,Barcelona,Gràcia,10,24854
0801906011,Barcelona,Gràcia,11,24990
0801906012,Barcelona,Gràcia,12,25334
0801906013,Barcelona,Gràcia,13,19797
0801906014,Barcelona,Gràcia,14,18783
0801906015,Barcelona,Gràcia,15,17226
0801906016,Barcelona,Gràcia,16,17143
0801906017,Barcelona,Gràcia,17,17855
0801906018,Barcelona,Gràcia,18,20736
0801906019,Barcelona,Gràcia,19,20448
0801906020,Barcelona,Gràcia,20,22923
0801906021,Barcelona,Gràcia,21,23545
0801906022,Barcelona,Gràcia,22,22702
0801906023,Barcelona,Gràcia,23,27154
0801906024,Barcelona,Gràcia,24,22144
0801906025,Barcelona,Gràcia,25,23298
0801906026,Barcelona,Gràcia,26,22563
0801906027,Barcelona,Gràcia,27,23973
0801906028,Barcelona,Gràcia,28,20448
0801906029,Barcelona,Gràcia,29,24152
0801906030,Barcelona,Gràcia,30,20675
0801906031,Barcelona,Gràcia,31,21358
0801906032,Barcelona,Gràcia,32,20381
0801906033,Barcelona,Gràcia,33,21314
0801906034,Barcelona,Gràcia,34,20830
0801906035,Barcelona,Gràcia,35,24959
0801906036,Barcelona,Gràcia,36,23325
0801906037,Barcelona,Gràcia,37,22019
0801906038,Barcelona,Gràcia,38,21692
0801906039,Barcelona,Gràcia,39,20378
0801906040,Barcelona,Gràcia,40,22826
0801906041,Barcelona,Gràcia,41,24929
0801906042,Barcelona,Gràcia,42,24617
0801906043,Barcelona,Gràcia,43,24036
0801906044,Barcelona,Gràcia,44,29932
0801906045,Barcelona,Gràcia,45,22835
0801906046,Barcelona,Gràcia,46,20744
0801906047,Barcelona,Gràcia,47,20690
0801906048,Barcelona,Gràcia,48,19320
0801906049,Barcelona,Gràcia,49,21577
0801906050,Barcelona,Gràcia,50,19818
0801906051,Barcelona,Gràcia,51,21580
0801906052,Barcelona,Gràcia,52,21439
0801906053,Barcelona,Gràcia,53,21594
0801906054,Barcelona,Gràcia,54,19968
0801906055,Barcelona,Gràcia,55,22165
0801906056,Barcelona,Gràcia,56,19517
0801906057,Barcelona,Gràcia,57,20267
0801906058,Barcelona,Gràcia,58,21572
0801906059,Barcelona,Gràcia,59,21129
0801906060,Barcelona,Gràcia,60,19985
0801906061,Barcelona,Gràcia,61,20554
0801906062,Barcelona,Gràcia,62,20224
0801906063,Barcelona,Gràcia,63,20869
0801906064,Barcelona,Gràcia,64,21939
0801906065,Barcelona,Gràcia,65,24278
0801906066,Barcelona,Gràcia,66,20874
0801906067,Barcelona,Gràcia,67,22772
0801906068,Barcelona,Gràcia,68,25143
0801906069,Barcelona,Gràcia,69,22479
0801906070,Barcelona,Gràcia,70,21318
0801906071,Barcelona,Gràcia,71,23608
0801906072,Barcelona,Gràcia,72,24548
0801906073,Barcelona,Gràcia,73,21491
0801906074,Barcelona,Gràcia,74,20401
0801906075,Barcelona,Gràcia,75,23967
0801906076,Barcelona,Gràcia,76,22308
0801906077,Barcelona,Gràcia,77,20385
0801906078,Barcelona,Gràcia,78,20766
0801906079,Barcelona,Gràcia,79,21413
0801906080,Barcelona,Gràcia,80,21237
0801906081,Barcelona,Gràcia,81,21085
0801906082,Barcelona,Gràcia,82,22702
0801906083,Barcelona,Gràcia,83,24389
0801906084,Barcelona,Gràcia,84,21758
0801906085,Barcelona,Gràcia,85,23141
0801906086,Barcelona,Gràcia,86,26547
0801906087,Barcelona,Gràcia,87,24801
0801906088,Barcelona,Gràcia,88,22322
0801907001,Barcelona,Horta-Guinardó,1,23203
0801907002,Barcelona,Horta-Guinardó,2,19703
0801907003,Barcelona,Horta-Guinardó,3,20155
0801907004,Barcelona,Horta-Guinardó,4,19394
0801907005,Barcelona,Horta-Guinardó,5,19205
0801907006,Barcelona,Horta-Guinardó,6,21260
0801907007,Barcelona,Horta-Guinardó,7,18617
0801907008,Barcelona,Horta-Guinardó,8,20245
0801907009,Barcelona,Horta-Guinardó,9,18073
0801907010,Barcelona,Horta-Guinardó,10,21814
0801907011,Barcelona,Horta-Guinardó,11,19375
0801907012,Barcelona,Horta-Guinardó,12,18357
0801907013,Barcelona,Horta-Guinardó,13,21523
0801907014,Barcelona,Horta-Guinardó,14,17890
0801907015,Barcelona,Horta-Guinardó,15,18596
0801907016,Barcelona,Horta-Guinardó,16,21737
0801907017,Barcelona,Horta-Guinardó,17,19412
0801907018,Barcelona,Horta-Guinardó,18,18902
0801907019,Barcelona,Horta-Guinardó,19,19656
0801907020,Barcelona,Horta-Guinardó,20,19268
0801907021,Barcelona,Horta-Guinardó,21,22083
0801907022,Barcelona,Horta-Guinardó,22,18684
0801907023,Barcelona,Horta-Guinardó,23,16090
0801907024,Barcelona,Horta-Guinardó,24,18165
0801907025,Barcelona,Horta-Guinardó,25,17356
0801907026,Barcelona,Horta-Guinardó,26,18215
0801907027,Barcelona,Horta-Guinardó,27,17402
0801907028,Barcelona,Horta-Guinardó,28,18371
0801907029,Barcelona,Horta-Guinardó,29,20097
0801907030,Barcelona,Horta-Guinardó,30,16491
0801907031,Barcelona,Horta-Guinardó,31,17165
0801907032,Barcelona,Horta-Guinardó,32,18969
0801907033,Barcelona,Horta-Guinardó,33,19866
0801907034,Barcelona,Horta-Guinardó,34,20494
0801907035,Barcelona,Horta-Guinardó,35,21856
0801907036,Barcelona,Horta-Guinardó,36,21691
0801907037,Barcelona,Horta-Guinardó,37,19659
0801907038,Barcelona,Horta-Guinardó,38,18963
0801907039,Barcelona,Horta-Guinardó,39,19823
0801907040,Barcelona,Horta-Guinardó,40,19334
0801907041,Barcelona,Horta-Guinardó,41,18293
0801907042,Barcelona,Horta-Guinardó,42,19097
0801907043,Barcelona,Horta-Guinardó,43,19203
0801907044,Barcelona,Horta-Guinardó,44,20394
0801907045,Barcelona,Horta-Guinardó,45,17870
0801907046,Barcelona,Horta-Guinardó,46,18263
0801907047,Barcelona,Horta-Guinardó,47,18448
0801907048,Barcelona,Horta-Guinardó,48,18959
0801907049,Barcelona,Horta-Guinardó,49,19338
0801907050,Barcelona,Horta-Guinardó,50,17784
0801907051,Barcelona,Horta-Guinardó,51,18248
0801907052,Barcelona,Horta-Guinardó,52,22569
0801907053,Barcelona,Horta-Guinardó,53,20692
0801907054,Barcelona,Horta-Guinardó,54,24809
0801907055,Barcelona,Horta-Guinardó,55,27279
0801907056,Barcelona,Horta-Guinardó,56,20250
0801907057,Barcelona,Horta-Guinardó,57,21288
0801907058,Barcelona,Horta-Guinardó,58,20893
0801907059,Barcelona,Horta-Guinardó,59,15203
0801907060,Barcelona,Horta-Guinardó,60,15472
0801907061,Barcelona,Horta-Guinardó,61,15872
0801907062,Barcelona,Horta-Guinardó,62,15633
0801907063,Barcelona,Horta-Guinardó,63,13311
0801907064,Barcelona,Horta-Guinardó,64,14338
0801907065,Barcelona,Horta-Guinardó,65,12745
0801907066,Barcelona,Horta-Guinardó,66,13314
0801907067,Barcelona,Horta-Guinardó,67,13770
0801907068,Barcelona,Horta-Guinardó,68,12130
0801907069,Barcelona,Horta-Guinardó,69,13333
0801907070,Barcelona,Horta-Guinardó,70,13918
0801907071,Barcelona,Horta-Guinardó,71,15889
0801907072,Barcelona,Horta-Guinardó,72,15634
0801907073,Barcelona,Horta-Guinardó,73,13798
0801907074,Barcelona,Horta-Guinardó,74,14130
0801907075,Barcelona,Horta-Guinardó,75,14028
0801907076,Barcelona,Horta-Guinardó,76,13906
0801907077,Barcelona,Horta-Guinardó,77,13531
0801907078,Barcelona,Horta-Guinardó,78,13716
0801907079,Barcelona,Horta-Guinardó,79,13679
0801907080,Barcelona,Horta-Guinardó,80,14784
0801907081,Barcelona,Horta-Guinardó,81,16390
0801907082,Barcelona,Horta-Guinardó,82,14795
0801907083,Barcelona,Horta-Guinardó,83,15568
0801907084,Barcelona,Horta-Guinardó,84,15238
0801907085,Barcelona,Horta-Guinardó,85,16702
0801907086,Barcelona,Horta-Guinardó,86,14641
0801907087,Barcelona,Horta-Guinardó,87,16524
0801907088,Barcelona,Horta-Guinardó,88,15708
0801907089,Barcelona,Horta-Guinardó,89,19310
0801907090,Barcelona,Horta-Guinardó,90,16551
0801907091,Barcelona,Horta-Guinardó,91,16843
0801907092,Barcelona,Horta-Guinardó,92,12705
0801907093,Barcelona,Horta-Guinardó,93,15592
0801907094,Barcelona,Horta-Guinardó,94,17203
0801907095,Barcelona,Horta-Guinardó,95,17639
0801907096,Barcelona,Horta-Guinardó,96,16024
0801907097,Barcelona,Horta-Guinardó,97,20601
0801907098,Barcelona,Horta-Guinardó,98,23801
0801907099,Barcelona,Horta-Guinardó,99,20821
0801907100,Barcelona,Horta-Guinardó,100,18726
0801907101,Barcelona,Horta-Guinardó,101,18982
0801907102,Barcelona,Horta-Guinardó,102,20072
0801907103,Barcelona,Horta-Guinardó,103,17072
0801907104,Barcelona,Horta-Guinardó,104,16382
0801907105,Barcelona,Horta-Guinardó,105,20716
0801907106,Barcelona,Horta-Guinardó,106,19261
0801907107,Barcelona,Horta-Guinardó,107,22411
0801907108,Barcelona,Horta-Guinardó,108,19428
0801907109,Barcelona,Horta-Guinardó,109,16130
0801907110,Barcelona,Horta-Guinardó,110,20053
0801907111,Barcelona,Horta-Guinardó,111,22881
0801907112,Barcelona,Horta-Guinardó,112,19245
0801907113,Barcelona,Horta-Guinardó,113,16955
0801907114,Barcelona,Horta-Guinardó,114,19782
0801907115,Barcelona,Horta-Guinardó,115,23201
0801907116,Barcelona,Horta-Guinardó,116,18479
0801907117,Barcelona,Horta-Guinardó,117,19479
0801907118,Barcelona,Horta-Guinardó,118,18577
0801907119,Barcelona,Horta-Guinardó,119,16451
0801907120,Barcelona,Horta-Guinardó,120,17016
0801907121,Barcelona,Horta-Guinardó,121,16017
0801907122,Barcelona,Horta-Guinardó,122,19538
0801907123,Barcelona,Horta-Guinardó,123,19627
0801908001,Barcelona,Nou Barris,1,17657
0801908002,Barcelona,Nou Barris,2,19054
0801908003,Barcelona,Nou Barris,3,16899
0801908004,Barcelona,Nou Barris,4,16095
0801908005,Barcelona,Nou Barris,5,18295
0801908006,Barcelona,Nou Barris,6,18311
0801908007,Barcelona,Nou Barris,7,18048
0801908008,Barcelona,Nou Barris,8,17721
0801908009,Barcelona,Nou Barris,9,16708
0801908010,Barcelona,Nou Barris,10,19771
0801908011,Barcelona,Nou Barris,11,19718
0801908012,Barcelona,Nou Barris,12,18409
0801908013,Barcelona,Nou Barris,13,17404
0801908014,Barcelona,Nou Barris,14,16546
0801908015,Barcelona,Nou Barris,15,14658
0801908016,Barcelona,Nou Barris,16,17446
0801908017,Barcelona,Nou Barris,17,18256
0801908018,Barcelona,Nou Barris,18,17783
0801908019,Barcelona,Nou Barris,19,16257
0801908020,Barcelona,Nou Barris,20,16394
0801908021,Barcelona,Nou Barris,21,17585
0801908022,Barcelona,Nou Barris,22,17590
0801908023,Barcelona,Nou Barris,23,15913
0801908024,Barcelona,Nou Barris,24,16692
0801908025,Barcelona,Nou Barris,25,14723
0801908026,Barcelona,Nou Barris,26,17531
0801908027,Barcelona,Nou Barris,27,18660
0801908028,Barcelona,Nou Barris,28,16209
0801908029,Barcelona,Nou Barris,29,14303
0801908030,Barcelona,Nou Barris,30,15536
0801908031,Barcelona,Nou Barris,31,16386
0801908032,Barcelona,Nou Barris,32,16867
0801908033,Barcelona,Nou Barris,33,14906
0801908034,Barcelona,Nou Barris,34,13226
0801908035,Barcelona,Nou Barris,35,16060
0801908036,Barcelona,Nou Barris,36,13201
0801908037,Barcelona,Nou Barris,37,15343
0801908038,Barcelona,Nou Barris,38,14242
0801908039,Barcelona,Nou Barris,39,14329
0801908040,Barcelona,Nou Barris,40,13038
0801908041,Barcelona,Nou Barris,41,10936
0801908042,Barcelona,Nou Barris,42,16647
0801908043,Barcelona,Nou Barris,43,16018
0801908044,Barcelona,Nou Barris,44,12819
0801908045,Barcelona,Nou Barris,45,12374
0801908046,Barcelona,Nou Barris,46,13520
0801908047,Barcelona,Nou Barris,47,11505
0801908048,Barcelona,Nou Barris,48,11080
0801908049,Barcelona,Nou Barris,49,14131
0801908050,Barcelona,Nou Barris,50,19610
0801908051,Barcelona,Nou Barris,51,17843
0801908052,Barcelona,Nou Barris,52,16322
0801908053,Barcelona,Nou Barris,53,19532
0801908054,Barcelona,Nou Barris,54,17735
0801908055,Barcelona,Nou Barris,55,21858
0801908056,Barcelona,Nou Barris,56,15722
0801908057,Barcelona,Nou Barris,57,16606
0801908058,Barcelona,Nou Barris,58,14586
0801908059,Barcelona,Nou Barris,59,15513
0801908060,Barcelona,Nou Barris,60,17489
0801908061,Barcelona,Nou Barris,61,15810
0801908062,Barcelona,Nou Barris,62,17385
0801908063,Barcelona,Nou Barris,63,19535
0801908064,Barcelona,Nou Barris,64,15209
0801908065,Barcelona,Nou Barris,65,11899
0801908066,Barcelona,Nou Barris,66,10857
0801908067,Barcelona,Nou Barris,67,13491
0801908068,Barcelona,Nou Barris,68,11832
0801908069,Barcelona,Nou Barris,69,12144
0801908070,Barcelona,Nou Barris,70,11626
0801908071,Barcelona,Nou Barris,71,12657
0801908072,Barcelona,Nou Barris,72,14190
0801908073,Barcelona,Nou Barris,73,10850
0801908074,Barcelona,Nou Barris,74,11741
0801908075,Barcelona,Nou Barris,75,13683
0801908076,Barcelona,Nou Barris,76,14386
0801908077,Barcelona,Nou Barris,77,12518
0801908078,Barcelona,Nou Barris,78,12571
0801908079,Barcelona,Nou Barris,79,12435
0801908080,Barcelona,Nou Barris,80,13489
0801908081,Barcelona,Nou Barris,81,12350
0801908082,Barcelona,Nou Barris,82,13902
0801908083,Barcelona,Nou Barris,83,13471
0801908084,Barcelona,Nou Barris,84,14816
0801908085,Barcelona,Nou Barris,85,13732
0801908086,Barcelona,Nou Barris,86,14694
0801908087,Barcelona,Nou Barris,87,14383
0801908088,Barcelona,Nou Barris,88,14864
0801908089,Barcelona,Nou Barris,89,14621
0801908090,Barcelona,Nou Barris,90,14906
0801908091,Barcelona,Nou Barris,91,14272
0801908092,Barcelona,Nou Barris,92,15718
0801908093,Barcelona,Nou Barris,93,14982
0801908094,Barcelona,Nou Barris,94,15199
0801908095,Barcelona,Nou Barris,95,18331
0801908096,Barcelona,Nou Barris,96,14715
0801908097,Barcelona,Nou Barris,97,14235
0801908098,Barcelona,Nou Barris,98,13718
0801908099,Barcelona,Nou Barris,99,13689
0801908100,Barcelona,Nou Barris,100,14130
0801908101,Barcelona,Nou Barris,101,14983
0801908102,Barcelona,Nou Barris,102,12771
0801908103,Barcelona,Nou Barris,103,10794
0801908104,Barcelona,Nou Barris,104,12097
0801908105,Barcelona,Nou Barris,105,11911
0801908106,Barcelona,Nou Barris,106,11794
0801908107,Barcelona,Nou Barris,107,12907
0801908108,Barcelona,Nou Barris,108,11378
0801908109,Barcelona,Nou Barris,109,11874
0801908110,Barcelona,Nou Barris,110,9374
0801908111,Barcelona,Nou Barris,111,9747
0801908112,Barcelona,Nou Barris,112,10500
0801908113,Barcelona,Nou Barris,113,10276
0801908114,Barcelona,Nou Barris,114,11161
0801908115,Barcelona,Nou Barris,115,11051
0801908116,Barcelona,Nou Barris,116,12097
0801908215,Barcelona,Nou Barris,215,17705
0801909001,Barcelona,Sant Andreu,1,9703
0801909002,Barcelona,Sant Andreu,2,10917
0801909003,Barcelona,Sant Andreu,3,11237
0801909004,Barcelona,Sant Andreu,4,11632
0801909005,Barcelona,Sant Andreu,5,14346
0801909006,Barcelona,Sant Andreu,6,12150
0801909007,Barcelona,Sant Andreu,7,11491
0801909008,Barcelona,Sant Andreu,8,21040
0801909009,Barcelona,Sant Andreu,9,16377
0801909010,Barcelona,Sant Andreu,10,14883
0801909011,Barcelona,Sant Andreu,11,12615
0801909013,Barcelona,Sant Andreu,13,11363
0801909014,Barcelona,Sant Andreu,14,12374
0801909015,Barcelona,Sant Andreu,15,12324
0801909016,Barcelona,Sant Andreu,16,18446
0801909017,Barcelona,Sant Andreu,17,18934
0801909018,Barcelona,Sant Andreu,18,17952
0801909019,Barcelona,Sant Andreu,19,20392
0801909020,Barcelona,Sant Andreu,20,19212
0801909021,Barcelona,Sant Andreu,21,19930
0801909022,Barcelona,Sant Andreu,22,21839
0801909023,Barcelona,Sant Andreu,23,21042
0801909024,Barcelona,Sant Andreu,24,19971
0801909025,Barcelona,Sant Andreu,25,21680
0801909026,Barcelona,Sant Andreu,26,21164
0801909027,Barcelona,Sant Andreu,27,20401
0801909028,Barcelona,Sant Andreu,28,23361
0801909029,Barcelona,Sant Andreu,29,18770
0801909030,Barcelona,Sant Andreu,30,19964
0801909031,Barcelona,Sant Andreu,31,21052
0801909032,Barcelona,Sant Andreu,32,15589
0801909033,Barcelona,Sant Andreu,33,17922
0801909034,Barcelona,Sant Andreu,34,16248
0801909035,Barcelona,Sant Andreu,35,18683
0801909036,Barcelona,Sant Andreu,36,19858
0801909037,Barcelona,Sant Andreu,37,16201
0801909038,Barcelona,Sant Andreu,38,19747
0801909039,Barcelona,Sant Andreu,39,19245
0801909040,Barcelona,Sant Andreu,40,20482
0801909041,Barcelona,Sant Andreu,41,18833
0801909042,Barcelona,Sant Andreu,42,20482
0801909043,Barcelona,Sant Andreu,43,17925
0801909044,Barcelona,Sant Andreu,44,19855
0801909045,Barcelona,Sant Andreu,45,19226
0801909046,Barcelona,Sant Andreu,46,20532
0801909047,Barcelona,Sant Andreu,47,20780
0801909048,Barcelona,Sant Andreu,48,18791
0801909049,Barcelona,Sant Andreu,49,17438
0801909050,Barcelona,Sant Andreu,50,19895
0801909051,Barcelona,Sant Andreu,51,19780
0801909052,Barcelona,Sant Andreu,52,18963
0801909053,Barcelona,Sant Andreu,53,20604
0801909054,Barcelona,Sant Andreu,54,19918
0801909055,Barcelona,Sant Andreu,55,14932
0801909056,Barcelona,Sant Andreu,56,18834
0801909057,Barcelona,Sant Andreu,57,17262
0801909058,Barcelona,Sant Andreu,58,19319
0801909059,Barcelona,Sant Andreu,59,19611
0801909060,Barcelona,Sant Andreu,60,17995
0801909061,Barcelona,Sant Andreu,61,20008
0801909062,Barcelona,Sant Andreu,62,20081
0801909063,Barcelona,Sant Andreu,63,20121
0801909064,Barcelona,Sant Andreu,64,19147
0801909065,Barcelona,Sant Andreu,65,17317
0801909066,Barcelona,Sant Andreu,66,20908
0801909067,Barcelona,Sant Andreu,67,16894
0801909068,Barcelona,Sant Andreu,68,19559
0801909069,Barcelona,Sant Andreu,69,18045
0801909070,Barcelona,Sant Andreu,70,14607
0801909071,Barcelona,Sant Andreu,71,17012
0801909072,Barcelona,Sant Andreu,72,15080
0801909073,Barcelona,Sant Andreu,73,18989
0801909074,Barcelona,Sant Andreu,74,17649
0801909075,Barcelona,Sant Andreu,75,17350
0801909076,Barcelona,Sant Andreu,76,17643
0801909077,Barcelona,Sant Andreu,77,18105
0801909078,Barcelona,Sant Andreu,78,18838
0801909079,Barcelona,Sant Andreu,79,19196
0801909080,Barcelona,Sant Andreu,80,19057
0801909081,Barcelona,Sant Andreu,81,18515
0801909082,Barcelona,Sant Andreu,82,17961
0801909083,Barcelona,Sant Andreu,83,18892
0801909084,Barcelona,Sant Andreu,84,20204
0801909085,Barcelona,Sant Andreu,85,18731
0801909086,Barcelona,Sant Andreu,86,18243
0801909087,Barcelona,Sant Andreu,87,19937
0801909088,Barcelona,Sant Andreu,88,17100
0801909089,Barcelona,Sant Andreu,89,17905
0801909090,Barcelona,Sant Andreu,90,17284
0801909091,Barcelona,Sant Andreu,91,18506
0801909092,Barcelona,Sant Andreu,92,18364
0801909093,Barcelona,Sant Andreu,93,19248
0801909094,Barcelona,Sant Andreu,94,18674
0801909095,Barcelona,Sant Andreu,95,19405
0801909156,Barcelona,Sant Andreu,156,16803
0801910001,Barcelona,Sant Martí,1,17121
0801910002,Barcelona,Sant Martí,2,18537
0801910003,Barcelona,Sant Martí,3,18819
0801910004,Barcelona,Sant Martí,4,18498
0801910005,Barcelona,Sant Martí,5,19465
0801910006,Barcelona,Sant Martí,6,20359
0801910007,Barcelona,Sant Martí,7,23994
0801910008,Barcelona,Sant Martí,8,19378
0801910009,Barcelona,Sant Martí,9,19025
0801910010,Barcelona,Sant Martí,10,18752
0801910011,Barcelona,Sant Martí,11,20441
0801910012,Barcelona,Sant Martí,12,20206
0801910013,Barcelona,Sant Martí,13,19372
0801910014,Barcelona,Sant Martí,14,18520
0801910015,Barcelona,Sant Martí,15,19710
0801910016,Barcelona,Sant Martí,16,20485
0801910017,Barcelona,Sant Martí,17,19904
0801910018,Barcelona,Sant Martí,18,18049
0801910019,Barcelona,Sant Martí,19,20030
0801910020,Barcelona,Sant Martí,20,17597
0801910021,Barcelona,Sant Martí,21,18045
0801910022,Barcelona,Sant Martí,22,20055
0801910023,Barcelona,Sant Martí,23,18489
0801910024,Barcelona,Sant Martí,24,19965
0801910025,Barcelona,Sant Martí,25,17913
0801910026,Barcelona,Sant Martí,26,20830
0801910027,Barcelona,Sant Martí,27,19196
0801910028,Barcelona,Sant Martí,28,18738
0801910029,Barcelona,Sant Martí,29,17596
0801910030,Barcelona,Sant Martí,30,18732
0801910031,Barcelona,Sant Martí,31,18657
0801910032,Barcelona,Sant Martí,32,20458
0801910033,Barcelona,Sant Martí,33,21840
0801910034,Barcelona,Sant Martí,34,19161
0801910035,Barcelona,Sant Martí,35,20274
0801910036,Barcelona,Sant Martí,36,21832
0801910037,Barcelona,Sant Martí,37,15138
0801910038,Barcelona,Sant Martí,38,20212
0801910039,Barcelona,Sant Martí,39,17733
0801910040,Barcelona,Sant Martí,40,18972
0801910041,Barcelona,Sant Martí,41,19059
0801910042,Barcelona,Sant Martí,42,18214
0801910043,Barcelona,Sant Martí,43,20868
0801910044,Barcelona,Sant Martí,44,20134
0801910045,Barcelona,Sant Martí,45,22082
0801910046,Barcelona,Sant Martí,46,21413
0801910047,Barcelona,Sant Martí,47,20778
0801910048,Barcelona,Sant Martí,48,22182
0801910049,Barcelona,Sant Martí,49,20790
0801910050,Barcelona,Sant Martí,50,21415
0801910051,Barcelona,Sant Martí,51,22304
0801910052,Barcelona,Sant Martí,52,27513
0801910053,Barcelona,Sant Martí,53,32722
0801910054,Barcelona,Sant Martí,54,29202
0801910055,Barcelona,Sant Martí,55,31783
0801910056,Barcelona,Sant Martí,56,20294
0801910057,Barcelona,Sant Martí,57,18776
0801910058,Barcelona,Sant Martí,58,19354
0801910059,Barcelona,Sant Martí,59,21471
0801910060,Barcelona,Sant Martí,60,19243
0801910061,Barcelona,Sant Martí,61,21948
0801910062,Barcelona,Sant Martí,62,21377
0801910063,Barcelona,Sant Martí,63,22181
0801910064,Barcelona,Sant Martí,64,21604
0801910065,Barcelona,Sant Martí,65,21219
0801910066,Barcelona,Sant Martí,66,21857
0801910067,Barcelona,Sant Martí,67,28175
0801910068,Barcelona,Sant Martí,68,23339
0801910069,Barcelona,Sant Martí,69,24503
0801910070,Barcelona,Sant Martí,70,20562
0801910071,Barcelona,Sant Martí,71,22597
0801910072,Barcelona,Sant Martí,72,20247
0801910073,Barcelona,Sant Martí,73,18455
0801910074,Barcelona,Sant Martí,74,18434
0801910075,Barcelona,Sant Martí,75,19207
0801910076,Barcelona,Sant Martí,76,22033
0801910077,Barcelona,Sant Martí,77,25237
0801910078,Barcelona,Sant Martí,78,27183
0801910079,Barcelona,Sant Martí,79,22625
0801910080,Barcelona,Sant Martí,80,.
0801910081,Barcelona,Sant Martí,81,14476
0801910082,Barcelona,Sant Martí,82,9096
0801910083,Barcelona,Sant Martí,83,8550
0801910084,Barcelona,Sant Martí,84,11413
0801910085,Barcelona,Sant Martí,85,9967
0801910086,Barcelona,Sant Martí,86,11656
0801910087,Barcelona,Sant Martí,87,11679
0801910088,Barcelona,Sant Martí,88,16376
0801910089,Barcelona,Sant Martí,89,12505
0801910090,Barcelona,Sant Martí,90,13293
0801910091,Barcelona,Sant Martí,91,14942
0801910092,Barcelona,Sant Martí,92,18794
0801910093,Barcelona,Sant Martí,93,18390
0801910094,Barcelona,Sant Martí,94,19809
0801910095,Barcelona,Sant Martí,95,17072
0801910096,Barcelona,Sant Martí,96,21833
0801910097,Barcelona,Sant Martí,97,21870
0801910098,Barcelona,Sant Martí,98,20994
0801910099,Barcelona,Sant Martí,99,14111
0801910100,Barcelona,Sant Martí,100,16163
0801910101,Barcelona,Sant Martí,101,15958
0801910102,Barcelona,Sant Martí,102,15674
0801910103,Barcelona,Sant Martí,103,17286
0801910104,Barcelona,Sant Martí,104,20156
0801910105,Barcelona,Sant Martí,105,19067
0801910106,Barcelona,Sant Martí,106,17033
0801910107,Barcelona,Sant Martí,107,20943
0801910108,Barcelona,Sant Martí,108,17005
0801910109,Barcelona,Sant Martí,109,16115
0801910110,Barcelona,Sant Martí,110,16524
0801910111,Barcelona,Sant Martí,111,17074
0801910112,Barcelona,Sant Martí,112,20618
0801910113,Barcelona,Sant Martí,113,17007
0801910114,Barcelona,Sant Martí,114,14026
0801910115,Barcelona,Sant Martí,115,15696
0801910116,Barcelona,Sant Martí,116,15174
0801910117,Barcelona,Sant Martí,117,16903
0801910118,Barcelona,Sant Martí,118,19675
0801910119,Barcelona,Sant Martí,119,14461
0801910120,Barcelona,Sant Martí,120,15745
0801910121,Barcelona,Sant Martí,121,15343
0801910122,Barcelona,Sant Martí,122,19697
0801910123,Barcelona,Sant Martí,123,16459
0801910124,Barcelona,Sant Martí,124,18496
0801910125,Barcelona,Sant Martí,125,16152
0801910126,Barcelona,Sant Martí,126,17699
0801910127,Barcelona,Sant Martí,127,19004
0801910128,Barcelona,Sant Martí,128,18664
0801910129,Barcelona,Sant Martí,129,18681
0801910130,Barcelona,Sant Martí,130,17064
0801910131,Barcelona,Sant Martí,131,20389
0801910132,Barcelona,Sant Martí,132,15035
0801910133,Barcelona,Sant Martí,133,15302
0801910134,Barcelona,Sant Martí,134,14824
0801910135,Barcelona,Sant Martí,135,15868
0801910136,Barcelona,Sant Martí,136,14916
0801910137,Barcelona,Sant Martí,137,13775
0801910138,Barcelona,Sant Martí,138,12409
0801910139,Barcelona,Sant Martí,139,13777
0801910140,Barcelona,Sant Martí,140,13838
0801910141,Barcelona,Sant Martí,141,14043
0801910142,Barcelona,Sant Martí,142,12802
0801910143,Barcelona,Sant Martí,143,14584
0801910234,Barcelona,Sant Martí,234,18762
0801910235,Barcelona,Sant Martí,235,16341
0801910236,Barcelona,Sant Martí,236,16763
0801910237,Barcelona,Sant Martí,237,15123
0802001001,Begues,1,1,23733
0802001002,Begues,1,2,24822
0802001003,Begues,1,3,20980
0802101001,Bellprat,1,1,.
0802201001,Berga,1,1,15038
0802201002,Berga,1,2,16057
0802201003,Berga,1,3,22474
0802201004,Berga,1,4,16266
0802201005,Berga,1,5,18179
0802201006,Berga,1,6,16180
0802202001,Berga,2,1,11978
0802202002,Berga,2,2,13459
0802202003,Berga,2,3,16471
0802202004,Berga,2,4,16957
0802202005,Berga,2,5,12082
0802203001,Berga,3,1,19842
0802204001,Berga,4,1,18133
0802301001,Bigues i Riells del Fai,1,1,20633
0802301002,Bigues i Riells del Fai,1,2,15930
0802301003,Bigues i Riells del Fai,1,3,16880
0802301004,Bigues i Riells del Fai,1,4,19357
0802301005,Bigues i Riells del Fai,1,5,18005
0802401001,Borredà,1,1,16533
0802501001,El Bruc,1,1,18536
0802601001,El Brull,1,1,24513
0802701001,Les Cabanyes,1,1,19241
0802801001,Cabrera d'Anoia,1,1,14793
0802901001,Cabrera de Mar,1,1,23312
0802901002,Cabrera de Mar,1,2,25173
0803001001,Cabrils,1,1,23488
0803001002,Cabrils,1,2,25632
0803001003,Cabrils,1,3,24817
0803101001,Calaf,1,1,14757
0803101002,Calaf,1,2,14407
0803201001,Caldes d'Estrac,1,1,20364
0803301001,Caldes de Montbui,1,1,18842
0803301002,Caldes de Montbui,1,2,15719
0803301003,Caldes de Montbui,1,3,18356
0803302001,Caldes de Montbui,2,1,18256
0803303001,Caldes de Montbui,3,1,16506
0803303002,Caldes de Montbui,3,2,15501
0803303003,Caldes de Montbui,3,3,18143
0803303004,Caldes de Montbui,3,4,18427
0803303005,Caldes de Montbui,3,5,20354
0803303006,Caldes de Montbui,3,6,19317
0803401001,Calders,1,1,19113
0803501001,Calella,1,1,14401
0803501002,Calella,1,2,17577
0803501003,Calella,1,3,12953
0803502001,Calella,2,1,15289
0803502002,Calella,2,2,14330
0803503001,Calella,3,1,14589
0803503002,Calella,3,2,14112
0803503003,Calella,3,3,16037
0803503004,Calella,3,4,15085
0803601001,Calonge de Segarra,1,1,17467
0803701001,Calldetenes,1,1,18363
0803801001,Callús,1,1,16322
0803901001,Campins,1,1,19484
0804001001,Canet de Mar,1,1,16581
0804001002,Canet de Mar,1,2,16929
0804001003,Canet de Mar,1,3,14905
0804001004,Canet de Mar,1,4,19930
0804001005,Canet de Mar,1,5,16018
0804001006,Canet de Mar,1,6,16349
0804001007,Canet de Mar,1,7,19441
0804001008,Canet de Mar,1,8,15930
0804001009,Canet de Mar,1,9,14671
0804001010,Canet de Mar,1,10,15410
0804101001,Canovelles,1,1,15408
0804101002,Canovelles,1,2,10773
0804101003,Canovelles,1,3,9605
0804101004,Canovelles,1,4,11667
0804101005,Canovelles,1,5,10160
0804101006,Canovelles,1,6,13692
0804101007,Canovelles,1,7,18358
0804101008,Canovelles,1,8,21275
0804201001,Cànoves i Samalús,1,1,18304
0804201002,Cànoves i Samalús,1,2,17286
0804301001,Canyelles,1,1,18479
0804301002,Canyelles,1,2,18283
0804301003,Canyelles,1,3,15482
0804401001,Capellades,1,1,15038
0804402001,Capellades,2,1,17468
0804402002,Capellades,2,2,16988
0804501001,Capolat,1,1,19672
0804601001,Cardedeu,1,1,18102
0804601002,Cardedeu,1,2,23403
0804601003,Cardedeu,1,3,18281
0804602001,Cardedeu,2,1,17114
0804602002,Cardedeu,2,2,17619
0804602003,Cardedeu,2,3,23881
0804602004,Cardedeu,2,4,19729
0804602005,Cardedeu,2,5,17756
0804603001,Cardedeu,3,1,17840
0804603002,Cardedeu,3,2,15622
0804701001,Cardona,1,1,17839
0804701002,Cardona,1,2,17368
0804701003,Cardona,1,3,17411
0804702001,Cardona,2,1,16289
0804801001,Carme,1,1,15628
0804901001,Casserres,1,1,16647
0805001001,Castellar del Riu,1,1,17916
0805101001,Castellar del Vallès,1,1,17977
0805101002,Castellar del Vallès,1,2,18772
0805101003,Castellar del Vallès,1,3,17422
0805101004,Castellar del Vallès,1,4,16784
0805101005,Castellar del Vallès,1,5,19476
0805101006,Castellar del Vallès,1,6,19457
0805101007,Castellar del Vallès,1,7,16116
0805101008,Castellar del Vallès,1,8,16874
0805101009,Castellar del Vallès,1,9,20660
0805101010,Castellar del Vallès,1,10,19072
0805101011,Castellar del Vallès,1,11,18525
0805101012,Castellar del Vallès,1,12,17665
0805101013,Castellar del Vallès,1,13,17433
0805101014,Castellar del Vallès,1,14,21769
0805201001,Castellar de n'Hug,1,1,18502
0805301001,Castellbell i el Vilar,1,1,15700
0805301002,Castellbell i el Vilar,1,2,15518
0805401001,Castellbisbal,1,1,17681
0805401002,Castellbisbal,1,2,16333
0805401003,Castellbisbal,1,3,17471
0805401004,Castellbisbal,1,4,19338
0805401005,Castellbisbal,1,5,18648
0805401006,Castellbisbal,1,6,16683
0805501001,Castellcir,1,1,18396
0805601001,Castelldefels,1,1,13074
0805601002,Castelldefels,1,2,14254
0805601003,Castelldefels,1,3,22390
0805601004,Castelldefels,1,4,14668
0805601005,Castelldefels,1,5,13996
0805601006,Castelldefels,1,6,16173
0805601007,Castelldefels,1,7,20460
0805601008,Castelldefels,1,8,23577
0805601009,Castelldefels,1,9,15020
0805601010,Castelldefels,1,10,18668
0805602001,Castelldefels,2,1,15458
0805602002,Castelldefels,2,2,17144
0805602003,Castelldefels,2,3,15801
0805602004,Castelldefels,2,4,18334
0805602005,Castelldefels,2,5,22003
0805602006,Castelldefels,2,6,16051
0805602007,Castelldefels,2,7,14956
0805603001,Castelldefels,3,1,13775
0805603002,Castelldefels,3,2,23890
0805603003,Castelldefels,3,3,15637
0805603004,Castelldefels,3,4,21654
0805603005,Castelldefels,3,5,25161
0805603006,Castelldefels,3,6,26928
0805604001,Castelldefels,4,1,25507
0805604002,Castelldefels,4,2,22348
0805604003,Castelldefels,4,3,22771
0805604004,Castelldefels,4,4,21073
0805604005,Castelldefels,4,5,24669
0805604006,Castelldefels,4,6,19565
0805604007,Castelldefels,4,7,21389
0805605001,Castelldefels,5,1,19687
0805605002,Castelldefels,5,2,26268
0805605003,Castelldefels,5,3,22065
0805605004,Castelldefels,5,4,25083
0805605005,Castelldefels,5,5,23838
0805605006,Castelldefels,5,6,23246
0805605007,Castelldefels,5,7,21208
0805701001,Castell de l'Areny,1,1,19672
0805801001,Castellet i la Gornal,1,1,15753
0805901001,Castellfollit del Boix,1,1,19132
0806001001,Castellfollit de Riubregós,1,1,17606
0806101001,Castellgalí,1,1,17022
0806201001,Castellnou de Bages,1,1,18505
0806301001,Castellolí,1,1,20082
0806401001,Castellterçol,1,1,16541
0806401002,Castellterçol,1,2,18052
0806501001,Castellví de la Marca,1,1,16370
0806601001,Castellví de Rosanes,1,1,19728
0806701001,Centelles,1,1,17939
0806701002,Centelles,1,2,17181
0806701003,Centelles,1,3,17333
0806701004,Centelles,1,4,16958
0806801001,Cervelló,1,1,18306
0806801002,Cervelló,1,2,18687
0806801003,Cervelló,1,3,19811
0806801004,Cervelló,1,4,20212
0806801005,Cervelló,1,5,21168
0806901001,Collbató,1,1,22185
0806901003,Collbató,1,3,20580
0806901004,Collbató,1,4,23608
0807001001,Collsuspina,1,1,15399
0807101001,Copons,1,1,17108
0807201001,Corbera de Llobregat,1,1,18971
0807201002,Corbera de Llobregat,1,2,17612
0807201003,Corbera de Llobregat,1,3,14785
0807201004,Corbera de Llobregat,1,4,22564
0807201005,Corbera de Llobregat,1,5,18614
0807201006,Corbera de Llobregat,1,6,18774
0807201007,Corbera de Llobregat,1,7,23266
0807201008,Corbera de Llobregat,1,8,21220
0807201009,Corbera de Llobregat,1,9,18880
0807201010,Corbera de Llobregat,1,10,18778
0807201011,Corbera de Llobregat,1,11,18714
0807301001,Cornellà de Llobregat,1,1,17172
0807301002,Cornellà de Llobregat,1,2,18252
0807301003,Cornellà de Llobregat,1,3,14546
0807301004,Cornellà de Llobregat,1,4,17754
0807301005,Cornellà de Llobregat,1,5,16941
0807301006,Cornellà de Llobregat,1,6,18356
0807301007,Cornellà de Llobregat,1,7,20404
0807301008,Cornellà de Llobregat,1,8,17960
0807301009,Cornellà de Llobregat,1,9,16466
0807301010,Cornellà de Llobregat,1,10,17724
0807301011,Cornellà de Llobregat,1,11,15183
0807301012,Cornellà de Llobregat,1,12,14312
0807301013,Cornellà de Llobregat,1,13,17755
0807301014,Cornellà de Llobregat,1,14,19550
0807302001,Cornellà de Llobregat,2,1,19437
0807302002,Cornellà de Llobregat,2,2,16694
0807302003,Cornellà de Llobregat,2,3,20144
0807302004,Cornellà de Llobregat,2,4,19329
0807303001,Cornellà de Llobregat,3,1,17938
0807303002,Cornellà de Llobregat,3,2,14155
0807303003,Cornellà de Llobregat,3,3,15112
0807303004,Cornellà de Llobregat,3,4,21631
0807303005,Cornellà de Llobregat,3,5,18973
0807303006,Cornellà de Llobregat,3,6,17390
0807303007,Cornellà de Llobregat,3,7,16062
0807303008,Cornellà de Llobregat,3,8,17367
0807303009,Cornellà de Llobregat,3,9,13843
0807303010,Cornellà de Llobregat,3,10,19440
0807304001,Cornellà de Llobregat,4,1,17152
0807304002,Cornellà de Llobregat,4,2,15152
0807304003,Cornellà de Llobregat,4,3,17796
0807304004,Cornellà de Llobregat,4,4,13668
0807304005,Cornellà de Llobregat,4,5,15908
0807304006,Cornellà de Llobregat,4,6,14309
0807304007,Cornellà de Llobregat,4,7,14377
0807304008,Cornellà de Llobregat,4,8,15512
0807304009,Cornellà de Llobregat,4,9,14315
0807304010,Cornellà de Llobregat,4,10,15021
0807304011,Cornellà de Llobregat,4,11,15497
0807304012,Cornellà de Llobregat,4,12,15305
0807304013,Cornellà de Llobregat,4,13,15906
0807304014,Cornellà de Llobregat,4,14,16042
0807304015,Cornellà de Llobregat,4,15,15842
0807304016,Cornellà de Llobregat,4,16,15210
0807304017,Cornellà de Llobregat,4,17,14366
0807304018,Cornellà de Llobregat,4,18,14559
0807304019,Cornellà de Llobregat,4,19,14805
0807305001,Cornellà de Llobregat,5,1,11838
0807305002,Cornellà de Llobregat,5,2,10499
0807305003,Cornellà de Llobregat,5,3,11460
0807305004,,,,
0807305005,Cornellà de Llobregat,5,5,11515
0807305006,Cornellà de Llobregat,5,6,13065
0807305007,Cornellà de Llobregat,5,7,10392
0807305008,Cornellà de Llobregat,5,8,10003
0807305009,Cornellà de Llobregat,5,9,15944
0807305010,Cornellà de Llobregat,5,10,12999
0807306001,Cornellà de Llobregat,6,1,10877
0807306002,,,,
0807306003,,,,
0807306004,Cornellà de Llobregat,6,4,12738
0807306005,Cornellà de Llobregat,6,5,11536
0807306006,,,,
0807306007,Cornellà de Llobregat,6,7,13389
0807306008,Cornellà de Llobregat,6,8,11631
0807306009,Cornellà de Llobregat,6,9,14561
0807306010,Cornellà de Llobregat,6,10,11093
0807306011,,,,
0807306012,,,,
0807306013,Cornellà de Llobregat,6,13,11553
0807306014,Cornellà de Llobregat,6,14,11845
0807306015,Cornellà de Llobregat,6,15,17388
0807306016,,,,
0807401001,Cubelles,1,1,15332
0807401002,Cubelles,1,2,16069
0807401003,Cubelles,1,3,17871
0807401004,Cubelles,1,4,16430
0807401005,Cubelles,1,5,21696
0807401006,Cubelles,1,6,15451
0807401007,Cubelles,1,7,16926
0807401008,Cubelles,1,8,17769
0807401009,Cubelles,1,9,16049
0807401010,Cubelles,1,10,17432
0807501001,Dosrius,1,1,18972
0807501002,Dosrius,1,2,16670
0807501003,Dosrius,1,3,17924
0807601001,Esparreguera,1,1,15773
0807601002,Esparreguera,1,2,16834
0807601003,Esparreguera,1,3,16812
0807601004,Esparreguera,1,4,17654
0807601005,Esparreguera,1,5,17000
0807601006,Esparreguera,1,6,20591
0807602001,Esparreguera,2,1,15218
0807602002,Esparreguera,2,2,17573
0807602003,Esparreguera,2,3,17764
0807602004,Esparreguera,2,4,19114
0807602005,Esparreguera,2,5,14822
0807701001,Esplugues de Llobregat,1,1,26095
0807701002,Esplugues de Llobregat,1,2,17486
0807701003,Esplugues de Llobregat,1,3,20389
0807701004,Esplugues de Llobregat,1,4,17150
0807701005,Esplugues de Llobregat,1,5,18931
0807702001,Esplugues de Llobregat,2,1,20479
0807702002,Esplugues de Llobregat,2,2,15617
0807702003,Esplugues de Llobregat,2,3,15926
0807702004,Esplugues de Llobregat,2,4,17648
0807702005,Esplugues de Llobregat,2,5,17567
0807702006,Esplugues de Llobregat,2,6,21776
0807703001,Esplugues de Llobregat,3,1,19975
0807703002,Esplugues de Llobregat,3,2,16924
0807704001,Esplugues de Llobregat,4,1,35387
0807705001,Esplugues de Llobregat,5,1,38797
0807706001,,,,
0807707001,Esplugues de Llobregat,7,1,34813
0807708001,Esplugues de Llobregat,8,1,18137
0807708002,Esplugues de Llobregat,8,2,17918
0807709001,Esplugues de Llobregat,9,1,17326
0807709002,Esplugues de Llobregat,9,2,19039
0807710001,Esplugues de Llobregat,10,1,15620
0807710002,Esplugues de Llobregat,10,2,16751
0807710003,Esplugues de Llobregat,10,3,14582
0807710004,Esplugues de Llobregat,10,4,11320
0807710005,Esplugues de Llobregat,10,5,11398
0807710006,Esplugues de Llobregat,10,6,13391
0807710007,Esplugues de Llobregat,10,7,14966
0807710008,Esplugues de Llobregat,10,8,11917
0807801001,L'Espunyola,1,1,17149
0807901001,L'Estany,1,1,20255
0808001001,Fígols,1,1,19672
0808101001,Fogars de Montclús,1,1,17671
0808201001,Fogars de la Selva,1,1,15601
0808301001,Folgueroles,1,1,20055
0808401001,Fonollosa,1,1,18369
0808501001,Font-rubí,1,1,17202
0808601001,Les Franqueses del Vallès,1,1,19604
0808601002,Les Franqueses del Vallès,1,2,12174
0808601003,Les Franqueses del Vallès,1,3,11302
0808601004,Les Franqueses del Vallès,1,4,16243
0808601005,Les Franqueses del Vallès,1,5,15461
0808601006,Les Franqueses del Vallès,1,6,17975
0808601007,Les Franqueses del Vallès,1,7,17728
0808601008,Les Franqueses del Vallès,1,8,13690
0808601009,Les Franqueses del Vallès,1,9,16894
0808601010,Les Franqueses del Vallès,1,10,15855
0808602001,Les Franqueses del Vallès,2,1,20939
0808701001,Gallifa,1,1,21007
0808801001,La Garriga,1,1,18741
0808801002,La Garriga,1,2,17780
0808801003,La Garriga,1,3,17916
0808801004,La Garriga,1,4,20837
0808802001,La Garriga,2,1,27556
0808802002,La Garriga,2,2,17593
0808802003,La Garriga,2,3,18365
0808802004,La Garriga,2,4,21097
0808802005,La Garriga,2,5,21766
0808802006,La Garriga,2,6,18322
0808901001,Gavà,1,1,16884
0808901002,Gavà,1,2,19281
0808901003,Gavà,1,3,17616
0808901004,Gavà,1,4,16909
0808901005,Gavà,1,5,14976
0808901006,Gavà,1,6,16932
0808901007,Gavà,1,7,23652
0808901008,Gavà,1,8,31028
0808902001,Gavà,2,1,18366
0808902002,Gavà,2,2,21842
0808902003,Gavà,2,3,17820
0808902004,Gavà,2,4,15265
0808902005,Gavà,2,5,15931
0808902006,Gavà,2,6,14348
0808902007,Gavà,2,7,15694
0808902008,Gavà,2,8,16550
0808902009,Gavà,2,9,17516
0808902010,Gavà,2,10,14470
0808903001,Gavà,3,1,16562
0808903002,Gavà,3,2,16476
0808903003,Gavà,3,3,17129
0808903004,Gavà,3,4,15731
0808903005,Gavà,3,5,13691
0808903006,Gavà,3,6,17195
0808903007,Gavà,3,7,18775
0808903008,Gavà,3,8,16977
0808903009,Gavà,3,9,20522
0808904001,Gavà,4,1,16821
0808904002,Gavà,4,2,15241
0809001001,Gaià,1,1,18263
0809101001,Gelida,1,1,18158
0809101002,Gelida,1,2,16147
0809102001,Gelida,2,1,17695
0809201001,Gironella,1,1,16932
0809202001,,,,
0809202002,Gironella,2,2,15228
0809202003,Gironella,2,3,16140
0809301001,Gisclareny,1,1,19672
0809401001,La Granada,1,1,17385
0809501001,Granera,1,1,.
0809601001,Granollers,1,1,22045
0809601003,Granollers,1,3,18041
0809601004,Granollers,1,4,18006
0809601005,Granollers,1,5,20812
0809601006,Granollers,1,6,10775
0809601009,Granollers,1,9,11460
0809601010,Granollers,1,10,13943
0809601011,Granollers,1,11,14626
0809602001,Granollers,2,1,19168
0809602002,Granollers,2,2,22003
0809602003,Granollers,2,3,21381
0809602004,Granollers,2,4,14056
0809602005,Granollers,2,5,15704
0809602006,Granollers,2,6,18273
0809602007,Granollers,2,7,15672
0809603001,Granollers,3,1,20487
0809603002,Granollers,3,2,14924
0809603003,Granollers,3,3,15592
0809603004,Granollers,3,4,18474
0809603005,Granollers,3,5,17951
0809603006,Granollers,3,6,20507
0809603007,Granollers,3,7,14257
0809603008,Granollers,3,8,12801
0809603009,Granollers,3,9,21573
0809603010,Granollers,3,10,17317
0809604001,Granollers,4,1,20735
0809604002,Granollers,4,2,15810
0809604003,Granollers,4,3,13707
0809604004,Granollers,4,4,13462
0809604006,Granollers,4,6,15514
0809604007,Granollers,4,7,18458
0809604008,Granollers,4,8,14225
0809604009,Granollers,4,9,13597
0809604010,Granollers,4,10,19360
0809604011,Granollers,4,11,20755
0809701001,Gualba,1,1,18558
0809801001,Sant Salvador de Guardiola,1,1,18583
0809801002,Sant Salvador de Guardiola,1,2,15018
0809901001,Guardiola de Berguedà,1,1,16672
0810001001,Gurb,1,1,20212
0810001002,Gurb,1,2,25759
0810101001,L'Hospitalet de Llobregat,1,1,18640
0810101002,L'Hospitalet de Llobregat,1,2,15862
0810101003,L'Hospitalet de Llobregat,1,3,16702
0810101004,L'Hospitalet de Llobregat,1,4,19155
0810101005,L'Hospitalet de Llobregat,1,5,17379
0810101006,L'Hospitalet de Llobregat,1,6,16705
0810101007,L'Hospitalet de Llobregat,1,7,16134
0810101008,L'Hospitalet de Llobregat,1,8,18820
0810101009,L'Hospitalet de Llobregat,1,9,19045
0810101010,L'Hospitalet de Llobregat,1,10,16891
0810101011,L'Hospitalet de Llobregat,1,11,18974
0810101012,L'Hospitalet de Llobregat,1,12,18428
0810101013,L'Hospitalet de Llobregat,1,13,20092
0810101014,L'Hospitalet de Llobregat,1,14,15125
0810101015,L'Hospitalet de Llobregat,1,15,14936
0810101016,L'Hospitalet de Llobregat,1,16,15750
0810101017,L'Hospitalet de Llobregat,1,17,15477
0810101018,L'Hospitalet de Llobregat,1,18,14660
0810101019,L'Hospitalet de Llobregat,1,19,16751
0810101020,L'Hospitalet de Llobregat,1,20,16910
0810101021,L'Hospitalet de Llobregat,1,21,12123
0810101022,L'Hospitalet de Llobregat,1,22,14359
0810101023,L'Hospitalet de Llobregat,1,23,16392
0810101024,L'Hospitalet de Llobregat,1,24,18070
0810101025,L'Hospitalet de Llobregat,1,25,14577
0810101026,L'Hospitalet de Llobregat,1,26,13832
0810101027,L'Hospitalet de Llobregat,1,27,14536
0810101028,L'Hospitalet de Llobregat,1,28,15195
0810101029,L'Hospitalet de Llobregat,1,29,14697
0810101030,L'Hospitalet de Llobregat,1,30,16825
0810101031,L'Hospitalet de Llobregat,1,31,14182
0810101032,L'Hospitalet de Llobregat,1,32,15315
0810101033,L'Hospitalet de Llobregat,1,33,18306
0810101034,L'Hospitalet de Llobregat,1,34,18388
0810101035,L'Hospitalet de Llobregat,1,35,16950
0810101036,L'Hospitalet de Llobregat,1,36,15379
0810101037,L'Hospitalet de Llobregat,1,37,15927
0810101038,L'Hospitalet de Llobregat,1,38,16923
0810101039,L'Hospitalet de Llobregat,1,39,14179
0810101040,L'Hospitalet de Llobregat,1,40,11411
0810101041,L'Hospitalet de Llobregat,1,41,21372
0810101042,,,,19737
0810101043,,,,21050
0810102001,L'Hospitalet de Llobregat,2,1,16787
0810102002,L'Hospitalet de Llobregat,2,2,10827
0810102004,L'Hospitalet de Llobregat,2,4,12179
0810102005,L'Hospitalet de Llobregat,2,5,14707
0810102007,L'Hospitalet de Llobregat,2,7,13615
0810102008,L'Hospitalet de Llobregat,2,8,18025
0810102009,L'Hospitalet de Llobregat,2,9,14168
0810102010,L'Hospitalet de Llobregat,2,10,14424
0810102011,L'Hospitalet de Llobregat,2,11,10305
0810102012,L'Hospitalet de Llobregat,2,12,10940
0810102013,L'Hospitalet de Llobregat,2,13,10955
0810102014,L'Hospitalet de Llobregat,2,14,11539
0810102016,L'Hospitalet de Llobregat,2,16,12040
0810102017,L'Hospitalet de Llobregat,2,17,11193
0810102020,L'Hospitalet de Llobregat,2,20,11649
0810102021,L'Hospitalet de Llobregat,2,21,11425
0810102023,L'Hospitalet de Llobregat,2,23,10888
0810102024,L'Hospitalet de Llobregat,2,24,11468
0810102026,L'Hospitalet de Llobregat,2,26,12753
0810102028,L'Hospitalet de Llobregat,2,28,10381
0810102029,L'Hospitalet de Llobregat,2,29,10245
0810102031,L'Hospitalet de Llobregat,2,31,10563
0810102032,L'Hospitalet de Llobregat,2,32,10999
0810102033,L'Hospitalet de Llobregat,2,33,11208
0810102034,L'Hospitalet de Llobregat,2,34,12225
0810102036,L'Hospitalet de Llobregat,2,36,11116
0810102037,L'Hospitalet de Llobregat,2,37,10824
0810102038,L'Hospitalet de Llobregat,2,38,12030
0810102039,L'Hospitalet de Llobregat,2,39,12648
0810102040,L'Hospitalet de Llobregat,2,40,10372
0810102042,L'Hospitalet de Llobregat,2,42,10536
0810102043,L'Hospitalet de Llobregat,2,43,12557
0810102045,L'Hospitalet de Llobregat,2,45,10631
0810102046,L'Hospitalet de Llobregat,2,46,10368
0810102047,L'Hospitalet de Llobregat,2,47,10639
0810102048,L'Hospitalet de Llobregat,2,48,12007
0810102049,L'Hospitalet de Llobregat,2,49,13297
0810103001,L'Hospitalet de Llobregat,3,1,14848
0810103002,L'Hospitalet de Llobregat,3,2,13492
0810103003,L'Hospitalet de Llobregat,3,3,13735
0810103004,L'Hospitalet de Llobregat,3,4,17467
0810103005,L'Hospitalet de Llobregat,3,5,16240
0810103006,L'Hospitalet de Llobregat,3,6,14443
0810103007,L'Hospitalet de Llobregat,3,7,17982
0810103008,L'Hospitalet de Llobregat,3,8,17740
0810103009,L'Hospitalet de Llobregat,3,9,16669
0810103010,L'Hospitalet de Llobregat,3,10,14083
0810103011,L'Hospitalet de Llobregat,3,11,13331
0810103012,L'Hospitalet de Llobregat,3,12,15469
0810103013,L'Hospitalet de Llobregat,3,13,15712
0810103014,L'Hospitalet de Llobregat,3,14,15544
0810103015,L'Hospitalet de Llobregat,3,15,16038
0810103016,L'Hospitalet de Llobregat,3,16,20855
0810103017,L'Hospitalet de Llobregat,3,17,12001
0810103018,L'Hospitalet de Llobregat,3,18,18196
0810103019,L'Hospitalet de Llobregat,3,19,17535
0810103020,L'Hospitalet de Llobregat,3,20,19374
0810103021,L'Hospitalet de Llobregat,3,21,18179
0810103022,L'Hospitalet de Llobregat,3,22,13882
0810103023,L'Hospitalet de Llobregat,3,23,15799
0810103024,L'Hospitalet de Llobregat,3,24,13606
0810103025,L'Hospitalet de Llobregat,3,25,18143
0810103026,L'Hospitalet de Llobregat,3,26,20496
0810103027,L'Hospitalet de Llobregat,3,27,19678
0810103028,L'Hospitalet de Llobregat,3,28,18307
0810103029,L'Hospitalet de Llobregat,3,29,17672
0810104001,L'Hospitalet de Llobregat,4,1,12493
0810104002,L'Hospitalet de Llobregat,4,2,10794
0810104003,L'Hospitalet de Llobregat,4,3,12851
0810104004,L'Hospitalet de Llobregat,4,4,11199
0810104005,L'Hospitalet de Llobregat,4,5,11058
0810104006,L'Hospitalet de Llobregat,4,6,11150
0810104007,L'Hospitalet de Llobregat,4,7,10112
0810104009,L'Hospitalet de Llobregat,4,9,10932
0810104010,L'Hospitalet de Llobregat,4,10,13212
0810104011,L'Hospitalet de Llobregat,4,11,12423
0810104012,L'Hospitalet de Llobregat,4,12,12747
0810104014,L'Hospitalet de Llobregat,4,14,9799
0810104016,L'Hospitalet de Llobregat,4,16,9989
0810104018,L'Hospitalet de Llobregat,4,18,11691
0810104019,L'Hospitalet de Llobregat,4,19,9713
0810104020,L'Hospitalet de Llobregat,4,20,10849
0810104021,L'Hospitalet de Llobregat,4,21,11032
0810104022,L'Hospitalet de Llobregat,4,22,10325
0810104023,L'Hospitalet de Llobregat,4,23,10550
0810104025,L'Hospitalet de Llobregat,4,25,11349
0810104026,L'Hospitalet de Llobregat,4,26,9921
0810104027,L'Hospitalet de Llobregat,4,27,9315
0810104030,L'Hospitalet de Llobregat,4,30,9505
0810104031,L'Hospitalet de Llobregat,4,31,8874
0810104032,L'Hospitalet de Llobregat,4,32,11152
0810104033,L'Hospitalet de Llobregat,4,33,9317
0810104035,L'Hospitalet de Llobregat,4,35,8757
0810104036,L'Hospitalet de Llobregat,4,36,10162
0810104037,L'Hospitalet de Llobregat,4,37,10249
0810104040,L'Hospitalet de Llobregat,4,40,12174
0810104041,L'Hospitalet de Llobregat,4,41,13498
0810105001,L'Hospitalet de Llobregat,5,1,17047
0810105002,L'Hospitalet de Llobregat,5,2,12603
0810105003,L'Hospitalet de Llobregat,5,3,16122
0810105004,L'Hospitalet de Llobregat,5,4,14438
0810105005,L'Hospitalet de Llobregat,5,5,14850
0810105006,L'Hospitalet de Llobregat,5,6,15413
0810105007,L'Hospitalet de Llobregat,5,7,12471
0810105008,L'Hospitalet de Llobregat,5,8,11168
0810105010,L'Hospitalet de Llobregat,5,10,12176
0810105011,L'Hospitalet de Llobregat,5,11,11397
0810105013,L'Hospitalet de Llobregat,5,13,10142
0810105014,L'Hospitalet de Llobregat,5,14,10561
0810105017,L'Hospitalet de Llobregat,5,17,9909
0810105018,L'Hospitalet de Llobregat,5,18,11551
0810105020,L'Hospitalet de Llobregat,5,20,11588
0810105021,L'Hospitalet de Llobregat,5,21,16082
0810105023,L'Hospitalet de Llobregat,5,23,11376
0810105024,L'Hospitalet de Llobregat,5,24,9601
0810105025,L'Hospitalet de Llobregat,5,25,10464
0810105026,L'Hospitalet de Llobregat,5,26,10585
0810105028,L'Hospitalet de Llobregat,5,28,11829
0810105029,L'Hospitalet de Llobregat,5,29,10749
0810105030,L'Hospitalet de Llobregat,5,30,14101
0810105031,L'Hospitalet de Llobregat,5,31,10934
0810105032,L'Hospitalet de Llobregat,5,32,11716
0810105033,L'Hospitalet de Llobregat,5,33,10770
0810105034,L'Hospitalet de Llobregat,5,34,11407
0810105035,L'Hospitalet de Llobregat,5,35,15475
0810105037,L'Hospitalet de Llobregat,5,37,12858
0810105038,L'Hospitalet de Llobregat,5,38,11317
0810106001,L'Hospitalet de Llobregat,6,1,14193
0810106002,L'Hospitalet de Llobregat,6,2,12135
0810106005,L'Hospitalet de Llobregat,6,5,15863
0810106006,L'Hospitalet de Llobregat,6,6,12735
0810106007,L'Hospitalet de Llobregat,6,7,12963
0810106008,L'Hospitalet de Llobregat,6,8,14506
0810106009,L'Hospitalet de Llobregat,6,9,14855
0810106010,L'Hospitalet de Llobregat,6,10,14682
0810106011,L'Hospitalet de Llobregat,6,11,13581
0810106012,L'Hospitalet de Llobregat,6,12,14444
0810106013,L'Hospitalet de Llobregat,6,13,14307
0810106014,L'Hospitalet de Llobregat,6,14,15318
0810106015,L'Hospitalet de Llobregat,6,15,15062
0810106016,L'Hospitalet de Llobregat,6,16,13118
0810106017,L'Hospitalet de Llobregat,6,17,14346
0810106018,L'Hospitalet de Llobregat,6,18,18744
0810106019,L'Hospitalet de Llobregat,6,19,14470
0810106021,L'Hospitalet de Llobregat,6,21,15538
0810106022,L'Hospitalet de Llobregat,6,22,15317
0810106023,L'Hospitalet de Llobregat,6,23,14974
0810106024,L'Hospitalet de Llobregat,6,24,14799
0810106025,L'Hospitalet de Llobregat,6,25,15843
0810106026,L'Hospitalet de Llobregat,6,26,14496
0810106027,L'Hospitalet de Llobregat,6,27,16387
0810106030,L'Hospitalet de Llobregat,6,30,14738
0810106031,L'Hospitalet de Llobregat,6,31,14984
0810106032,L'Hospitalet de Llobregat,6,32,13344
0810201001,Igualada,1,1,13010
0810202001,Igualada,2,1,18460
0810202002,Igualada,2,2,16318
0810202003,Igualada,2,3,18022
0810203001,Igualada,3,1,13807
0810203002,Igualada,3,2,19846
0810203003,Igualada,3,3,16685
0810203004,Igualada,3,4,17566
0810203005,Igualada,3,5,12786
0810203006,Igualada,3,6,18846
0810203007,Igualada,3,7,18600
0810203008,Igualada,3,8,17198
0810203009,Igualada,3,9,19332
0810203010,Igualada,3,10,18887
0810204001,Igualada,4,1,14578
0810204002,Igualada,4,2,16668
0810204003,Igualada,4,3,15557
0810204004,Igualada,4,4,16312
0810204005,Igualada,4,5,16871
0810205001,Igualada,5,1,14593
0810205002,Igualada,5,2,14514
0810205003,Igualada,5,3,15915
0810205004,Igualada,5,4,16095
0810205005,Igualada,5,5,10146
0810205006,,,,
0810205007,Igualada,5,7,16332
0810301001,Jorba,1,1,18572
0810401001,La Llacuna,1,1,17132
0810501001,La Llagosta,1,1,14930
0810501002,La Llagosta,1,2,15001
0810501003,La Llagosta,1,3,13371
0810501004,La Llagosta,1,4,14427
0810501005,La Llagosta,1,5,13327
0810501006,La Llagosta,1,6,12877
0810501007,La Llagosta,1,7,13223
0810501008,La Llagosta,1,8,17416
0810501009,La Llagosta,1,9,15117
0810601001,Llinars del Vallès,1,1,15453
0810601002,Llinars del Vallès,1,2,16232
0810602001,Llinars del Vallès,2,1,19505
0810602002,Llinars del Vallès,2,2,19102
0810602003,Llinars del Vallès,2,3,19373
0810602004,Llinars del Vallès,2,4,18460
0810701001,Lliçà d'Amunt,1,1,18623
0810701002,Lliçà d'Amunt,1,2,18750
0810701003,Lliçà d'Amunt,1,3,18291
0810701004,Lliçà d'Amunt,1,4,16806
0810701005,Lliçà d'Amunt,1,5,17707
0810701006,Lliçà d'Amunt,1,6,17698
0810701007,Lliçà d'Amunt,1,7,19425
0810701008,Lliçà d'Amunt,1,8,17710
0810701009,Lliçà d'Amunt,1,9,16372
0810701010,Lliçà d'Amunt,1,10,18110
0810801001,Lliçà de Vall,1,1,19047
0810801002,Lliçà de Vall,1,2,20183
0810801003,Lliçà de Vall,1,3,20980
0810801004,Lliçà de Vall,1,4,16233
0810901001,Lluçà,1,1,16741
0811001001,Malgrat de Mar,1,1,16194
0811001002,Malgrat de Mar,1,2,16016
0811001003,Malgrat de Mar,1,3,14344
0811001004,Malgrat de Mar,1,4,13801
0811001005,Malgrat de Mar,1,5,14532
0811001006,Malgrat de Mar,1,6,15230
0811002001,Malgrat de Mar,2,1,17361
0811002002,Malgrat de Mar,2,2,15801
0811002003,Malgrat de Mar,2,3,15290
0811101001,Malla,1,1,24142
0811201001,Manlleu,1,1,16677
0811201002,Manlleu,1,2,14406
0811202001,Manlleu,2,1,16227
0811202002,Manlleu,2,2,14521
0811202003,Manlleu,2,3,13486
0811202004,Manlleu,2,4,12222
0811203001,Manlleu,3,1,14905
0811203002,Manlleu,3,2,13449
0811203003,Manlleu,3,3,11215
0811203004,Manlleu,3,4,15071
0811204001,Manlleu,4,1,14666
0811204002,Manlleu,4,2,16620
0811301001,Manresa,1,1,12638
0811301002,Manresa,1,2,12292
0811302001,Manresa,2,1,18275
0811302002,Manresa,2,2,20552
0811302003,Manresa,2,3,18104
0811302004,Manresa,2,4,18863
0811302005,Manresa,2,5,15138
0811302006,Manresa,2,6,13772
0811302007,Manresa,2,7,16887
0811302008,Manresa,2,8,14884
0811302009,Manresa,2,9,12940
0811302010,Manresa,2,10,19365
0811302011,Manresa,2,11,17989
0811302012,Manresa,2,12,20444
0811302013,Manresa,2,13,14047
0811302014,Manresa,2,14,14955
0811303001,Manresa,3,1,12646
0811303002,Manresa,3,2,12485
0811303004,Manresa,3,4,13062
0811303005,Manresa,3,5,14403
0811303006,Manresa,3,6,13369
0811304001,Manresa,4,1,14789
0811304003,Manresa,4,3,13845
0811304004,Manresa,4,4,17835
0811304005,Manresa,4,5,16530
0811304006,Manresa,4,6,15360
0811304007,Manresa,4,7,16837
0811304008,Manresa,4,8,15670
0811304009,Manresa,4,9,15307
0811304011,Manresa,4,11,14195
0811304012,Manresa,4,12,15814
0811304013,Manresa,4,13,15637
0811304014,Manresa,4,14,20892
0811304015,Manresa,4,15,17331
0811305001,Manresa,5,1,12183
0811305002,Manresa,5,2,11310
0811305003,Manresa,5,3,15711
0811305004,Manresa,5,4,13692
0811305005,Manresa,5,5,14243
0811305006,Manresa,5,6,13680
0811305007,Manresa,5,7,12184
0811305008,Manresa,5,8,18173
0811305010,Manresa,5,10,13833
0811305011,Manresa,5,11,14582
0811305012,Manresa,5,12,13628
0811305013,Manresa,5,13,16860
0811305014,Manresa,5,14,15470
0811305015,Manresa,5,15,14248
0811305017,Manresa,5,17,19258
0811305018,Manresa,5,18,15569
0811306001,Manresa,6,1,10613
0811306002,Manresa,6,2,17876
0811401001,Martorell,1,1,14516
0811401002,Martorell,1,2,12298
0811401003,Martorell,1,3,13894
0811402003,Martorell,2,3,13063
0811403002,Martorell,3,2,12976
0811403004,Martorell,3,4,13232
0811403005,Martorell,3,5,11584
0811403006,Martorell,3,6,13952
0811403007,Martorell,3,7,17230
0811403008,Martorell,3,8,19292
0811403010,Martorell,3,10,20468
0811404001,Martorell,4,1,19440
0811404002,Martorell,4,2,19641
0811404003,Martorell,4,3,17914
0811404004,Martorell,4,4,17497
0811501001,Martorelles,1,1,16206
0811501002,Martorelles,1,2,20880
0811501003,Martorelles,1,3,16098
0811601001,Les Masies de Roda,1,1,17591
0811701001,Les Masies de Voltregà,1,1,17883
0811702001,Les Masies de Voltregà,2,1,17234
0811801001,El Masnou,1,1,24205
0811801002,El Masnou,1,2,19310
0811801003,El Masnou,1,3,20035
0811801004,El Masnou,1,4,22314
0811801005,El Masnou,1,5,18711
0811801006,El Masnou,1,6,16960
0811801007,El Masnou,1,7,18070
0811801008,El Masnou,1,8,16167
0811801009,El Masnou,1,9,21098
0811801010,El Masnou,1,10,23363
0811802001,El Masnou,2,1,22702
0811802002,El Masnou,2,2,23932
0811802003,El Masnou,2,3,18649
0811802004,El Masnou,2,4,19727
0811901001,Masquefa,1,1,16003
0811901002,Masquefa,1,2,17395
0811901003,Masquefa,1,3,15032
0811901004,Masquefa,1,4,17845
0811901005,Masquefa,1,5,16749
0811901006,Masquefa,1,6,16038
0812001001,Matadepera,1,1,30724
0812001002,Matadepera,1,2,25729
0812001003,Matadepera,1,3,28220
0812001004,Matadepera,1,4,29718
0812101001,Mataró,1,1,21473
0812101002,Mataró,1,2,21698
0812101003,Mataró,1,3,21804
0812101004,Mataró,1,4,23344
0812101005,Mataró,1,5,20565
0812101006,Mataró,1,6,20874
0812101007,Mataró,1,7,19796
0812101009,Mataró,1,9,20594
0812102001,Mataró,2,1,20368
0812102002,Mataró,2,2,16814
0812102003,Mataró,2,3,15619
0812102004,Mataró,2,4,9584
0812102005,Mataró,2,5,17280
0812102007,Mataró,2,7,18038
0812102008,Mataró,2,8,18377
0812102009,Mataró,2,9,20036
0812102010,Mataró,2,10,17378
0812102011,Mataró,2,11,18689
0812102012,Mataró,2,12,17168
0812103001,Mataró,3,1,10933
0812103002,Mataró,3,2,8658
0812103003,Mataró,3,3,10823
0812103004,Mataró,3,4,9904
0812103005,Mataró,3,5,10117
0812103006,Mataró,3,6,16971
0812103007,Mataró,3,7,13139
0812103008,Mataró,3,8,13372
0812103009,Mataró,3,9,14674
0812103010,Mataró,3,10,19906
0812103011,Mataró,3,11,15034
0812103012,Mataró,3,12,22438
0812103013,Mataró,3,13,17068
0812103014,Mataró,3,14,17593
0812104001,Mataró,4,1,14442
0812104002,Mataró,4,2,13393
0812104003,Mataró,4,3,12361
0812104004,Mataró,4,4,16448
0812104005,Mataró,4,5,15604
0812104006,Mataró,4,6,18996
0812104007,Mataró,4,7,13696
0812104008,Mataró,4,8,19620
0812104009,Mataró,4,9,15255
0812105001,Mataró,5,1,15763
0812105002,Mataró,5,2,12622
0812105003,Mataró,5,3,11958
0812105004,Mataró,5,4,14237
0812105005,Mataró,5,5,11807
0812105006,Mataró,5,6,11273
0812105007,Mataró,5,7,12526
0812105008,Mataró,5,8,11417
0812105009,Mataró,5,9,11136
0812105010,Mataró,5,10,8945
0812105011,Mataró,5,11,10171
0812105012,Mataró,5,12,11609
0812105013,Mataró,5,13,11064
0812105015,Mataró,5,15,12023
0812105016,Mataró,5,16,12411
0812105017,Mataró,5,17,10438
0812105019,Mataró,5,19,11805
0812105020,Mataró,5,20,10709
0812105021,Mataró,5,21,16433
0812106001,Mataró,6,1,18370
0812106002,Mataró,6,2,19994
0812106003,Mataró,6,3,18986
0812106004,Mataró,6,4,18545
0812106005,Mataró,6,5,14378
0812106006,Mataró,6,6,16673
0812106007,Mataró,6,7,14305
0812106008,Mataró,6,8,15702
0812106009,Mataró,6,9,17649
0812106010,Mataró,6,10,14969
0812106011,Mataró,6,11,17349
0812106012,Mataró,6,12,13301
0812106013,Mataró,6,13,15406
0812106014,Mataró,6,14,17109
0812201001,Mediona,1,1,15412
0812301001,Molins de Rei,1,1,18128
0812301002,Molins de Rei,1,2,19435
0812301003,Molins de Rei,1,3,18718
0812302001,Molins de Rei,2,1,18507
0812302002,Molins de Rei,2,2,19230
0812302003,Molins de Rei,2,3,15463
0812302004,Molins de Rei,2,4,17429
0812303001,Molins de Rei,3,1,19533
0812303002,Molins de Rei,3,2,23575
0812303003,Molins de Rei,3,3,22771
0812303004,Molins de Rei,3,4,18063
0812304001,Molins de Rei,4,1,17883
0812401001,Mollet del Vallès,1,1,14770
0812401002,Mollet del Vallès,1,2,14814
0812401003,Mollet del Vallès,1,3,13670
0812401004,Mollet del Vallès,1,4,17864
0812401005,Mollet del Vallès,1,5,15088
0812401006,Mollet del Vallès,1,6,14887
0812401007,Mollet del Vallès,1,7,14731
0812402001,Mollet del Vallès,2,1,16285
0812402002,Mollet del Vallès,2,2,18801
0812402003,Mollet del Vallès,2,3,15113
0812402004,Mollet del Vallès,2,4,16240
0812402005,Mollet del Vallès,2,5,17704
0812402006,Mollet del Vallès,2,6,14608
0812402007,Mollet del Vallès,2,7,16428
0812402008,Mollet del Vallès,2,8,18990
0812402009,Mollet del Vallès,2,9,20372
0812403001,Mollet del Vallès,3,1,14569
0812403002,Mollet del Vallès,3,2,14705
0812403003,Mollet del Vallès,3,3,17334
0812403004,Mollet del Vallès,3,4,16660
0812403005,Mollet del Vallès,3,5,20348
0812403006,Mollet del Vallès,3,6,9586
0812403007,Mollet del Vallès,3,7,13030
0812403008,Mollet del Vallès,3,8,15110
0812403009,Mollet del Vallès,3,9,15205
0812403010,Mollet del Vallès,3,10,15947
0812403011,Mollet del Vallès,3,11,16496
0812403012,Mollet del Vallès,3,12,15378
0812403013,Mollet del Vallès,3,13,17037
0812403014,Mollet del Vallès,3,14,16038
0812403015,Mollet del Vallès,3,15,15472
0812501001,Montcada i Reixac,1,1,15879
0812501002,Montcada i Reixac,1,2,16516
0812501004,Montcada i Reixac,1,4,13752
0812501005,Montcada i Reixac,1,5,15573
0812502001,Montcada i Reixac,2,1,9215
0812502002,Montcada i Reixac,2,2,15993
0812502003,Montcada i Reixac,2,3,17616
0812503001,Montcada i Reixac,3,1,16077
0812503002,Montcada i Reixac,3,2,16337
0812503003,Montcada i Reixac,3,3,15251
0812503004,Montcada i Reixac,3,4,18887
0812503005,Montcada i Reixac,3,5,17025
0812503006,Montcada i Reixac,3,6,17155
0812504001,Montcada i Reixac,4,1,16345
0812504002,Montcada i Reixac,4,2,17642
0812504003,Montcada i Reixac,4,3,19076
0812505001,Montcada i Reixac,5,1,12068
0812505002,Montcada i Reixac,5,2,12731
0812505003,Montcada i Reixac,5,3,10935
0812506001,Montcada i Reixac,6,1,15741
0812506002,Montcada i Reixac,6,2,15825
0812506003,Montcada i Reixac,6,3,13863
0812601001,Montgat,1,1,21047
0812601002,Montgat,1,2,16943
0812601003,Montgat,1,3,18665
0812601004,Montgat,1,4,19923
0812701001,Monistrol de Montserrat,1,1,14902
0812701002,Monistrol de Montserrat,1,2,15457
0812801001,Monistrol de Calders,1,1,15803
0812901001,Muntanyola,1,1,19847
0813001001,Montclar,1,1,16055
0813101001,Montesquiu,1,1,15401
0813201001,Montmajor,1,1,16487
0813301001,Montmaneu,1,1,16906
0813401001,Figaró-Montmany,1,1,16680
0813501001,Montmeló,1,1,17563
0813501002,Montmeló,1,2,15728
0813501003,Montmeló,1,3,17070
0813501004,Montmeló,1,4,15848
0813501005,Montmeló,1,5,17845
0813601001,Montornès del Vallès,1,1,16207
0813601002,Montornès del Vallès,1,2,15213
0813601003,Montornès del Vallès,1,3,15861
0813601004,Montornès del Vallès,1,4,17020
0813601005,Montornès del Vallès,1,5,17823
0813601006,Montornès del Vallès,1,6,19885
0813601007,Montornès del Vallès,1,7,18269
0813602001,Montornès del Vallès,2,1,9508
0813602002,Montornès del Vallès,2,2,13447
0813602003,Montornès del Vallès,2,3,11406
0813701001,Montseny,1,1,23268
0813801001,Moià,1,1,17019
0813801002,Moià,1,2,15897
0813801003,Moià,1,3,16459
0813901001,Mura,1,1,19186
0814001001,Navarcles,1,1,15339
0814001002,Navarcles,1,2,17624
0814001003,Navarcles,1,3,18461
0814101001,Navàs,1,1,17501
0814101002,Navàs,1,2,16487
0814101003,Navàs,1,3,15877
0814101004,Navàs,1,4,16558
0814102001,Navàs,2,1,17375
0814201001,La Nou de Berguedà,1,1,16644
0814301001,Òdena,1,1,16949
0814301002,Òdena,1,2,14559
0814401001,Olvan,1,1,16416
0814501001,Olèrdola,1,1,16868
0814501002,Olèrdola,1,2,18776
0814601001,Olesa de Bonesvalls,1,1,17535
0814601002,Olesa de Bonesvalls,1,2,17592
0814701001,Olesa de Montserrat,1,1,14527
0814701002,Olesa de Montserrat,1,2,17131
0814701003,Olesa de Montserrat,1,3,16620
0814701004,Olesa de Montserrat,1,4,18505
0814701005,Olesa de Montserrat,1,5,16982
0814701006,Olesa de Montserrat,1,6,15748
0814701007,Olesa de Montserrat,1,7,15852
0814701008,Olesa de Montserrat,1,8,15756
0814701009,Olesa de Montserrat,1,9,18255
0814701010,Olesa de Montserrat,1,10,15125
0814701011,Olesa de Montserrat,1,11,17735
0814701012,Olesa de Montserrat,1,12,17312
0814801001,Olivella,1,1,16201
0814801002,Olivella,1,2,17293
0814901001,Olost,1,1,19579
0815001001,Orís,1,1,19218
0815101001,Oristà,1,1,17291
0815201001,Orpí,1,1,17221
0815301001,Òrrius,1,1,17816
0815401001,Pacs del Penedès,1,1,22419
0815501001,Palafolls,1,1,16374
0815501002,Palafolls,1,2,15946
0815501003,Palafolls,1,3,13954
0815501004,Palafolls,1,4,16099
0815501005,Palafolls,1,5,15285
0815501006,Palafolls,1,6,16212
0815601001,Palau-solità i Plegamans,1,1,15716
0815601002,Palau-solità i Plegamans,1,2,18623
0815601003,Palau-solità i Plegamans,1,3,19132
0815601004,Palau-solità i Plegamans,1,4,18919
0815601005,Palau-solità i Plegamans,1,5,19683
0815601006,Palau-solità i Plegamans,1,6,19256
0815601007,Palau-solità i Plegamans,1,7,19681
0815601008,Palau-solità i Plegamans,1,8,17904
0815601009,Palau-solità i Plegamans,1,9,16772
0815701001,Pallejà,1,1,19442
0815701002,Pallejà,1,2,16344
0815701003,Pallejà,1,3,18240
0815701004,Pallejà,1,4,24138
0815701005,Pallejà,1,5,18665
0815801001,El Papiol,1,1,19001
0815801002,El Papiol,1,2,17168
0815901001,Parets del Vallès,1,1,17120
0815901002,Parets del Vallès,1,2,17264
0815901003,Parets del Vallès,1,3,18349
0815901004,Parets del Vallès,1,4,17628
0815902001,Parets del Vallès,2,1,17651
0815902002,Parets del Vallès,2,2,19374
0815902003,Parets del Vallès,2,3,17040
0815902004,Parets del Vallès,2,4,18330
0815902005,Parets del Vallès,2,5,19656
0815902006,Parets del Vallès,2,6,18252
0815902007,Parets del Vallès,2,7,17352
0816001001,Perafita,1,1,17328
0816101001,Piera,1,1,15787
0816101002,Piera,1,2,14596
0816101003,Piera,1,3,14520
0816101004,Piera,1,4,14897
0816101005,Piera,1,5,15922
0816101006,Piera,1,6,15428
0816101007,Piera,1,7,16043
0816101008,Piera,1,8,15544
0816101009,Piera,1,9,15851
0816201001,Els Hostalets de Pierola,1,1,16907
0816301001,Pineda de Mar,1,1,14519
0816301002,Pineda de Mar,1,2,16208
0816301003,Pineda de Mar,1,3,17636
0816301004,Pineda de Mar,1,4,14569
0816301005,Pineda de Mar,1,5,15447
0816301006,Pineda de Mar,1,6,14402
0816301007,Pineda de Mar,1,7,15267
0816301008,Pineda de Mar,1,8,11389
0816301009,Pineda de Mar,1,9,14261
0816301010,Pineda de Mar,1,10,15333
0816301011,Pineda de Mar,1,11,15760
0816301012,Pineda de Mar,1,12,11795
0816301013,Pineda de Mar,1,13,13862
0816301014,Pineda de Mar,1,14,13558
0816401001,El Pla del Penedès,1,1,16097
0816501001,La Pobla de Claramunt,1,1,16403
0816601001,La Pobla de Lillet,1,1,17352
0816601002,,,,
0816701001,Polinyà,1,1,15652
0816701002,Polinyà,1,2,14698
0816701003,Polinyà,1,3,17656
0816701004,Polinyà,1,4,16863
0816701005,Polinyà,1,5,18204
0816801001,Pontons,1,1,14919
0816901001,El Prat de Llobregat,1,1,18514
0816901002,El Prat de Llobregat,1,2,20150
0816901003,El Prat de Llobregat,1,3,20626
0816901004,El Prat de Llobregat,1,4,15863
0816901005,El Prat de Llobregat,1,5,16922
0816902001,El Prat de Llobregat,2,1,17074
0816902002,El Prat de Llobregat,2,2,19087
0816902003,El Prat de Llobregat,2,3,15417
0816902004,El Prat de Llobregat,2,4,15531
0816902005,El Prat de Llobregat,2,5,16738
0816902006,El Prat de Llobregat,2,6,18008
0816902007,El Prat de Llobregat,2,7,17216
0816903001,El Prat de Llobregat,3,1,18829
0816903002,El Prat de Llobregat,3,2,16937
0816903003,El Prat de Llobregat,3,3,15368
0816903004,El Prat de Llobregat,3,4,14742
0816903005,El Prat de Llobregat,3,5,17391
0816903006,El Prat de Llobregat,3,6,16337
0816903007,El Prat de Llobregat,3,7,16847
0816903008,El Prat de Llobregat,3,8,15376
0816903009,El Prat de Llobregat,3,9,15902
0816903010,El Prat de Llobregat,3,10,16748
0816903011,El Prat de Llobregat,3,11,17179
0816903012,El Prat de Llobregat,3,12,18015
0816903013,El Prat de Llobregat,3,13,19115
0816904001,El Prat de Llobregat,4,1,15383
0816904002,El Prat de Llobregat,4,2,13217
0816904003,El Prat de Llobregat,4,3,12459
0816904004,El Prat de Llobregat,4,4,11807
0816904005,El Prat de Llobregat,4,5,11411
0816904006,El Prat de Llobregat,4,6,7578
0816905001,El Prat de Llobregat,5,1,15906
0816905002,El Prat de Llobregat,5,2,15946
0816905003,El Prat de Llobregat,5,3,15133
0816905004,El Prat de Llobregat,5,4,18698
0816905005,El Prat de Llobregat,5,5,15907
0816905006,El Prat de Llobregat,5,6,16713
0816905007,El Prat de Llobregat,5,7,15791
0816905008,El Prat de Llobregat,5,8,19538
0816905009,El Prat de Llobregat,5,9,19357
0817001001,Els Prats de Rei,1,1,17410
0817101001,Prats de Lluçanès,1,1,17162
0817101002,Prats de Lluçanès,1,2,16648
0817201001,Premià de Mar,1,1,20367
0817201002,Premià de Mar,1,2,18423
0817201003,Premià de Mar,1,3,18404
0817202001,Premià de Mar,2,1,18300
0817202002,Premià de Mar,2,2,13524
0817202003,Premià de Mar,2,3,14293
0817202004,Premià de Mar,2,4,12345
0817203001,Premià de Mar,3,1,17415
0817203002,Premià de Mar,3,2,14013
0817203003,Premià de Mar,3,3,15794
0817203004,Premià de Mar,3,4,18558
0817203005,Premià de Mar,3,5,12383
0817203006,Premià de Mar,3,6,20774
0817203007,Premià de Mar,3,7,19518
0817203008,Premià de Mar,3,8,19845
0817203009,Premià de Mar,3,9,25699
0817401001,Puigdàlber,1,1,16043
0817501001,Puig-reig,1,1,15581
0817501002,Puig-reig,1,2,16880
0817502001,Puig-reig,2,1,18298
0817601001,Pujalt,1,1,21052
0817701001,La Quar,1,1,19672
0817801001,Rajadell,1,1,19712
0817901001,Rellinars,1,1,17594
0818001001,Ripollet,1,1,14750
0818001002,Ripollet,1,2,17221
0818001003,Ripollet,1,3,15552
0818001004,Ripollet,1,4,14903
0818001005,Ripollet,1,5,14597
0818001006,Ripollet,1,6,12828
0818001007,Ripollet,1,7,13232
0818001008,Ripollet,1,8,14470
0818001009,Ripollet,1,9,18540
0818001010,Ripollet,1,10,17338
0818001011,Ripollet,1,11,17922
0818001012,Ripollet,1,12,16861
0818001013,Ripollet,1,13,17315
0818002001,Ripollet,2,1,14710
0818002002,Ripollet,2,2,15093
0818002003,Ripollet,2,3,13286
0818002004,Ripollet,2,4,15102
0818002005,Ripollet,2,5,11524
0818002006,Ripollet,2,6,13500
0818002007,Ripollet,2,7,11256
0818101001,La Roca del Vallès,1,1,25849
0818101002,La Roca del Vallès,1,2,21023
0818101003,La Roca del Vallès,1,3,17885
0818101004,La Roca del Vallès,1,4,20138
0818101005,La Roca del Vallès,1,5,19198
0818201001,El Pont de Vilomara i Rocafort,1,1,15197
0818301001,Roda de Ter,1,1,15530
0818301002,Roda de Ter,1,2,17118
0818301003,Roda de Ter,1,3,15520
0818302001,Roda de Ter,2,1,15652
0818401001,Rubí,1,1,17205
0818401002,Rubí,1,2,14450
0818401003,Rubí,1,3,16856
0818401004,Rubí,1,4,19772
0818402001,Rubí,2,1,16766
0818402003,Rubí,2,3,16492
0818402004,Rubí,2,4,18162
0818402005,Rubí,2,5,16369
0818402006,Rubí,2,6,17090
0818403001,Rubí,3,1,17634
0818403003,Rubí,3,3,11309
0818403004,Rubí,3,4,11937
0818403005,Rubí,3,5,14709
0818403006,Rubí,3,6,13404
0818403007,Rubí,3,7,15351
0818403008,Rubí,3,8,11274
0818403009,Rubí,3,9,18239
0818404001,Rubí,4,1,15314
0818404002,Rubí,4,2,15848
0818404003,Rubí,4,3,15777
0818404004,Rubí,4,4,14896
0818404005,Rubí,4,5,16479
0818404006,Rubí,4,6,15118
0818404007,Rubí,4,7,15436
0818404008,Rubí,4,8,13687
0818404009,Rubí,4,9,15853
0818404010,Rubí,4,10,14782
0818404011,Rubí,4,11,15220
0818404012,Rubí,4,12,14793
0818404013,Rubí,4,13,13564
0818404014,Rubí,4,14,16571
0818404015,Rubí,4,15,14424
0818404016,Rubí,4,16,14687
0818404018,Rubí,4,18,14720
0818404019,Rubí,4,19,12840
0818404020,Rubí,4,20,14591
0818404021,Rubí,4,21,17161
0818404022,Rubí,4,22,19719
0818404023,Rubí,4,23,14218
0818404024,Rubí,4,24,17008
0818404025,Rubí,4,25,13940
0818404026,Rubí,4,26,15909
0818501001,Rubió,1,1,18221
0818701001,Sabadell,1,1,23189
0818701002,Sabadell,1,2,25717
0818701003,Sabadell,1,3,23257
0818701004,Sabadell,1,4,23358
0818701005,Sabadell,1,5,23608
0818701006,Sabadell,1,6,29373
0818701007,Sabadell,1,7,22150
0818701008,Sabadell,1,8,24191
0818701009,Sabadell,1,9,24586
0818701010,Sabadell,1,10,25461
0818701011,Sabadell,1,11,23493
0818701012,Sabadell,1,12,20675
0818701013,Sabadell,1,13,19930
0818701014,Sabadell,1,14,21509
0818701015,Sabadell,1,15,23016
0818701016,Sabadell,1,16,21295
0818701017,Sabadell,1,17,17804
0818701018,Sabadell,1,18,17102
0818701019,Sabadell,1,19,19523
0818701020,Sabadell,1,20,19231
0818701021,Sabadell,1,21,15885
0818701022,Sabadell,1,22,19928
0818701023,Sabadell,1,23,15017
0818701024,Sabadell,1,24,15998
0818701025,Sabadell,1,25,14869
0818701026,Sabadell,1,26,17836
0818701027,Sabadell,1,27,15648
0818701028,Sabadell,1,28,20569
0818701029,Sabadell,1,29,18906
0818701030,Sabadell,1,30,24693
0818701031,Sabadell,1,31,23194
0818701032,Sabadell,1,32,23190
0818701033,Sabadell,1,33,18389
0818701034,Sabadell,1,34,18355
0818701035,Sabadell,1,35,15686
0818701036,Sabadell,1,36,25965
0818701037,Sabadell,1,37,22477
0818701038,Sabadell,1,38,18896
0818702001,Sabadell,2,1,23052
0818702002,Sabadell,2,2,21859
0818702003,Sabadell,2,3,17329
0818702004,Sabadell,2,4,19265
0818702005,Sabadell,2,5,20455
0818702006,Sabadell,2,6,16323
0818702007,Sabadell,2,7,17263
0818702008,Sabadell,2,8,17971
0818702009,Sabadell,2,9,20741
0818702010,Sabadell,2,10,15738
0818702011,Sabadell,2,11,11534
0818702012,Sabadell,2,12,12412
0818702013,Sabadell,2,13,10792
0818702014,Sabadell,2,14,8226
0818702015,Sabadell,2,15,15526
0818702016,Sabadell,2,16,21023
0818702017,Sabadell,2,17,22900
0818703001,Sabadell,3,1,13854
0818703002,Sabadell,3,2,14734
0818703003,Sabadell,3,3,12805
0818703004,Sabadell,3,4,13106
0818703005,Sabadell,3,5,14442
0818703006,Sabadell,3,6,14311
0818703007,Sabadell,3,7,13519
0818703008,Sabadell,3,8,12739
0818703009,Sabadell,3,9,11558
0818703010,Sabadell,3,10,15505
0818703011,Sabadell,3,11,11917
0818703012,Sabadell,3,12,13581
0818703013,Sabadell,3,13,14123
0818703014,Sabadell,3,14,11835
0818703015,Sabadell,3,15,13804
0818703016,Sabadell,3,16,10896
0818703017,Sabadell,3,17,12414
0818703018,Sabadell,3,18,13576
0818703019,Sabadell,3,19,17879
0818703020,Sabadell,3,20,14720
0818703021,Sabadell,3,21,12810
0818703022,Sabadell,3,22,12277
0818703023,Sabadell,3,23,16018
0818703024,Sabadell,3,24,16402
0818703025,Sabadell,3,25,15896
0818703026,Sabadell,3,26,18835
0818703027,Sabadell,3,27,14066
0818704001,Sabadell,4,1,15486
0818704002,Sabadell,4,2,12412
0818704003,Sabadell,4,3,14517
0818704004,Sabadell,4,4,15002
0818704005,Sabadell,4,5,15291
0818704006,Sabadell,4,6,18071
0818704007,Sabadell,4,7,16730
0818704008,Sabadell,4,8,17892
0818704009,Sabadell,4,9,20252
0818704010,Sabadell,4,10,14098
0818704011,Sabadell,4,11,13633
0818704012,Sabadell,4,12,12473
0818704013,Sabadell,4,13,13811
0818704014,Sabadell,4,14,15130
0818704015,Sabadell,4,15,12138
0818704016,Sabadell,4,16,14988
0818704017,Sabadell,4,17,13532
0818704018,Sabadell,4,18,13265
0818704019,Sabadell,4,19,12321
0818704020,Sabadell,4,20,13296
0818704021,Sabadell,4,21,14495
0818704022,Sabadell,4,22,15821
0818704023,Sabadell,4,23,14213
0818704024,Sabadell,4,24,16359
0818704025,Sabadell,4,25,15618
0818704026,Sabadell,4,26,19070
0818704027,Sabadell,4,27,18919
0818704028,Sabadell,4,28,21713
0818704029,Sabadell,4,29,21361
0818704030,Sabadell,4,30,18062
0818705001,Sabadell,5,1,16065
0818705002,Sabadell,5,2,18802
0818705003,Sabadell,5,3,21452
0818705004,Sabadell,5,4,17901
0818705005,Sabadell,5,5,15588
0818705006,Sabadell,5,6,17106
0818705007,Sabadell,5,7,13045
0818705008,Sabadell,5,8,11142
0818705009,Sabadell,5,9,16968
0818705011,Sabadell,5,11,10469
0818705012,Sabadell,5,12,13118
0818705013,Sabadell,5,13,18258
0818705014,Sabadell,5,14,17868
0818705015,Sabadell,5,15,20444
0818705016,Sabadell,5,16,15200
0818706001,Sabadell,6,1,11945
0818706002,Sabadell,6,2,12633
0818706003,Sabadell,6,3,13670
0818706004,Sabadell,6,4,13016
0818706005,Sabadell,6,5,12728
0818706006,Sabadell,6,6,13122
0818706007,Sabadell,6,7,9861
0818706008,Sabadell,6,8,15982
0818706009,Sabadell,6,9,11229
0818706010,Sabadell,6,10,10376
0818706011,Sabadell,6,11,10891
0818706012,Sabadell,6,12,11348
0818706013,Sabadell,6,13,11394
0818706014,Sabadell,6,14,14619
0818706016,Sabadell,6,16,14033
0818706017,Sabadell,6,17,13708
0818706018,Sabadell,6,18,11500
0818706020,Sabadell,6,20,14140
0818706021,Sabadell,6,21,13066
0818706022,Sabadell,6,22,13593
0818706023,Sabadell,6,23,14681
0818706024,Sabadell,6,24,13139
0818706025,Sabadell,6,25,10353
0818707001,Sabadell,7,1,11671
0818707002,Sabadell,7,2,11231
0818707003,Sabadell,7,3,10352
0818707004,Sabadell,7,4,10822
0818707005,Sabadell,7,5,13572
0818707006,Sabadell,7,6,12648
0818707007,Sabadell,7,7,13401
0818707008,Sabadell,7,8,11141
0818801001,Sagàs,1,1,20774
0818901001,Sant Pere Sallavinera,1,1,23078
0819001001,Saldes,1,1,19466
0819101001,Sallent,1,1,16271
0819101002,,,,
0819101003,Sallent,1,3,17488
0819101004,Sallent,1,4,16032
0819101005,Sallent,1,5,16612
0819101006,Sallent,1,6,16164
0819102001,,,,
0819201001,Santpedor,1,1,16519
0819201002,Santpedor,1,2,17797
0819201003,Santpedor,1,3,19760
0819201004,Santpedor,1,4,22524
0819301001,Sant Iscle de Vallalta,1,1,17457
0819401001,Sant Adrià de Besòs,1,1,16837
0819401002,Sant Adrià de Besòs,1,2,15952
0819401003,Sant Adrià de Besòs,1,3,13528
0819401004,Sant Adrià de Besòs,1,4,16036
0819401005,Sant Adrià de Besòs,1,5,16340
0819401006,Sant Adrià de Besòs,1,6,17106
0819402001,Sant Adrià de Besòs,2,1,14432
0819402002,Sant Adrià de Besòs,2,2,13495
0819402003,Sant Adrià de Besòs,2,3,14866
0819402004,Sant Adrià de Besòs,2,4,15545
0819402005,Sant Adrià de Besòs,2,5,16250
0819403001,Sant Adrià de Besòs,3,1,12854
0819404001,Sant Adrià de Besòs,4,1,17428
0819405001,Sant Adrià de Besòs,5,1,14129
0819405002,Sant Adrià de Besòs,5,2,12745
0819405003,Sant Adrià de Besòs,5,3,13083
0819405004,Sant Adrià de Besòs,5,4,13855
0819406001,Sant Adrià de Besòs,6,1,9350
0819406002,Sant Adrià de Besòs,6,2,9100
0819406003,Sant Adrià de Besòs,6,3,7817
0819406004,Sant Adrià de Besòs,6,4,9014
0819406005,Sant Adrià de Besòs,6,5,10973
0819406006,Sant Adrià de Besòs,6,6,9269
0819406007,Sant Adrià de Besòs,6,7,13938
0819501001,Sant Agustí de Lluçanès,1,1,17506
0819601001,Sant Andreu de la Barca,1,1,16555
0819601002,Sant Andreu de la Barca,1,2,15268
0819601003,Sant Andreu de la Barca,1,3,14459
0819601004,Sant Andreu de la Barca,1,4,15120
0819601005,Sant Andreu de la Barca,1,5,16994
0819601006,Sant Andreu de la Barca,1,6,14904
0819601007,Sant Andreu de la Barca,1,7,17365
0819601008,Sant Andreu de la Barca,1,8,18632
0819601009,Sant Andreu de la Barca,1,9,15422
0819601010,Sant Andreu de la Barca,1,10,14106
0819601011,Sant Andreu de la Barca,1,11,15954
0819601012,Sant Andreu de la Barca,1,12,21998
0819601013,Sant Andreu de la Barca,1,13,17194
0819601014,Sant Andreu de la Barca,1,14,18207
0819701001,Sant Andreu de Llavaneres,1,1,17475
0819701002,Sant Andreu de Llavaneres,1,2,21179
0819701003,Sant Andreu de Llavaneres,1,3,17254
0819702001,Sant Andreu de Llavaneres,2,1,28857
0819702002,Sant Andreu de Llavaneres,2,2,21860
0819702003,Sant Andreu de Llavaneres,2,3,24922
0819801001,Sant Antoni de Vilamajor,1,1,18136
0819801002,Sant Antoni de Vilamajor,1,2,20100
0819801003,Sant Antoni de Vilamajor,1,3,22682
0819801004,Sant Antoni de Vilamajor,1,4,16202
0819901001,Sant Bartomeu del Grau,1,1,17167
0820001001,Sant Boi de Llobregat,1,1,12670
0820001002,Sant Boi de Llobregat,1,2,13763
0820001003,Sant Boi de Llobregat,1,3,14205
0820001004,Sant Boi de Llobregat,1,4,13942
0820001005,Sant Boi de Llobregat,1,5,17472
0820001006,Sant Boi de Llobregat,1,6,13661
0820001007,Sant Boi de Llobregat,1,7,15016
0820002001,Sant Boi de Llobregat,2,1,18635
0820002002,Sant Boi de Llobregat,2,2,14229
0820002003,Sant Boi de Llobregat,2,3,13864
0820002004,Sant Boi de Llobregat,2,4,14770
0820002005,Sant Boi de Llobregat,2,5,14593
0820002006,Sant Boi de Llobregat,2,6,16436
0820002007,Sant Boi de Llobregat,2,7,14553
0820002008,Sant Boi de Llobregat,2,8,17462
0820002009,Sant Boi de Llobregat,2,9,14498
0820002010,Sant Boi de Llobregat,2,10,16424
0820002011,Sant Boi de Llobregat,2,11,18998
0820002012,Sant Boi de Llobregat,2,12,15507
0820002013,Sant Boi de Llobregat,2,13,24741
0820002014,Sant Boi de Llobregat,2,14,16168
0820002015,Sant Boi de Llobregat,2,15,15436
0820002016,Sant Boi de Llobregat,2,16,19636
0820002017,Sant Boi de Llobregat,2,17,18466
0820002018,Sant Boi de Llobregat,2,18,18982
0820002019,Sant Boi de Llobregat,2,19,16732
0820003001,Sant Boi de Llobregat,3,1,17883
0820003002,Sant Boi de Llobregat,3,2,16891
0820003003,Sant Boi de Llobregat,3,3,16270
0820003004,Sant Boi de Llobregat,3,4,17841
0820003005,Sant Boi de Llobregat,3,5,16469
0820003006,Sant Boi de Llobregat,3,6,17590
0820003007,Sant Boi de Llobregat,3,7,16393
0820003008,Sant Boi de Llobregat,3,8,17722
0820003009,Sant Boi de Llobregat,3,9,13793
0820004001,Sant Boi de Llobregat,4,1,16125
0820004002,Sant Boi de Llobregat,4,2,17863
0820004003,Sant Boi de Llobregat,4,3,15930
0820004004,Sant Boi de Llobregat,4,4,15957
0820004005,Sant Boi de Llobregat,4,5,15600
0820004006,Sant Boi de Llobregat,4,6,14497
0820004007,Sant Boi de Llobregat,4,7,15740
0820004008,Sant Boi de Llobregat,4,8,16556
0820004009,Sant Boi de Llobregat,4,9,16913
0820005001,Sant Boi de Llobregat,5,1,18326
0820005002,Sant Boi de Llobregat,5,2,11512
0820005003,Sant Boi de Llobregat,5,3,11331
0820006001,Sant Boi de Llobregat,6,1,15360
0820006002,Sant Boi de Llobregat,6,2,13882
0820006003,Sant Boi de Llobregat,6,3,12216
0820101001,Sant Boi de Lluçanès,1,1,18686
0820201001,Sant Celoni,1,1,18398
0820201002,Sant Celoni,1,2,19868
0820201003,Sant Celoni,1,3,15702
0820201004,Sant Celoni,1,4,12356
0820201005,Sant Celoni,1,5,16734
0820201006,Sant Celoni,1,6,16119
0820201007,Sant Celoni,1,7,15438
0820201008,Sant Celoni,1,8,19221
0820201009,Sant Celoni,1,9,16114
0820202001,Sant Celoni,2,1,16310
0820301001,Sant Cebrià de Vallalta,1,1,17099
0820301002,Sant Cebrià de Vallalta,1,2,18607
0820401001,Sant Climent de Llobregat,1,1,19166
0820401002,Sant Climent de Llobregat,1,2,17732
0820501001,Sant Cugat del Vallès,1,1,21508
0820501002,Sant Cugat del Vallès,1,2,20829
0820501003,Sant Cugat del Vallès,1,3,22159
0820501004,Sant Cugat del Vallès,1,4,26126
0820501005,Sant Cugat del Vallès,1,5,22265
0820501006,Sant Cugat del Vallès,1,6,18167
0820501007,Sant Cugat del Vallès,1,7,17686
0820501008,Sant Cugat del Vallès,1,8,19267
0820501009,Sant Cugat del Vallès,1,9,32514
0820501010,Sant Cugat del Vallès,1,10,16852
0820501011,Sant Cugat del Vallès,1,11,21548
0820501012,Sant Cugat del Vallès,1,12,31991
0820501013,Sant Cugat del Vallès,1,13,28705
0820501014,Sant Cugat del Vallès,1,14,28081
0820501015,Sant Cugat del Vallès,1,15,26442
0820501016,Sant Cugat del Vallès,1,16,26883
0820501017,Sant Cugat del Vallès,1,17,26238
0820501018,Sant Cugat del Vallès,1,18,23594
0820501019,Sant Cugat del Vallès,1,19,28271
0820501020,Sant Cugat del Vallès,1,20,23474
0820501021,Sant Cugat del Vallès,1,21,21441
0820501022,Sant Cugat del Vallès,1,22,18431
0820501023,Sant Cugat del Vallès,1,23,25262
0820501024,Sant Cugat del Vallès,1,24,24907
0820502001,Sant Cugat del Vallès,2,1,40089
0820502002,Sant Cugat del Vallès,2,2,21404
0820502003,Sant Cugat del Vallès,2,3,21645
0820502004,Sant Cugat del Vallès,2,4,26467
0820502005,Sant Cugat del Vallès,2,5,18722
0820502006,Sant Cugat del Vallès,2,6,35264
0820502007,Sant Cugat del Vallès,2,7,22445
0820502008,Sant Cugat del Vallès,2,8,34889
0820502009,Sant Cugat del Vallès,2,9,33317
0820502010,Sant Cugat del Vallès,2,10,33560
0820502011,Sant Cugat del Vallès,2,11,36886
0820502012,Sant Cugat del Vallès,2,12,31690
0820503001,Sant Cugat del Vallès,3,1,27561
0820503002,Sant Cugat del Vallès,3,2,31114
0820503003,Sant Cugat del Vallès,3,3,31176
0820503004,Sant Cugat del Vallès,3,4,27824
0820504001,Sant Cugat del Vallès,4,1,22835
0820504002,Sant Cugat del Vallès,4,2,22002
0820504003,Sant Cugat del Vallès,4,3,21903
0820505001,Sant Cugat del Vallès,5,1,37238
0820505002,Sant Cugat del Vallès,5,2,24401
0820505003,Sant Cugat del Vallès,5,3,30369
0820505004,Sant Cugat del Vallès,5,4,32930
0820505005,Sant Cugat del Vallès,5,5,25410
0820505006,Sant Cugat del Vallès,5,6,27432
0820505007,Sant Cugat del Vallès,5,7,25372
0820505008,Sant Cugat del Vallès,5,8,25090
0820506001,Sant Cugat del Vallès,6,1,17561
0820601001,Sant Cugat Sesgarrigues,1,1,17771
0820701001,Sant Esteve de Palautordera,1,1,19106
0820701002,Sant Esteve de Palautordera,1,2,18319
0820801001,Sant Esteve Sesrovires,1,1,19786
0820801002,Sant Esteve Sesrovires,1,2,20996
0820801003,Sant Esteve Sesrovires,1,3,19182
0820801004,Sant Esteve Sesrovires,1,4,21324
0820801005,Sant Esteve Sesrovires,1,5,21068
0820901001,Sant Fost de Campsentelles,1,1,19295
0820901002,Sant Fost de Campsentelles,1,2,17752
0820901003,Sant Fost de Campsentelles,1,3,20784
0820901004,Sant Fost de Campsentelles,1,4,19170
0821001001,Sant Feliu de Codines,1,1,17379
0821001002,Sant Feliu de Codines,1,2,16819
0821002001,Sant Feliu de Codines,2,1,16610
0821002002,Sant Feliu de Codines,2,2,15860
0821101001,Sant Feliu de Llobregat,1,1,20847
0821101002,Sant Feliu de Llobregat,1,2,22287
0821101003,Sant Feliu de Llobregat,1,3,20101
0821101004,Sant Feliu de Llobregat,1,4,22542
0821101005,Sant Feliu de Llobregat,1,5,17955
0821101006,Sant Feliu de Llobregat,1,6,18814
0821101007,Sant Feliu de Llobregat,1,7,19284
0821101008,Sant Feliu de Llobregat,1,8,25591
0821102003,Sant Feliu de Llobregat,2,3,14370
0821102004,Sant Feliu de Llobregat,2,4,15943
0821102006,Sant Feliu de Llobregat,2,6,16804
0821102007,Sant Feliu de Llobregat,2,7,16456
0821102008,Sant Feliu de Llobregat,2,8,15975
0821103001,Sant Feliu de Llobregat,3,1,16010
0821103002,Sant Feliu de Llobregat,3,2,19799
0821103003,Sant Feliu de Llobregat,3,3,19900
0821103004,Sant Feliu de Llobregat,3,4,19537
0821103005,Sant Feliu de Llobregat,3,5,18066
0821104003,Sant Feliu de Llobregat,4,3,14351
0821104006,Sant Feliu de Llobregat,4,6,13808
0821104007,Sant Feliu de Llobregat,4,7,14079
0821104008,Sant Feliu de Llobregat,4,8,14416
0821105001,Sant Feliu de Llobregat,5,1,13924
0821105002,Sant Feliu de Llobregat,5,2,14693
0821105003,Sant Feliu de Llobregat,5,3,13303
0821105004,Sant Feliu de Llobregat,5,4,13849
0821105005,Sant Feliu de Llobregat,5,5,16464
0821106004,Sant Feliu de Llobregat,6,4,20923
0821107001,Sant Feliu de Llobregat,7,1,22164
0821107002,Sant Feliu de Llobregat,7,2,26326
0821107003,Sant Feliu de Llobregat,7,3,20639
0821201001,Sant Feliu Sasserra,1,1,17635
0821301001,Sant Fruitós de Bages,1,1,17442
0821301002,Sant Fruitós de Bages,1,2,16751
0821301003,Sant Fruitós de Bages,1,3,20914
0821301004,Sant Fruitós de Bages,1,4,33159
0821301005,Sant Fruitós de Bages,1,5,17265
0821301006,Sant Fruitós de Bages,1,6,15208
0821401001,Vilassar de Dalt,1,1,28336
0821401002,Vilassar de Dalt,1,2,14996
0821401003,Vilassar de Dalt,1,3,16564
0821401004,Vilassar de Dalt,1,4,22589
0821402001,Vilassar de Dalt,2,1,19618
0821402002,Vilassar de Dalt,2,2,21289
0821501001,Sant Hipòlit de Voltregà,1,1,17537
0821501002,Sant Hipòlit de Voltregà,1,2,16646
0821501003,Sant Hipòlit de Voltregà,1,3,17714
0821601001,Sant Jaume de Frontanyà,1,1,19672
0821701001,Sant Joan Despí,1,1,23505
0821701002,Sant Joan Despí,1,2,19380
0821701003,Sant Joan Despí,1,3,19588
0821701004,Sant Joan Despí,1,4,21004
0821701005,Sant Joan Despí,1,5,17760
0821701006,Sant Joan Despí,1,6,16800
0821701007,Sant Joan Despí,1,7,16706
0821701008,Sant Joan Despí,1,8,18353
0821701009,Sant Joan Despí,1,9,22443
0821701010,Sant Joan Despí,1,10,23524
0821701011,,,,22266
0821702002,Sant Joan Despí,2,2,20087
0821702003,Sant Joan Despí,2,3,13909
0821702004,Sant Joan Despí,2,4,13431
0821703001,Sant Joan Despí,3,1,14604
0821703002,Sant Joan Despí,3,2,13874
0821703003,Sant Joan Despí,3,3,14361
0821703004,Sant Joan Despí,3,4,14529
0821703005,Sant Joan Despí,3,5,14080
0821704001,Sant Joan Despí,4,1,22700
0821704002,Sant Joan Despí,4,2,25186
0821705001,Sant Joan Despí,5,1,21359
0821705002,Sant Joan Despí,5,2,26297
0821706001,Sant Joan Despí,6,1,21933
0821801001,Sant Joan de Vilatorrada,1,1,15783
0821801002,Sant Joan de Vilatorrada,1,2,16854
0821801003,Sant Joan de Vilatorrada,1,3,16449
0821801005,Sant Joan de Vilatorrada,1,5,16287
0821801006,Sant Joan de Vilatorrada,1,6,16262
0821901001,Vilassar de Mar,1,1,22739
0821901002,Vilassar de Mar,1,2,20563
0821901003,Vilassar de Mar,1,3,19634
0821901004,Vilassar de Mar,1,4,21543
0821901005,Vilassar de Mar,1,5,20523
0821901006,Vilassar de Mar,1,6,23858
0821902001,Vilassar de Mar,2,1,24283
0821902002,Vilassar de Mar,2,2,26315
0821902003,Vilassar de Mar,2,3,22886
0821902004,Vilassar de Mar,2,4,23692
0821902005,Vilassar de Mar,2,5,23957
0821903001,Vilassar de Mar,3,1,19303
0821903002,Vilassar de Mar,3,2,21699
0821903003,Vilassar de Mar,3,3,15137
0821903004,Vilassar de Mar,3,4,14092
0822001001,Sant Julià de Vilatorta,1,1,18410
0822001002,Sant Julià de Vilatorta,1,2,24546
0822101001,Sant Just Desvern,1,1,32539
0822101002,Sant Just Desvern,1,2,25102
0822101003,Sant Just Desvern,1,3,24525
0822101004,Sant Just Desvern,1,4,24512
0822101005,Sant Just Desvern,1,5,30384
0822101006,Sant Just Desvern,1,6,28106
0822101007,Sant Just Desvern,1,7,25096
0822101008,Sant Just Desvern,1,8,23668
0822101009,Sant Just Desvern,1,9,31448
0822101010,Sant Just Desvern,1,10,24206
0822201001,Sant Llorenç d'Hortons,1,1,17764
0822301001,Sant Llorenç Savall,1,1,16484
0822401001,Sant Martí de Centelles,1,1,16016
0822501001,Sant Martí d'Albars,1,1,18613
0822601001,Sant Martí de Tous,1,1,17652
0822701001,Sant Martí Sarroca,1,1,15388
0822701002,Sant Martí Sarroca,1,2,17142
0822801001,Sant Martí Sesgueioles,1,1,16855
0822901001,Sant Mateu de Bages,1,1,19065
0823001001,Premià de Dalt,1,1,24369
0823001002,Premià de Dalt,1,2,20746
0823001003,Premià de Dalt,1,3,13303
0823001004,Premià de Dalt,1,4,25462
0823001005,Premià de Dalt,1,5,13817
0823001006,Premià de Dalt,1,6,27775
0823101001,Sant Pere de Ribes,1,1,24160
0823101002,Sant Pere de Ribes,1,2,20646
0823101003,Sant Pere de Ribes,1,3,17387
0823101004,Sant Pere de Ribes,1,4,13131
0823101005,Sant Pere de Ribes,1,5,13625
0823101006,Sant Pere de Ribes,1,6,11762
0823101007,Sant Pere de Ribes,1,7,13093
0823101008,Sant Pere de Ribes,1,8,20643
0823101009,Sant Pere de Ribes,1,9,16216
0823101010,Sant Pere de Ribes,1,10,13471
0823101011,Sant Pere de Ribes,1,11,12748
0823101012,Sant Pere de Ribes,1,12,21310
0823101013,Sant Pere de Ribes,1,13,16850
0823101014,Sant Pere de Ribes,1,14,23139
0823101015,Sant Pere de Ribes,1,15,19650
0823101016,Sant Pere de Ribes,1,16,17063
0823101017,Sant Pere de Ribes,1,17,16248
0823201001,Sant Pere de Riudebitlles,1,1,16985
0823301001,Sant Pere de Torelló,1,1,17480
0823301002,Sant Pere de Torelló,1,2,16761
0823401001,Sant Pere de Vilamajor,1,1,18534
0823401002,Sant Pere de Vilamajor,1,2,19033
0823401003,Sant Pere de Vilamajor,1,3,17646
0823501001,Sant Pol de Mar,1,1,21830
0823501002,Sant Pol de Mar,1,2,20673
0823501003,Sant Pol de Mar,1,3,19542
0823601001,Sant Quintí de Mediona,1,1,14480
0823701001,Sant Quirze de Besora,1,1,17601
0823701002,Sant Quirze de Besora,1,2,17191
0823801001,Sant Quirze del Vallès,1,1,22495
0823801002,Sant Quirze del Vallès,1,2,31872
0823801003,Sant Quirze del Vallès,1,3,17823
0823801004,Sant Quirze del Vallès,1,4,25954
0823801005,Sant Quirze del Vallès,1,5,22320
0823801006,Sant Quirze del Vallès,1,6,25433
0823801007,Sant Quirze del Vallès,1,7,25620
0823801008,Sant Quirze del Vallès,1,8,26773
0823801009,Sant Quirze del Vallès,1,9,20684
0823801010,Sant Quirze del Vallès,1,10,20777
0823801011,Sant Quirze del Vallès,1,11,19016
0823801012,Sant Quirze del Vallès,1,12,25531
0823901001,Sant Quirze Safaja,1,1,22176
0824001001,Sant Sadurní d'Anoia,1,1,17141
0824001002,Sant Sadurní d'Anoia,1,2,16902
0824001003,Sant Sadurní d'Anoia,1,3,15568
0824001004,Sant Sadurní d'Anoia,1,4,20469
0824002001,Sant Sadurní d'Anoia,2,1,18754
0824002002,Sant Sadurní d'Anoia,2,2,17802
0824002003,Sant Sadurní d'Anoia,2,3,18723
0824002004,Sant Sadurní d'Anoia,2,4,19320
0824101001,Sant Sadurní d'Osormort,1,1,.
0824201001,Marganell,1,1,17225
0824301001,Santa Cecília de Voltregà,1,1,21606
0824401001,Santa Coloma de Cervelló,1,1,19246
0824401002,Santa Coloma de Cervelló,1,2,19375
0824401003,Santa Coloma de Cervelló,1,3,17944
0824401004,Santa Coloma de Cervelló,1,4,21785
0824401005,Santa Coloma de Cervelló,1,5,18528
0824501001,Santa Coloma de Gramenet,1,1,17817
0824501002,Santa Coloma de Gramenet,1,2,20049
0824501003,Santa Coloma de Gramenet,1,3,11832
0824501004,Santa Coloma de Gramenet,1,4,13077
0824501005,Santa Coloma de Gramenet,1,5,13073
0824501006,Santa Coloma de Gramenet,1,6,14387
0824501007,Santa Coloma de Gramenet,1,7,10181
0824501008,,,,
0824501009,Santa Coloma de Gramenet,1,9,12638
0824501010,Santa Coloma de Gramenet,1,10,10930
0824501011,Santa Coloma de Gramenet,1,11,14246
0824501012,Santa Coloma de Gramenet,1,12,15423
0824501013,Santa Coloma de Gramenet,1,13,16326
0824501014,Santa Coloma de Gramenet,1,14,18623
0824501015,Santa Coloma de Gramenet,1,15,15612
0824501016,Santa Coloma de Gramenet,1,16,17822
0824501017,Santa Coloma de Gramenet,1,17,15211
0824501018,Santa Coloma de Gramenet,1,18,15621
0824501019,Santa Coloma de Gramenet,1,19,15655
0824502001,Santa Coloma de Gramenet,2,1,13423
0824502002,Santa Coloma de Gramenet,2,2,15353
0824502003,Santa Coloma de Gramenet,2,3,14420
0824502004,Santa Coloma de Gramenet,2,4,11943
0824502005,Santa Coloma de Gramenet,2,5,12514
0824502006,Santa Coloma de Gramenet,2,6,12864
0824502007,Santa Coloma de Gramenet,2,7,14408
0824502008,Santa Coloma de Gramenet,2,8,12991
0824502009,Santa Coloma de Gramenet,2,9,12392
0824502010,Santa Coloma de Gramenet,2,10,11761
0824502011,Santa Coloma de Gramenet,2,11,12452
0824503001,Santa Coloma de Gramenet,3,1,13233
0824503002,Santa Coloma de Gramenet,3,2,15109
0824503003,Santa Coloma de Gramenet,3,3,12105
0824503004,Santa Coloma de Gramenet,3,4,12911
0824503005,Santa Coloma de Gramenet,3,5,11868
0824503006,Santa Coloma de Gramenet,3,6,13102
0824503007,Santa Coloma de Gramenet,3,7,14905
0824503008,Santa Coloma de Gramenet,3,8,15021
0824503009,Santa Coloma de Gramenet,3,9,14885
0824503010,Santa Coloma de Gramenet,3,10,16531
0824503011,Santa Coloma de Gramenet,3,11,15017
0824503012,Santa Coloma de Gramenet,3,12,14293
0824503013,Santa Coloma de Gramenet,3,13,15423
0824503014,Santa Coloma de Gramenet,3,14,12739
0824503015,Santa Coloma de Gramenet,3,15,17837
0824503016,Santa Coloma de Gramenet,3,16,14497
0824503017,Santa Coloma de Gramenet,3,17,16245
0824504001,Santa Coloma de Gramenet,4,1,16141
0824504002,Santa Coloma de Gramenet,4,2,17461
0824504003,Santa Coloma de Gramenet,4,3,15832
0824504004,Santa Coloma de Gramenet,4,4,16179
0824504005,Santa Coloma de Gramenet,4,5,14685
0824504006,Santa Coloma de Gramenet,4,6,14595
0824504007,Santa Coloma de Gramenet,4,7,14887
0824504008,Santa Coloma de Gramenet,4,8,15749
0824504009,Santa Coloma de Gramenet,4,9,14632
0824504010,Santa Coloma de Gramenet,4,10,13746
0824504011,Santa Coloma de Gramenet,4,11,13748
0824504012,Santa Coloma de Gramenet,4,12,12659
0824504013,Santa Coloma de Gramenet,4,13,15369
0824504014,Santa Coloma de Gramenet,4,14,13615
0824504015,Santa Coloma de Gramenet,4,15,12021
0824504016,Santa Coloma de Gramenet,4,16,14522
0824505001,Santa Coloma de Gramenet,5,1,10912
0824505002,Santa Coloma de Gramenet,5,2,12222
0824505003,Santa Coloma de Gramenet,5,3,12053
0824505004,Santa Coloma de Gramenet,5,4,12260
0824505005,Santa Coloma de Gramenet,5,5,11520
0824505006,Santa Coloma de Gramenet,5,6,10630
0824505007,Santa Coloma de Gramenet,5,7,11373
0824505008,Santa Coloma de Gramenet,5,8,11020
0824505009,Santa Coloma de Gramenet,5,9,11833
0824505010,,,,
0824505011,Santa Coloma de Gramenet,5,11,10398
0824505012,Santa Coloma de Gramenet,5,12,9745
0824505013,Santa Coloma de Gramenet,5,13,10248
0824505014,Santa Coloma de Gramenet,5,14,12323
0824505015,Santa Coloma de Gramenet,5,15,11410
0824505016,Santa Coloma de Gramenet,5,16,14003
0824505017,,,,
0824505018,Santa Coloma de Gramenet,5,18,9020
0824505019,Santa Coloma de Gramenet,5,19,13220
0824506001,,,,
0824506002,Santa Coloma de Gramenet,6,2,11464
0824506003,Santa Coloma de Gramenet,6,3,10711
0824506004,Santa Coloma de Gramenet,6,4,12784
0824506005,Santa Coloma de Gramenet,6,5,10655
0824506006,,,,
0824506007,,,,
0824506008,Santa Coloma de Gramenet,6,8,10628
0824506009,Santa Coloma de Gramenet,6,9,9363
0824506010,,,,
0824506011,Santa Coloma de Gramenet,6,11,8690
0824506012,Santa Coloma de Gramenet,6,12,9348
0824506013,,,,
0824506014,Santa Coloma de Gramenet,6,14,8917
0824506015,,,,
0824506016,,,,
0824506017,,,,
0824601001,Santa Eugènia de Berga,1,1,16951
0824701001,Santa Eulàlia de Riuprimer,1,1,18328
0824801001,Santa Eulàlia de Ronçana,1,1,17454
0824801002,Santa Eulàlia de Ronçana,1,2,18631
0824801003,Santa Eulàlia de Ronçana,1,3,18473
0824801004,Santa Eulàlia de Ronçana,1,4,16748
0824901001,Santa Fe del Penedès,1,1,19809
0825001001,Santa Margarida de Montbui,1,1,18058
0825001002,Santa Margarida de Montbui,1,2,12847
0825001003,Santa Margarida de Montbui,1,3,13004
0825001004,Santa Margarida de Montbui,1,4,15147
0825001005,Santa Margarida de Montbui,1,5,12363
0825001006,Santa Margarida de Montbui,1,6,12730
0825001007,Santa Margarida de Montbui,1,7,12211
0825101001,Santa Margarida i els Monjos,1,1,16218
0825101002,Santa Margarida i els Monjos,1,2,15684
0825101003,Santa Margarida i els Monjos,1,3,14429
0825101004,Santa Margarida i els Monjos,1,4,13814
0825201001,Barberà del Vallès,1,1,16736
0825201002,Barberà del Vallès,1,2,17038
0825201003,Barberà del Vallès,1,3,13450
0825201004,Barberà del Vallès,1,4,14377
0825201005,Barberà del Vallès,1,5,14068
0825201006,Barberà del Vallès,1,6,14664
0825201007,Barberà del Vallès,1,7,18706
0825201008,Barberà del Vallès,1,8,14574
0825201009,Barberà del Vallès,1,9,15079
0825201010,Barberà del Vallès,1,10,20064
0825201011,Barberà del Vallès,1,11,18090
0825201018,Barberà del Vallès,1,18,15128
0825201019,Barberà del Vallès,1,19,15348
0825201020,Barberà del Vallès,1,20,13553
0825201021,Barberà del Vallès,1,21,16044
0825201022,Barberà del Vallès,1,22,19692
0825201023,Barberà del Vallès,1,23,19794
0825201024,Barberà del Vallès,1,24,14202
0825201025,Barberà del Vallès,1,25,16980
0825201026,Barberà del Vallès,1,26,17881
0825201027,Barberà del Vallès,1,27,18091
0825201028,Barberà del Vallès,1,28,18543
0825201029,Barberà del Vallès,1,29,18894
0825301001,Santa Maria de Besora,1,1,17363
0825401001,L'Esquirol,1,1,18402
0825501001,Santa Maria de Merlès,1,1,19135
0825601001,Santa Maria de Martorelles,1,1,18533
0825701001,Santa Maria de Miralles,1,1,16714
0825801001,Santa Maria d'Oló,1,1,16580
0825901001,Santa Maria de Palautordera,1,1,15343
0825901002,Santa Maria de Palautordera,1,2,18414
0825901003,Santa Maria de Palautordera,1,3,19062
0825901004,Santa Maria de Palautordera,1,4,19143
0826001001,Santa Perpètua de Mogoda,1,1,15046
0826001002,Santa Perpètua de Mogoda,1,2,16134
0826001003,Santa Perpètua de Mogoda,1,3,17206
0826001004,Santa Perpètua de Mogoda,1,4,10940
0826001005,Santa Perpètua de Mogoda,1,5,12831
0826001006,Santa Perpètua de Mogoda,1,6,14576
0826001007,Santa Perpètua de Mogoda,1,7,17707
0826001008,Santa Perpètua de Mogoda,1,8,17726
0826001009,Santa Perpètua de Mogoda,1,9,18759
0826001010,Santa Perpètua de Mogoda,1,10,18266
0826001011,Santa Perpètua de Mogoda,1,11,17155
0826001012,Santa Perpètua de Mogoda,1,12,16113
0826001013,Santa Perpètua de Mogoda,1,13,21085
0826001014,Santa Perpètua de Mogoda,1,14,16972
0826001015,Santa Perpètua de Mogoda,1,15,16067
0826001016,Santa Perpètua de Mogoda,1,16,18981
0826101001,Santa Susanna,1,1,17816
0826101002,Santa Susanna,1,2,15348
0826201001,Sant Vicenç de Castellet,1,1,14738
0826201002,Sant Vicenç de Castellet,1,2,15233
0826201003,Sant Vicenç de Castellet,1,3,15829
0826202001,Sant Vicenç de Castellet,2,1,14470
0826202002,Sant Vicenç de Castellet,2,2,13769
0826301001,Sant Vicenç dels Horts,1,1,17764
0826301002,Sant Vicenç dels Horts,1,2,17295
0826301003,Sant Vicenç dels Horts,1,3,17044
0826301004,Sant Vicenç dels Horts,1,4,17270
0826301005,Sant Vicenç dels Horts,1,5,17512
0826301006,Sant Vicenç dels Horts,1,6,15461
0826301007,Sant Vicenç dels Horts,1,7,15927
0826301008,Sant Vicenç dels Horts,1,8,15521
0826301009,Sant Vicenç dels Horts,1,9,15186
0826301010,Sant Vicenç dels Horts,1,10,15248
0826301011,Sant Vicenç dels Horts,1,11,16250
0826301012,Sant Vicenç dels Horts,1,12,13421
0826302001,Sant Vicenç dels Horts,2,1,12809
0826302002,Sant Vicenç dels Horts,2,2,14171
0826302003,Sant Vicenç dels Horts,2,3,14662
0826303001,Sant Vicenç dels Horts,3,1,14901
0826303002,Sant Vicenç dels Horts,3,2,15034
0826304001,Sant Vicenç dels Horts,4,1,16412
0826304002,Sant Vicenç dels Horts,4,2,17528
0826304003,Sant Vicenç dels Horts,4,3,18087
0826401001,Sant Vicenç de Montalt,1,1,26461
0826401002,Sant Vicenç de Montalt,1,2,21698
0826401003,Sant Vicenç de Montalt,1,3,23842
0826401004,Sant Vicenç de Montalt,1,4,27477
0826501001,Sant Vicenç de Torelló,1,1,18436
0826601001,Cerdanyola del Vallès,1,1,15936
0826601002,Cerdanyola del Vallès,1,2,17645
0826601003,Cerdanyola del Vallès,1,3,16179
0826601004,Cerdanyola del Vallès,1,4,14058
0826601005,Cerdanyola del Vallès,1,5,14062
0826601006,Cerdanyola del Vallès,1,6,20053
0826601007,Cerdanyola del Vallès,1,7,20879
0826601008,Cerdanyola del Vallès,1,8,17549
0826601009,Cerdanyola del Vallès,1,9,19023
0826601010,Cerdanyola del Vallès,1,10,19500
0826601011,Cerdanyola del Vallès,1,11,19145
0826601012,Cerdanyola del Vallès,1,12,16479
0826601013,Cerdanyola del Vallès,1,13,21389
0826601014,Cerdanyola del Vallès,1,14,21862
0826601015,Cerdanyola del Vallès,1,15,15183
0826601016,Cerdanyola del Vallès,1,16,16284
0826601017,Cerdanyola del Vallès,1,17,14123
0826601018,Cerdanyola del Vallès,1,18,18038
0826601019,Cerdanyola del Vallès,1,19,16627
0826601020,Cerdanyola del Vallès,1,20,33718
0826601027,Cerdanyola del Vallès,1,27,14307
0826601028,Cerdanyola del Vallès,1,28,24729
0826601029,Cerdanyola del Vallès,1,29,22053
0826601030,Cerdanyola del Vallès,1,30,20798
0826601031,Cerdanyola del Vallès,1,31,15762
0826601032,Cerdanyola del Vallès,1,32,22875
0826601033,Cerdanyola del Vallès,1,33,15643
0826601034,Cerdanyola del Vallès,1,34,17888
0826601035,Cerdanyola del Vallès,1,35,21261
0826601036,Cerdanyola del Vallès,1,36,18655
0826601037,Cerdanyola del Vallès,1,37,19364
0826601038,Cerdanyola del Vallès,1,38,18035
0826601039,Cerdanyola del Vallès,1,39,17461
0826601040,Cerdanyola del Vallès,1,40,35709
0826701001,Sentmenat,1,1,17870
0826701002,Sentmenat,1,2,16773
0826701003,Sentmenat,1,3,16631
0826701004,Sentmenat,1,4,17459
0826701005,Sentmenat,1,5,17535
0826801001,Cercs,1,1,16459
0826801002,,,,
0826901001,Seva,1,1,21679
0826901002,Seva,1,2,17057
0827001001,Sitges,1,1,19606
0827001002,Sitges,1,2,19322
0827001003,Sitges,1,3,33960
0827001004,Sitges,1,4,21815
0827001005,Sitges,1,5,25588
0827001006,Sitges,1,6,26561
0827002001,Sitges,2,1,18617
0827002002,Sitges,2,2,22731
0827002003,Sitges,2,3,20351
0827002004,Sitges,2,4,16620
0827002005,Sitges,2,5,15846
0827002006,Sitges,2,6,19566
0827002007,Sitges,2,7,25914
0827002009,Sitges,2,9,27904
0827002010,Sitges,2,10,25176
0827002011,Sitges,2,11,19209
0827101001,Sobremunt,1,1,.
0827201001,Sora,1,1,16905
0827301001,Subirats,1,1,18028
0827301002,Subirats,1,2,17307
0827301003,Subirats,1,3,18380
0827401001,Súria,1,1,16806
0827401002,Súria,1,2,15285
0827401004,Súria,1,4,17549
0827401005,Súria,1,5,18440
0827501001,Tavèrnoles,1,1,.
0827601001,Tagamanent,1,1,18000
0827701001,Talamanca,1,1,18411
0827801001,Taradell,1,1,18150
0827801002,Taradell,1,2,18201
0827801003,Taradell,1,3,22304
0827801004,Taradell,1,4,18974
0827901001,Terrassa,1,1,23797
0827901002,Terrassa,1,2,23053
0827901004,Terrassa,1,4,22197
0827901005,Terrassa,1,5,22532
0827901006,Terrassa,1,6,23205
0827901007,Terrassa,1,7,23054
0827901008,Terrassa,1,8,25757
0827901009,Terrassa,1,9,22658
0827901010,Terrassa,1,10,23060
0827901011,Terrassa,1,11,16434
0827901012,Terrassa,1,12,17030
0827901013,Terrassa,1,13,14280
0827901014,Terrassa,1,14,15122
0827901015,Terrassa,1,15,15905
0827901016,Terrassa,1,16,18354
0827901017,Terrassa,1,17,19545
0827901018,Terrassa,1,18,20751
0827901019,Terrassa,1,19,16238
0827901020,Terrassa,1,20,22674
0827901021,Terrassa,1,21,18860
0827901022,Terrassa,1,22,18901
0827901023,Terrassa,1,23,21198
0827901024,Terrassa,1,24,25521
0827901025,Terrassa,1,25,23285
0827902001,Terrassa,2,1,11236
0827902002,,,,
0827902003,Terrassa,2,3,9243
0827902004,Terrassa,2,4,8766
0827902005,Terrassa,2,5,11139
0827902006,Terrassa,2,6,12399
0827902008,Terrassa,2,8,12673
0827902009,Terrassa,2,9,11671
0827902011,Terrassa,2,11,12794
0827902012,Terrassa,2,12,8475
0827902014,Terrassa,2,14,15283
0827902015,Terrassa,2,15,8945
0827902016,Terrassa,2,16,16097
0827902017,Terrassa,2,17,12387
0827903001,Terrassa,3,1,15651
0827903002,Terrassa,3,2,15882
0827903003,Terrassa,3,3,13308
0827903004,Terrassa,3,4,13612
0827903005,Terrassa,3,5,16701
0827903006,Terrassa,3,6,19275
0827903007,Terrassa,3,7,17622
0827903008,Terrassa,3,8,13887
0827903009,,,,
0827903010,,,,
0827903011,,,,
0827903012,,,,
0827903014,Terrassa,3,14,12237
0827903015,Terrassa,3,15,14001
0827903016,Terrassa,3,16,10552
0827903017,Terrassa,3,17,11901
0827903018,Terrassa,3,18,13534
0827903019,Terrassa,3,19,11389
0827903020,Terrassa,3,20,14724
0827904001,Terrassa,4,1,22115
0827904002,Terrassa,4,2,18445
0827904003,Terrassa,4,3,18319
0827904004,Terrassa,4,4,16267
0827904005,Terrassa,4,5,16017
0827904006,Terrassa,4,6,14245
0827904007,Terrassa,4,7,14146
0827904008,Terrassa,4,8,14284
0827904009,Terrassa,4,9,12881
0827904010,Terrassa,4,10,9740
0827904012,Terrassa,4,12,16173
0827904013,Terrassa,4,13,18421
0827904014,Terrassa,4,14,20527
0827904015,Terrassa,4,15,20101
0827904016,Terrassa,4,16,21500
0827904017,Terrassa,4,17,19809
0827904018,Terrassa,4,18,16612
0827904019,Terrassa,4,19,14797
0827904020,Terrassa,4,20,10493
0827904021,Terrassa,4,21,12306
0827904022,Terrassa,4,22,16240
0827904023,Terrassa,4,23,16401
0827904024,Terrassa,4,24,16836
0827904025,Terrassa,4,25,15468
0827904026,Terrassa,4,26,19702
0827905001,Terrassa,5,1,18499
0827905002,Terrassa,5,2,14971
0827905003,Terrassa,5,3,16530
0827905004,Terrassa,5,4,17758
0827905005,Terrassa,5,5,17441
0827905006,Terrassa,5,6,18687
0827905007,Terrassa,5,7,19378
0827905008,Terrassa,5,8,19068
0827905009,Terrassa,5,9,18081
0827905010,Terrassa,5,10,12581
0827905011,Terrassa,5,11,17002
0827905012,Terrassa,5,12,15230
0827905013,Terrassa,5,13,15215
0827905014,Terrassa,5,14,14453
0827905015,Terrassa,5,15,14078
0827905016,Terrassa,5,16,15314
0827905017,Terrassa,5,17,18994
0827905018,Terrassa,5,18,15354
0827905019,Terrassa,5,19,18969
0827905020,Terrassa,5,20,17799
0827905021,Terrassa,5,21,16462
0827905022,Terrassa,5,22,16413
0827905023,Terrassa,5,23,19951
0827905024,Terrassa,5,24,19637
0827905025,Terrassa,5,25,17798
0827905026,Terrassa,5,26,19608
0827905027,Terrassa,5,27,19034
0827905028,Terrassa,5,28,18169
0827905029,Terrassa,5,29,17954
0827905030,Terrassa,5,30,15121
0827905031,Terrassa,5,31,14371
0827905032,Terrassa,5,32,15954
0827906001,Terrassa,6,1,14477
0827906002,Terrassa,6,2,13601
0827906003,Terrassa,6,3,13203
0827906004,Terrassa,6,4,11489
0827906005,Terrassa,6,5,14211
0827906006,Terrassa,6,6,15372
0827906008,Terrassa,6,8,16038
0827906009,Terrassa,6,9,14307
0827906010,Terrassa,6,10,15706
0827906011,Terrassa,6,11,12557
0827906012,Terrassa,6,12,13418
0827906013,Terrassa,6,13,13503
0827906014,Terrassa,6,14,11532
0827906016,Terrassa,6,16,13407
0827906018,Terrassa,6,18,11782
0827906020,Terrassa,6,20,10347
0827906023,Terrassa,6,23,13653
0827906024,Terrassa,6,24,13535
0827906025,Terrassa,6,25,13317
0827906026,Terrassa,6,26,14113
0827906027,Terrassa,6,27,13250
0827906028,Terrassa,6,28,16202
0827906029,Terrassa,6,29,14727
0827906030,Terrassa,6,30,15681
0827906031,Terrassa,6,31,13227
0827906032,Terrassa,6,32,16764
0827906033,Terrassa,6,33,17839
0827907001,Terrassa,7,1,18985
0827907002,Terrassa,7,2,13802
0827907003,Terrassa,7,3,11155
0827907004,Terrassa,7,4,17530
0827907005,Terrassa,7,5,18070
0828001001,Tavertet,1,1,20157
0828101001,Teià,1,1,22969
0828101002,Teià,1,2,24456
0828101003,Teià,1,3,27541
0828201001,Tiana,1,1,22962
0828201002,Tiana,1,2,26523
0828201003,Tiana,1,3,21878
0828201004,Tiana,1,4,26784
0828201005,Tiana,1,5,28275
0828301001,Tona,1,1,15752
0828301002,Tona,1,2,22461
0828301003,Tona,1,3,17462
0828301004,Tona,1,4,16647
0828401001,Tordera,1,1,14060
0828401002,Tordera,1,2,13671
0828401003,Tordera,1,3,14080
0828401004,Tordera,1,4,14452
0828402001,Tordera,2,1,13759
0828402002,Tordera,2,2,14584
0828402003,Tordera,2,3,15673
0828501001,Torelló,1,1,15332
0828501002,Torelló,1,2,17591
0828501004,Torelló,1,4,16083
0828502001,Torelló,2,1,18038
0828502002,Torelló,2,2,16608
0828503001,Torelló,3,1,15821
0828503002,Torelló,3,2,14872
0828503003,Torelló,3,3,16996
0828601001,La Torre de Claramunt,1,1,17438
0828601002,La Torre de Claramunt,1,2,13980
0828701001,Torrelavit,1,1,18140
0828801001,Torrelles de Foix,1,1,13232
0828901001,Torrelles de Llobregat,1,1,18590
0828901002,Torrelles de Llobregat,1,2,19885
0828901003,Torrelles de Llobregat,1,3,20220
0828901004,Torrelles de Llobregat,1,4,19635
0829001001,Ullastrell,1,1,19021
0829101001,Vacarisses,1,1,18752
0829101002,Vacarisses,1,2,18287
0829101003,Vacarisses,1,3,16320
0829101004,Vacarisses,1,4,15570
0829201001,Vallbona d'Anoia,1,1,16781
0829301001,Vallcebre,1,1,21592
0829401001,Vallgorguina,1,1,17280
0829401002,Vallgorguina,1,2,17898
0829501001,Vallirana,1,1,15731
0829501002,Vallirana,1,2,15861
0829501003,Vallirana,1,3,20878
0829501004,Vallirana,1,4,20524
0829501005,Vallirana,1,5,16408
0829501006,Vallirana,1,6,18192
0829501007,Vallirana,1,7,18950
0829501008,Vallirana,1,8,18094
0829501009,Vallirana,1,9,14545
0829501010,Vallirana,1,10,18489
0829601001,Vallromanes,1,1,23663
0829701001,Veciana,1,1,14788
0829801001,Vic,1,1,16893
0829802001,Vic,2,1,15100
0829802002,Vic,2,2,20193
0829802003,Vic,2,3,18476
0829802004,Vic,2,4,14385
0829802005,Vic,2,5,17561
0829802006,Vic,2,6,15977
0829803001,Vic,3,1,22871
0829803003,Vic,3,3,13541
0829803004,Vic,3,4,14333
0829803005,Vic,3,5,10775
0829803006,Vic,3,6,12290
0829803007,Vic,3,7,19637
0829803008,Vic,3,8,11758
0829803009,Vic,3,9,16672
0829803010,Vic,3,10,20879
0829803011,Vic,3,11,10965
0829803012,Vic,3,12,21014
0829803013,Vic,3,13,17111
0829804001,Vic,4,1,15946
0829804002,Vic,4,2,14339
0829804003,Vic,4,3,17038
0829804004,Vic,4,4,14749
0829805001,Vic,5,1,18617
0829901001,Vilada,1,1,17203
0830001001,Viladecavalls,1,1,21833
0830001002,Viladecavalls,1,2,16962
0830001003,Viladecavalls,1,3,19923
0830001004,Viladecavalls,1,4,21749
0830001005,,,,
0830001006,Viladecavalls,1,6,20163
0830101001,Viladecans,1,1,14349
0830101002,Viladecans,1,2,19950
0830101003,Viladecans,1,3,16535
0830101004,Viladecans,1,4,17471
0830101005,Viladecans,1,5,17978
0830101006,Viladecans,1,6,16345
0830101007,Viladecans,1,7,15374
0830101008,Viladecans,1,8,16168
0830101009,Viladecans,1,9,16545
0830101010,Viladecans,1,10,14036
0830101011,Viladecans,1,11,18654
0830101012,Viladecans,1,12,19821
0830101013,Viladecans,1,13,19353
0830101014,Viladecans,1,14,16623
0830101015,Viladecans,1,15,14189
0830101016,Viladecans,1,16,21185
0830101017,Viladecans,1,17,14008
0830101018,Viladecans,1,18,19459
0830102001,Viladecans,2,1,12926
0830102002,Viladecans,2,2,13621
0830102003,Viladecans,2,3,21073
0830102004,Viladecans,2,4,14399
0830102005,Viladecans,2,5,19268
0830102006,Viladecans,2,6,14114
0830102007,Viladecans,2,7,13935
0830102008,Viladecans,2,8,16777
0830102009,Viladecans,2,9,13240
0830102010,Viladecans,2,10,15107
0830102011,Viladecans,2,11,15479
0830102012,Viladecans,2,12,15158
0830102013,Viladecans,2,13,14729
0830102014,Viladecans,2,14,15026
0830102015,Viladecans,2,15,14832
0830102016,Viladecans,2,16,17775
0830102017,Viladecans,2,17,16054
0830102018,Viladecans,2,18,11944
0830102019,Viladecans,2,19,13005
0830102020,Viladecans,2,20,18712
0830102021,Viladecans,2,21,15084
0830102022,Viladecans,2,22,16802
0830102023,Viladecans,2,23,20987
0830102024,Viladecans,2,24,17711
0830102025,Viladecans,2,25,16614
0830102026,Viladecans,2,26,18836
0830102027,Viladecans,2,27,18418
0830102028,Viladecans,2,28,18769
0830102029,Viladecans,2,29,20241
0830201001,Vilanova del Camí,1,1,13885
0830201002,Vilanova del Camí,1,2,14085
0830201003,Vilanova del Camí,1,3,14087
0830201004,Vilanova del Camí,1,4,14415
0830201005,Vilanova del Camí,1,5,13650
0830201006,Vilanova del Camí,1,6,14316
0830201007,Vilanova del Camí,1,7,14847
0830301001,Vilanova de Sau,1,1,17437
0830401001,Vilobí del Penedès,1,1,18229
0830501001,Vilafranca del Penedès,1,1,15032
0830501002,Vilafranca del Penedès,1,2,13739
0830501003,Vilafranca del Penedès,1,3,16286
0830502001,Vilafranca del Penedès,2,1,12232
0830502002,Vilafranca del Penedès,2,2,16238
0830502003,Vilafranca del Penedès,2,3,12564
0830502004,Vilafranca del Penedès,2,4,13126
0830502005,Vilafranca del Penedès,2,5,16688
0830502006,Vilafranca del Penedès,2,6,12965
0830503001,Vilafranca del Penedès,3,1,14859
0830503002,Vilafranca del Penedès,3,2,15263
0830503003,Vilafranca del Penedès,3,3,16600
0830503004,Vilafranca del Penedès,3,4,20925
0830504001,Vilafranca del Penedès,4,1,18413
0830504002,Vilafranca del Penedès,4,2,17822
0830504003,Vilafranca del Penedès,4,3,15678
0830504004,Vilafranca del Penedès,4,4,17451
0830504005,Vilafranca del Penedès,4,5,18664
0830504006,Vilafranca del Penedès,4,6,17691
0830504007,Vilafranca del Penedès,4,7,21247
0830504008,Vilafranca del Penedès,4,8,16336
0830504009,Vilafranca del Penedès,4,9,17366
0830601001,Vilalba Sasserra,1,1,15122
0830701001,Vilanova i la Geltrú,1,1,17212
0830701002,Vilanova i la Geltrú,1,2,19238
0830701003,Vilanova i la Geltrú,1,3,17928
0830701004,Vilanova i la Geltrú,1,4,19523
0830701005,Vilanova i la Geltrú,1,5,19162
0830701006,Vilanova i la Geltrú,1,6,17265
0830701007,Vilanova i la Geltrú,1,7,16632
0830701008,Vilanova i la Geltrú,1,8,17547
0830701009,Vilanova i la Geltrú,1,9,22508
0830701010,Vilanova i la Geltrú,1,10,18815
0830701011,Vilanova i la Geltrú,1,11,15998
0830702001,Vilanova i la Geltrú,2,1,21704
0830702002,Vilanova i la Geltrú,2,2,17464
0830702003,Vilanova i la Geltrú,2,3,19335
0830702004,Vilanova i la Geltrú,2,4,17262
0830702005,,,,
0830702006,Vilanova i la Geltrú,2,6,16249
0830702007,Vilanova i la Geltrú,2,7,15362
0830702008,Vilanova i la Geltrú,2,8,24663
0830703001,Vilanova i la Geltrú,3,1,17088
0830703002,Vilanova i la Geltrú,3,2,18397
0830703003,Vilanova i la Geltrú,3,3,15977
0830703004,Vilanova i la Geltrú,3,4,14490
0830703005,Vilanova i la Geltrú,3,5,12253
0830704001,Vilanova i la Geltrú,4,1,18757
0830704002,Vilanova i la Geltrú,4,2,15909
0830704003,Vilanova i la Geltrú,4,3,16483
0830704004,Vilanova i la Geltrú,4,4,14964
0830704005,Vilanova i la Geltrú,4,5,17245
0830704006,Vilanova i la Geltrú,4,6,15213
0830704007,Vilanova i la Geltrú,4,7,17465
0830704008,Vilanova i la Geltrú,4,8,12186
0830704009,Vilanova i la Geltrú,4,9,15791
0830704010,Vilanova i la Geltrú,4,10,17191
0830704011,Vilanova i la Geltrú,4,11,14283
0830704012,Vilanova i la Geltrú,4,12,18443
0830704013,Vilanova i la Geltrú,4,13,19870
0830704014,Vilanova i la Geltrú,4,14,19816
0830704015,Vilanova i la Geltrú,4,15,18218
0830704016,Vilanova i la Geltrú,4,16,11105
0830704017,Vilanova i la Geltrú,4,17,17832
0830801001,Viver i Serrateix,1,1,19756
0890101001,Rupit i Pruit,1,1,19636
0890201001,Vilanova del Vallès,1,1,18523
0890201002,Vilanova del Vallès,1,2,19213
0890201003,Vilanova del Vallès,1,3,19770
0890301001,Sant Julià de Cerdanyola,1,1,20281
0890401001,Badia del Vallès,1,1,14503
0890401002,Badia del Vallès,1,2,11358
0890401003,Badia del Vallès,1,3,12803
0890401004,Badia del Vallès,1,4,12203
0890401005,Badia del Vallès,1,5,12562
0890401006,Badia del Vallès,1,6,14280
0890401007,Badia del Vallès,1,7,13299
0890401008,Badia del Vallès,1,8,12482
0890401009,Badia del Vallès,1,9,13296
0890401010,Badia del Vallès,1,10,15337
0890401011,Badia del Vallès,1,11,14431
0890401012,Badia del Vallès,1,12,14161
0890501001,La Palma de Cervelló,1,1,22146
0890501002,La Palma de Cervelló,1,2,18592
1700101001,Agullana,1,1,19880
1700201001,Aiguaviva,1,1,20784
1700301001,Albanyà,1,1,12691
1700401001,Albons,1,1,17611
1700501001,El Far d'Empordà,1,1,16641
1700601001,Alp,1,1,20608
1700701001,Amer,1,1,16544
1700801001,Anglès,1,1,13035
1700801002,Anglès,1,2,15546
1700801003,Anglès,1,3,15925
1700901001,Arbúcies,1,1,13280
1700901002,Arbúcies,1,2,15238
1700902001,Arbúcies,2,1,19793
1701001001,Argelaguer,1,1,17295
1701101001,L'Armentera,1,1,17768
1701201001,Avinyonet de Puigventós,1,1,16901
1701301001,Begur,1,1,20122
1701301002,Begur,1,2,19300
1701301003,Begur,1,3,20773
1701401001,La Vajol,1,1,.
1701501001,Banyoles,1,1,15744
1701501002,Banyoles,1,2,17312
1701501003,Banyoles,1,3,16093
1701501004,Banyoles,1,4,14364
1701501005,Banyoles,1,5,15947
1701502001,Banyoles,2,1,22198
1701502002,Banyoles,2,2,19090
1701502003,Banyoles,2,3,19107
1701502004,Banyoles,2,4,17177
1701502005,Banyoles,2,5,21036
1701503001,Banyoles,3,1,17751
1701503002,Banyoles,3,2,12481
1701601001,Bàscara,1,1,16387
1701801001,Bellcaire d'Empordà,1,1,17165
1701901001,Besalú,1,1,17255
1702001001,Bescanó,1,1,17655
1702001002,Bescanó,1,2,19093
1702001003,Bescanó,1,3,17215
1702101001,Beuda,1,1,15925
1702201002,La Bisbal d'Empordà,1,2,14033
1702201003,La Bisbal d'Empordà,1,3,13792
1702201004,La Bisbal d'Empordà,1,4,16508
1702202001,La Bisbal d'Empordà,2,1,13591
1702202002,La Bisbal d'Empordà,2,2,12002
1702202003,La Bisbal d'Empordà,2,3,14007
1702301001,Blanes,1,1,19146
1702301002,Blanes,1,2,17826
1702301004,Blanes,1,4,14291
1702301006,Blanes,1,6,14142
1702301007,Blanes,1,7,26599
1702302001,Blanes,2,1,15248
1702302002,Blanes,2,2,14103
1702302003,Blanes,2,3,12383
1702302004,Blanes,2,4,14204
1702302005,Blanes,2,5,14654
1702302006,Blanes,2,6,18216
1702302007,Blanes,2,7,13152
1702302008,Blanes,2,8,18593
1702302009,Blanes,2,9,14715
1702302010,Blanes,2,10,11399
1702302011,Blanes,2,11,15337
1702302012,Blanes,2,12,13417
1702302013,Blanes,2,13,16029
1702303001,Blanes,3,1,13277
1702303002,Blanes,3,2,13274
1702303003,Blanes,3,3,13812
1702303004,Blanes,3,4,13635
1702401001,Bolvir,1,1,25944
1702501001,Bordils,1,1,18593
1702601001,Borrassà,1,1,19470
1702701001,Breda,1,1,15562
1702701002,Breda,1,2,17593
1702801001,Brunyola i Sant Martí Sapresa,1,1,20266
1702901001,Boadella i les Escaules,1,1,17280
1703001001,Cabanes,1,1,15079
1703101001,Cabanelles,1,1,13892
1703201001,Cadaqués,1,1,17070
1703301001,Caldes de Malavella,1,1,16609
1703301002,Caldes de Malavella,1,2,20169
1703301003,Caldes de Malavella,1,3,17115
1703301004,Caldes de Malavella,1,4,16346
1703401001,Calonge i Sant Antoni,1,1,14374
1703401002,Calonge i Sant Antoni,1,2,16169
1703401003,Calonge i Sant Antoni,1,3,18733
1703401004,Calonge i Sant Antoni,1,4,16439
1703401005,Calonge i Sant Antoni,1,5,19040
1703501001,Camós,1,1,19581
1703601001,Campdevànol,1,1,17653
1703601002,Campdevànol,1,2,16161
1703601003,Campdevànol,1,3,20083
1703701001,Campelles,1,1,21736
1703801001,Campllong,1,1,20450
1703901001,Camprodon,1,1,17372
1703901002,Camprodon,1,2,19173
1704001001,Canet d'Adri,1,1,19000
1704101001,Cantallops,1,1,15435
1704201001,Capmany,1,1,17127
1704301001,Queralbs,1,1,21134
1704401001,Cassà de la Selva,1,1,20956
1704401002,Cassà de la Selva,1,2,16046
1704402001,Cassà de la Selva,2,1,14727
1704402002,Cassà de la Selva,2,2,15498
1704402003,Cassà de la Selva,2,3,17665
1704601001,Castellfollit de la Roca,1,1,16389
1704701001,Castelló d'Empúries,1,1,13646
1704701002,Castelló d'Empúries,1,2,16484
1704701003,Castelló d'Empúries,1,3,13540
1704701004,Castelló d'Empúries,1,4,11542
1704801001,Castell-Platja d'Aro,1,1,16722
1704801002,Castell-Platja d'Aro,1,2,15270
1704801003,Castell-Platja d'Aro,1,3,15290
1704801004,Castell-Platja d'Aro,1,4,16225
1704801005,Castell-Platja d'Aro,1,5,21265
1704801006,Castell-Platja d'Aro,1,6,14539
1704901001,Celrà,1,1,19397
1704901002,Celrà,1,2,15353
1704901003,Celrà,1,3,16295
1705001001,Cervià de Ter,1,1,18182
1705101001,Cistella,1,1,17502
1705201001,Siurana,1,1,18273
1705401001,Colera,1,1,20360
1705501001,Colomers,1,1,19991
1705601001,Cornellà del Terri,1,1,17671
1705701001,Corçà,1,1,17798
1705801001,Crespià,1,1,15337
1706001001,Darnius,1,1,15529
1706101001,Das,1,1,24467
1706201001,L'Escala,1,1,16949
1706201002,L'Escala,1,2,15265
1706201003,L'Escala,1,3,17413
1706201004,L'Escala,1,4,13573
1706201005,L'Escala,1,5,16869
1706301001,Espinelves,1,1,19255
1706401001,Espolla,1,1,19734
1706501001,Esponellà,1,1,21139
1706601001,Figueres,1,1,14147
1706601002,Figueres,1,2,17767
1706601003,Figueres,1,3,16654
1706601004,Figueres,1,4,13893
1706601005,Figueres,1,5,6427
1706601006,Figueres,1,6,9911
1706601007,Figueres,1,7,11281
1706601008,Figueres,1,8,12388
1706602001,Figueres,2,1,13101
1706602002,Figueres,2,2,12460
1706602003,Figueres,2,3,15461
1706602004,Figueres,2,4,13324
1706602005,,,,
1706603001,Figueres,3,1,13963
1706603002,Figueres,3,2,14009
1706603003,Figueres,3,3,13731
1706603004,Figueres,3,4,8564
1706603005,Figueres,3,5,13284
1706604001,Figueres,4,1,13980
1706604002,Figueres,4,2,14491
1706604003,Figueres,4,3,14063
1706604004,Figueres,4,4,13953
1706604005,Figueres,4,5,11021
1706604007,Figueres,4,7,16302
1706604008,Figueres,4,8,13596
1706604009,Figueres,4,9,16114
1706701001,Flaçà,1,1,16241
1706801001,Foixà,1,1,27415
1706901001,Fontanals de Cerdanya,1,1,.
1707001001,Fontanilles,1,1,21254
1707101001,Fontcoberta,1,1,19348
1707301001,Fornells de la Selva,1,1,21386
1707301002,Fornells de la Selva,1,2,26927
1707401001,Fortià,1,1,17339
1707501001,Garrigàs,1,1,19206
1707601001,Garrigoles,1,1,19448
1707701001,Garriguella,1,1,17054
1707801001,Ger,1,1,24472
1707901001,Girona,1,1,20242
1707901002,Girona,1,2,18092
1707901003,Girona,1,3,19704
1707901004,Girona,1,4,14815
1707901005,Girona,1,5,6387
1707901006,Girona,1,6,10459
1707902001,Girona,2,1,23933
1707902002,Girona,2,2,22245
1707902003,Girona,2,3,24042
1707902004,Girona,2,4,23514
1707902005,Girona,2,5,23953
1707902006,Girona,2,6,20955
1707902007,Girona,2,7,23862
1707902008,Girona,2,8,22882
1707902009,Girona,2,9,18439
1707902010,Girona,2,10,19530
1707902011,Girona,2,11,16916
1707902012,Girona,2,12,23976
1707902013,Girona,2,13,19367
1707902014,Girona,2,14,14939
1707902015,Girona,2,15,27351
1707902016,Girona,2,16,28506
1707902017,Girona,2,17,23654
1707902018,Girona,2,18,20885
1707902019,Girona,2,19,20608
1707902020,Girona,2,20,23685
1707902021,Girona,2,21,19478
1707902022,Girona,2,22,15913
1707903001,Girona,3,1,22081
1707903002,Girona,3,2,25021
1707903003,Girona,3,3,21371
1707903004,Girona,3,4,24475
1707903005,Girona,3,5,24270
1707903006,Girona,3,6,17232
1707903007,Girona,3,7,12649
1707903008,Girona,3,8,13765
1707903009,Girona,3,9,10098
1707903010,Girona,3,10,13586
1707903011,Girona,3,11,12040
1707903012,Girona,3,12,12438
1707903013,Girona,3,13,11114
1707903014,Girona,3,14,11157
1707903015,Girona,3,15,14188
1707903016,Girona,3,16,15710
1707903017,Girona,3,17,14368
1707903018,Girona,3,18,13223
1707903019,Girona,3,19,21881
1707903020,Girona,3,20,20341
1707903021,Girona,3,21,13493
1707904001,Girona,4,1,19027
1707904002,Girona,4,2,18032
1707905001,Girona,5,1,28894
1707905002,Girona,5,2,14592
1707905003,Girona,5,3,13734
1707905004,Girona,5,4,19767
1707905005,Girona,5,5,12458
1707905006,Girona,5,6,23243
1707906001,Girona,6,1,18168
1707906002,Girona,6,2,15521
1707906003,Girona,6,3,16252
1707906004,Girona,6,4,18741
1707906005,Girona,6,5,14139
1708001001,Gombrèn,1,1,18598
1708101001,Gualta,1,1,.
1708201001,Guils de Cerdanya,1,1,21967
1708301001,Hostalric,1,1,14239
1708301002,Hostalric,1,2,16096
1708301003,Hostalric,1,3,14039
1708401001,Isòvol,1,1,22974
1708501001,Jafre,1,1,18624
1708601001,La Jonquera,1,1,14780
1708601002,La Jonquera,1,2,14477
1708701001,Juià,1,1,17993
1708801001,Lladó,1,1,17192
1708901001,Llagostera,1,1,12301
1708901002,Llagostera,1,2,15074
1708901003,Llagostera,1,3,16192
1708901004,Llagostera,1,4,15355
1709001001,Llambilles,1,1,25122
1709101001,Llanars,1,1,17934
1709201001,Llançà,1,1,19405
1709201002,Llançà,1,2,15879
1709201003,Llançà,1,3,13782
1709301001,Llers,1,1,17321
1709401001,Llívia,1,1,19285
1709501001,Lloret de Mar,1,1,13030
1709501002,Lloret de Mar,1,2,12364
1709501003,Lloret de Mar,1,3,12308
1709501004,Lloret de Mar,1,4,13088
1709502001,Lloret de Mar,2,1,11473
1709502002,Lloret de Mar,2,2,11870
1709502003,Lloret de Mar,2,3,14145
1709503001,Lloret de Mar,3,1,15108
1709503002,Lloret de Mar,3,2,15459
1709503003,Lloret de Mar,3,3,12305
1709503004,Lloret de Mar,3,4,14144
1709504001,Lloret de Mar,4,1,14470
1709504002,Lloret de Mar,4,2,12292
1709504003,Lloret de Mar,4,3,14828
1709504004,Lloret de Mar,4,4,14415
1709601001,Les Llosses,1,1,16834
1709701001,Madremanya,1,1,20480
1709801001,Maià de Montcal,1,1,17043
1709901001,Meranges,1,1,17456
1710001001,Masarac,1,1,17248
1710101001,Massanes,1,1,13389
1710201001,Maçanet de Cabrenys,1,1,15485
1710301001,Maçanet de la Selva,1,1,16827
1710301002,Maçanet de la Selva,1,2,13168
1710301003,Maçanet de la Selva,1,3,15898
1710301004,Maçanet de la Selva,1,4,14437
1710501001,Mieres,1,1,16538
1710601001,Mollet de Peralada,1,1,19015
1710701001,Molló,1,1,16566
1710901001,Montagut i Oix,1,1,17128
1711001001,Mont-ras,1,1,17051
1711101001,Navata,1,1,18631
1711201001,Ogassa,1,1,19506
1711401001,Olot,1,1,12447
1711401002,Olot,1,2,15469
1711401003,Olot,1,3,21938
1711401004,Olot,1,4,24682
1711401005,Olot,1,5,18957
1711401006,Olot,1,6,13997
1711401007,Olot,1,7,16196
1711402001,Olot,2,1,17201
1711402002,Olot,2,2,17712
1711402003,Olot,2,3,14045
1711402004,Olot,2,4,13551
1711402005,Olot,2,5,14751
1711403001,Olot,3,1,15059
1711403002,Olot,3,2,19480
1711403003,Olot,3,3,16975
1711404001,Olot,4,1,12377
1711404002,Olot,4,2,11954
1711405001,Olot,5,1,16370
1711405002,Olot,5,2,20101
1711405003,Olot,5,3,16338
1711405004,Olot,5,4,18300
1711501001,Ordis,1,1,17538
1711601001,Osor,1,1,16897
1711701001,Palafrugell,1,1,13534
1711701002,Palafrugell,1,2,16134
1711701003,Palafrugell,1,3,11451
1711701004,Palafrugell,1,4,15389
1711701005,Palafrugell,1,5,11775
1711702001,Palafrugell,2,1,15310
1711702002,Palafrugell,2,2,12383
1711702003,Palafrugell,2,3,19351
1711703001,Palafrugell,3,1,13231
1711703002,Palafrugell,3,2,15698
1711703003,Palafrugell,3,3,13017
1711801001,Palamós,1,1,16373
1711801002,Palamós,1,2,16995
1711801003,Palamós,1,3,14231
1711801004,Palamós,1,4,14991
1711802001,Palamós,2,1,18425
1711802002,Palamós,2,2,17193
1711803001,Palamós,3,1,15367
1711803002,Palamós,3,2,15527
1711803003,Palamós,3,3,16963
1711804001,Palamós,4,1,13986
1711804002,Palamós,4,2,17467
1711901001,Palau de Santa Eulàlia,1,1,25409
1712001001,Palau-saverdera,1,1,16427
1712101001,Palau-sator,1,1,22982
1712301001,Palol de Revardit,1,1,19161
1712401001,Pals,1,1,19025
1712501001,Pardines,1,1,17010
1712601001,Parlavà,1,1,19282
1712801001,Pau,1,1,15964
1712901001,Pedret i Marzà,1,1,17758
1713001001,La Pera,1,1,19549
1713201001,Peralada,1,1,21259
1713301001,Les Planes d'Hostoles,1,1,16529
1713401001,Planoles,1,1,19768
1713501001,Pont de Molins,1,1,15815
1713601001,Pontós,1,1,17706
1713701001,Porqueres,1,1,20901
1713701002,Porqueres,1,2,17523
1713701003,Porqueres,1,3,18386
1713801001,Portbou,1,1,16431
1713901001,Les Preses,1,1,18257
1714001001,El Port de la Selva,1,1,17998
1714101001,Puigcerdà,1,1,11217
1714101002,Puigcerdà,1,2,14814
1714101003,Puigcerdà,1,3,16907
1714101004,Puigcerdà,1,4,13128
1714101005,Puigcerdà,1,5,16387
1714201001,Quart,1,1,19464
1714201002,Quart,1,2,18944
1714301001,Rabós,1,1,14852
1714401001,Regencós,1,1,18295
1714501001,Ribes de Freser,1,1,18210
1714501002,Ribes de Freser,1,2,17245
1714601001,Riells i Viabrea,1,1,17028
1714601002,Riells i Viabrea,1,2,15872
1714701001,Ripoll,1,1,14642
1714702001,Ripoll,2,1,17341
1714702002,Ripoll,2,2,14477
1714703001,Ripoll,3,1,15541
1714703002,Ripoll,3,2,16521
1714703003,Ripoll,3,3,17551
1714703004,Ripoll,3,4,15164
1714704001,Ripoll,4,1,19806
1714801001,Riudarenes,1,1,15943
1714901001,Riudaura,1,1,17838
1715001001,Riudellots de la Selva,1,1,18703
1715101001,Riumors,1,1,17291
1715201001,Roses,1,1,12373
1715201002,Roses,1,2,13617
1715201003,Roses,1,3,13192
1715201004,Roses,1,4,14494
1715201005,Roses,1,5,13822
1715201006,Roses,1,6,12402
1715202001,Roses,2,1,12990
1715202002,Roses,2,2,12527
1715202003,Roses,2,3,21335
1715202004,Roses,2,4,17434
1715202005,Roses,2,5,12928
1715301001,Rupià,1,1,21083
1715401001,Sales de Llierca,1,1,16304
1715501001,Salt,1,1,14126
1715501002,Salt,1,2,13457
1715501003,Salt,1,3,8724
1715501004,Salt,1,4,13098
1715501005,Salt,1,5,9334
1715501006,Salt,1,6,8970
1715501008,Salt,1,8,14830
1715501009,Salt,1,9,18381
1715502001,Salt,2,1,11221
1715502002,Salt,2,2,10048
1715502003,Salt,2,3,11183
1715502004,Salt,2,4,12594
1715502005,Salt,2,5,15323
1715502006,Salt,2,6,9581
1715502007,Salt,2,7,14414
1715701001,Sant Andreu Salou,1,1,20819
1715801001,Sant Climent Sescebes,1,1,15233
1715901001,Sant Feliu de Buixalleu,1,1,13272
1716001001,Sant Feliu de Guíxols,1,1,18237
1716001002,Sant Feliu de Guíxols,1,2,17452
1716002001,Sant Feliu de Guíxols,2,1,15244
1716002002,Sant Feliu de Guíxols,2,2,13688
1716002003,Sant Feliu de Guíxols,2,3,13639
1716002004,Sant Feliu de Guíxols,2,4,13549
1716002005,Sant Feliu de Guíxols,2,5,11813
1716003001,Sant Feliu de Guíxols,3,1,14822
1716003002,Sant Feliu de Guíxols,3,2,13623
1716003003,Sant Feliu de Guíxols,3,3,10903
1716004001,Sant Feliu de Guíxols,4,1,16412
1716004002,Sant Feliu de Guíxols,4,2,21544
1716101001,Sant Feliu de Pallerols,1,1,18470
1716201001,Sant Ferriol,1,1,14507
1716301001,Sant Gregori,1,1,23556
1716301002,Sant Gregori,1,2,20811
1716301003,Sant Gregori,1,3,21311
1716401001,Sant Hilari Sacalm,1,1,13496
1716401002,Sant Hilari Sacalm,1,2,15794
1716401003,Sant Hilari Sacalm,1,3,15938
1716501001,Sant Jaume de Llierca,1,1,16711
1716601001,Sant Jordi Desvalls,1,1,16400
1716701001,Sant Joan de les Abadesses,1,1,17117
1716701002,Sant Joan de les Abadesses,1,2,17150
1716701003,Sant Joan de les Abadesses,1,3,17438
1716801001,Sant Joan de Mollet,1,1,17681
1716901001,Sant Julià de Ramis,1,1,16511
1716901002,Sant Julià de Ramis,1,2,16885
1716901003,Sant Julià de Ramis,1,3,22796
1717001001,Vallfogona de Ripollès,1,1,17742
1717101001,Sant Llorenç de la Muga,1,1,17730
1717201001,Sant Martí de Llémena,1,1,18580
1717301001,Sant Martí Vell,1,1,17063
1717401001,Sant Miquel de Campmajor,1,1,16585
1717501001,Sant Miquel de Fluvià,1,1,13170
1717601001,Sant Mori,1,1,21820
1717701001,Sant Pau de Segúries,1,1,17727
1717801001,Sant Pere Pescador,1,1,14860
1718001001,Santa Coloma de Farners,1,1,13689
1718001002,Santa Coloma de Farners,1,2,16267
1718001003,Santa Coloma de Farners,1,3,14428
1718001004,Santa Coloma de Farners,1,4,16706
1718001005,Santa Coloma de Farners,1,5,14860
1718001006,Santa Coloma de Farners,1,6,16048
1718101001,Santa Cristina d'Aro,1,1,15887
1718101002,Santa Cristina d'Aro,1,2,20639
1718201001,Santa Llogaia d'Àlguema,1,1,13176
1718301001,Sant Aniol de Finestres,1,1,19401
1718401001,Santa Pau,1,1,19236
1718501001,Sant Joan les Fonts,1,1,16364
1718501002,Sant Joan les Fonts,1,2,20129
1718501003,Sant Joan les Fonts,1,3,18505
1718601001,Sarrià de Ter,1,1,16959
1718601002,Sarrià de Ter,1,2,17044
1718601003,Sarrià de Ter,1,3,15807
1718701001,"Saus, Camallera i Llampaies",1,1,16279
1718801001,La Selva de Mar,1,1,17985
1718901001,La Cellera de Ter,1,1,16943
1718901002,La Cellera de Ter,1,2,16369
1719001001,Serinyà,1,1,16088
1719101001,Serra de Daró,1,1,19006
1719201001,Setcases,1,1,17664
1719301001,Sils,1,1,17254
1719301002,Sils,1,2,15815
1719301003,Sils,1,3,14903
1719401001,Susqueda,1,1,19792
1719501001,La Tallada d'Empordà,1,1,23264
1719601001,Terrades,1,1,18291
1719701001,Torrent,1,1,22561
1719801001,Torroella de Fluvià,1,1,17195
1719901001,Torroella de Montgrí,1,1,16515
1719901002,Torroella de Montgrí,1,2,15032
1719901003,Torroella de Montgrí,1,3,13904
1719901004,Torroella de Montgrí,1,4,15338
1719901005,Torroella de Montgrí,1,5,12422
1719901006,Torroella de Montgrí,1,6,15531
1719901007,Torroella de Montgrí,1,7,18335
1720001001,Tortellà,1,1,17694
1720101001,Toses,1,1,20180
1720201001,Tossa de Mar,1,1,15835
1720201002,Tossa de Mar,1,2,15352
1720201003,Tossa de Mar,1,3,15649
1720301001,Ultramort,1,1,17319
1720401001,Ullà,1,1,13178
1720501001,Ullastret,1,1,19092
1720601001,Urús,1,1,22427
1720701001,La Vall d'en Bas,1,1,19233
1720701002,La Vall d'en Bas,1,2,19924
1720801001,La Vall de Bianya,1,1,18730
1720901001,Vall-llobrega,1,1,18672
1721001001,Ventalló,1,1,17335
1721101001,Verges,1,1,16763
1721201001,Vidrà,1,1,17448
1721301001,Vidreres,1,1,15040
1721301002,Vidreres,1,2,15004
1721301003,Vidreres,1,3,19646
1721301004,Vidreres,1,4,13473
1721401001,Vilabertran,1,1,16043
1721501001,Vilablareix,1,1,20925
1721501002,Vilablareix,1,2,21358
1721601001,Viladasens,1,1,18030
1721701001,Viladamat,1,1,18124
1721801001,Vilademuls,1,1,18048
1722001001,Viladrau,1,1,19098
1722101001,Vilafant,1,1,15412
1722101002,Vilafant,1,2,17839
1722101003,Vilafant,1,3,16417
1722101004,Vilafant,1,4,18195
1722201001,Vilaür,1,1,19449
1722301001,Vilajuïga,1,1,16334
1722401001,Vilallonga de Ter,1,1,18153
1722501001,Vilamacolum,1,1,17335
1722601001,Vilamalla,1,1,15687
1722701001,Vilamaniscle,1,1,18322
1722801001,Vilanant,1,1,19025
1723001001,Vila-sacra,1,1,15322
1723201001,Vilopriu,1,1,22258
1723301001,Vilobí d'Onyar,1,1,18955
1723301002,Vilobí d'Onyar,1,2,17915
1723401001,Biure,1,1,16662
1790101001,"Cruïlles, Monells i Sant Sadurní de l'Heura",1,1,19279
1790201001,Forallac,1,1,18536
1790201002,Forallac,1,2,18791
1790301001,Sant Julià del Llor i Bonmatí,1,1,16363
4300101001,Aiguamúrcia,1,1,14179
4300201001,Albinyana,1,1,13675
4300201002,,,,14528
4300301001,L'Albiol,1,1,16989
4300401001,Alcanar,1,1,12356
4300401002,Alcanar,1,2,12765
4300401003,Alcanar,1,3,17252
4300401004,Alcanar,1,4,13003
4300401005,,,,14014
4300402001,Alcanar,2,1,12041
4300402002,Alcanar,2,2,
4300501001,Alcover,1,1,15523
4300502001,Alcover,2,1,16050
4300601001,Aldover,1,1,14350
4300701001,L'Aleixar,1,1,15379
4300801001,Alfara de Carles,1,1,14195
4300901001,Alforja,1,1,15615
4301001001,Alió,1,1,14533
4301101001,Almoster,1,1,21522
4301201001,Altafulla,1,1,18062
4301201002,Altafulla,1,2,20622
4301201003,Altafulla,1,3,21622
4301301001,L'Ametlla de Mar,1,1,15105
4301301002,L'Ametlla de Mar,1,2,13523
4301301003,L'Ametlla de Mar,1,3,16737
4301401001,Amposta,1,1,11101
4301401002,Amposta,1,2,13386
4301402001,Amposta,2,1,13351
4301402002,Amposta,2,2,11692
4301403001,Amposta,3,1,12871
4301403002,Amposta,3,2,12753
4301404001,Amposta,4,1,12418
4301404002,Amposta,4,2,12909
4301404003,Amposta,4,3,12895
4301404004,Amposta,4,4,16435
4301404005,Amposta,4,5,12846
4301404006,Amposta,4,6,14356
4301404007,,,,13444
4301404008,,,,12720
4301501001,Arbolí,1,1,16541
4301601001,L'Arboç,1,1,14299
4301601002,L'Arboç,1,2,12692
4301701001,L'Argentera,1,1,24005
4301801001,Arnes,1,1,14634
4301901001,Ascó,1,1,18242
4302001001,Banyeres del Penedès,1,1,16053
4302001002,Banyeres del Penedès,1,2,16547
4302101001,Barberà de la Conca,1,1,16109
4302201001,Batea,1,1,12510
4302201002,Batea,1,2,12352
4302301001,Bellmunt del Priorat,1,1,14489
4302401001,Bellvei,1,1,13976
4302501001,Benifallet,1,1,14766
4302601001,Benissanet,1,1,14150
4302701001,La Bisbal de Falset,1,1,12488
4302801001,La Bisbal del Penedès,1,1,15435
4302801002,La Bisbal del Penedès,1,2,13670
4302901001,Blancafort,1,1,16874
4303001001,Bonastre,1,1,14410
4303101001,Les Borges del Camp,1,1,14946
4303201001,Bot,1,1,13923
4303301001,Botarell,1,1,16286
4303401001,Bràfim,1,1,15722
4303501001,Cabacés,1,1,14332
4303601001,Cabra del Camp,1,1,14167
4303701001,Calafell,1,1,15002
4303701002,Calafell,1,2,15080
4303701003,Calafell,1,3,17276
4303701004,,,,13114
4303702001,Calafell,2,1,14577
4303702002,Calafell,2,2,20370
4303702003,Calafell,2,3,15477
4303703001,Calafell,3,1,14796
4303703002,Calafell,3,2,15241
4303703003,Calafell,3,3,13791
4303703004,Calafell,3,4,13958
4303703005,,,,12125
4303703006,,,,13738
4303704001,Calafell,4,1,15246
4303801001,Cambrils,1,1,.
4303801002,Cambrils,1,2,14206
4303801003,Cambrils,1,3,12595
4303801004,Cambrils,1,4,14581
4303801005,Cambrils,1,5,16626
4303801006,Cambrils,1,6,12586
4303802001,Cambrils,2,1,16591
4303802002,Cambrils,2,2,12475
4303802003,Cambrils,2,3,19791
4303802004,Cambrils,2,4,14512
4303802005,Cambrils,2,5,19538
4303802006,Cambrils,2,6,18574
4303802007,Cambrils,2,7,20064
4303802008,Cambrils,2,8,13070
4303802009,Cambrils,2,9,21545
4303802010,Cambrils,2,10,18499
4303802011,,,,19915
4303901001,Capafonts,1,1,18605
4304001001,Capçanes,1,1,15613
4304101001,Caseres,1,1,12736
4304201001,Castellvell del Camp,1,1,18675
4304201002,Castellvell del Camp,1,2,23237
4304301001,El Catllar,1,1,17039
4304301002,El Catllar,1,2,18918
4304301003,,,,21418
4304401001,La Sénia,1,1,13482
4304402001,La Sénia,2,1,12658
4304402002,La Sénia,2,2,13726
4304501001,Colldejou,1,1,16235
4304601001,Conesa,1,1,16260
4304701001,Constantí,1,1,13669
4304701002,Constantí,1,2,8002
4304702001,Constantí,2,1,14234
4304801001,Corbera d'Ebre,1,1,13272
4304901001,Cornudella de Montsant,1,1,16260
4305001001,Creixell,1,1,15969
4305001002,Creixell,1,2,14781
4305101001,Cunit,1,1,14325
4305101002,Cunit,1,2,14818
4305101003,Cunit,1,3,13490
4305101004,Cunit,1,4,13815
4305101005,Cunit,1,5,14690
4305101006,,,,16818
4305101007,,,,12314
4305101008,,,,16269
4305101009,,,,15418
4305201001,Xerta,1,1,14103
4305301001,Duesaigües,1,1,18061
4305401001,L'Espluga de Francolí,1,1,15814
4305402001,L'Espluga de Francolí,2,1,15861
4305501001,Falset,1,1,15001
4305502001,Falset,2,1,16677
4305601001,La Fatarella,1,1,15580
4305701001,La Febró,1,1,.
4305801001,La Figuera,1,1,14800
4305901001,Figuerola del Camp,1,1,18675
4306001001,Flix,1,1,15735
4306001002,Flix,1,2,16794
4306002001,Flix,2,1,17877
4306101001,Forès,1,1,.
4306201001,Freginals,1,1,13826
4306301001,La Galera,1,1,12038
4306401001,Gandesa,1,1,15045
4306402001,Gandesa,2,1,13341
4306501001,Garcia,1,1,13719
4306601001,Els Garidells,1,1,18787
4306701001,Ginestar,1,1,14433
4306801001,Godall,1,1,12959
4306901001,Gratallops,1,1,16239
4307001001,Els Guiamets,1,1,16793
4307101001,Horta de Sant Joan,1,1,13724
4307201001,El Lloar,1,1,14829
4307301001,Llorac,1,1,19098
4307401001,Llorenç del Penedès,1,1,16601
4307501001,Margalef,1,1,14887
4307601001,Marçà,1,1,14654
4307701001,Mas de Barberans,1,1,13817
4307801001,Masdenverge,1,1,14259
4307901001,Masllorenç,1,1,14815
4308001001,La Masó,1,1,15822
4308101001,Maspujols,1,1,16728
4308201001,El Masroig,1,1,13809
4308301001,El Milà,1,1,14542
4308401001,Miravet,1,1,14242
4308501001,El Molar,1,1,15802
4308601001,Montblanc,1,1,15485
4308601002,,,,
4308602001,Montblanc,2,1,16871
4308602002,Montblanc,2,2,15856
4308602003,Montblanc,2,3,19867
4308801001,Montbrió del Camp,1,1,14796
4308801002,Montbrió del Camp,1,2,15803
4308901001,Montferri,1,1,14112
4309001001,El Montmell,1,1,13059
4309101001,Mont-ral,1,1,16006
4309201001,Mont-roig del Camp,1,1,13612
4309201002,Mont-roig del Camp,1,2,14563
4309201003,Mont-roig del Camp,1,3,13204
4309201004,Mont-roig del Camp,1,4,16730
4309201005,Mont-roig del Camp,1,5,14644
4309201006,Mont-roig del Camp,1,6,14368
4309201007,Mont-roig del Camp,1,7,13917
4309201008,Mont-roig del Camp,1,8,15243
4309301001,Móra d'Ebre,1,1,14552
4309301002,Móra d'Ebre,1,2,16515
4309302001,Móra d'Ebre,2,1,13044
4309401001,Móra la Nova,1,1,14783
4309402001,Móra la Nova,2,1,13820
4309501001,El Morell,1,1,15135
4309501002,El Morell,1,2,17651
4309601001,La Morera de Montsant,1,1,14499
4309701001,La Nou de Gaià,1,1,15622
4309801001,Nulles,1,1,15315
4309901001,La Palma d'Ebre,1,1,14198
4310001001,Els Pallaresos,1,1,18979
4310001002,Els Pallaresos,1,2,18901
4310001003,Els Pallaresos,1,3,18612
4310101001,Passanant i Belltall,1,1,20993
4310201001,Paüls,1,1,14402
4310301001,Perafort,1,1,17204
4310401001,El Perelló,1,1,12988
4310401002,El Perelló,1,2,13748
4310501001,Les Piles,1,1,17702
4310601001,El Pinell de Brai,1,1,13981
4310701001,Pira,1,1,15794
4310801001,El Pla de Santa Maria,1,1,15265
4310901001,La Pobla de Mafumet,1,1,14638
4310901002,La Pobla de Mafumet,1,2,15519
4311001001,La Pobla de Massaluca,1,1,14189
4311101001,La Pobla de Montornès,1,1,14371
4311101002,La Pobla de Montornès,1,2,14355
4311201001,Poboleda,1,1,14237
4311301001,El Pont d'Armentera,1,1,14397
4311401001,Porrera,1,1,14978
4311501001,Pradell de la Teixeta,1,1,16689
4311601001,Prades,1,1,15752
4311701001,Prat de Comte,1,1,14393
4311801001,Pratdip,1,1,14678
4311901001,Puigpelat,1,1,16319
4312001001,Querol,1,1,15967
4312101001,Rasquera,1,1,13934
4312201001,Renau,1,1,19512
4312301001,Reus,1,1,13800
4312301002,Reus,1,2,19298
4312301003,Reus,1,3,17598
4312302001,Reus,2,1,12026
4312302002,Reus,2,2,14291
4312302003,Reus,2,3,16816
4312302004,Reus,2,4,11206
4312302006,Reus,2,6,15261
4312302007,Reus,2,7,15752
4312302008,Reus,2,8,13629
4312302009,Reus,2,9,19199
4312302010,Reus,2,10,16497
4312302011,Reus,2,11,11838
4312302012,Reus,2,12,17304
4312302013,Reus,2,13,14374
4312302014,Reus,2,14,14886
4312302015,Reus,2,15,19397
4312303001,Reus,3,1,13863
4312303003,Reus,3,3,12025
4312303004,Reus,3,4,12974
4312303005,Reus,3,5,10264
4312303007,Reus,3,7,14837
4312303008,Reus,3,8,14854
4312303009,Reus,3,9,10332
4312303010,Reus,3,10,11766
4312303011,Reus,3,11,13168
4312303012,Reus,3,12,11053
4312303013,Reus,3,13,15251
4312304002,Reus,4,2,13800
4312304003,Reus,4,3,12745
4312304004,Reus,4,4,12541
4312304005,Reus,4,5,16394
4312304007,Reus,4,7,11332
4312304008,Reus,4,8,14351
4312305001,Reus,5,1,12553
4312305002,Reus,5,2,14584
4312305003,Reus,5,3,9283
4312305004,Reus,5,4,14518
4312305005,Reus,5,5,10161
4312305007,Reus,5,7,14403
4312306001,Reus,6,1,13007
4312306002,Reus,6,2,26731
4312306003,Reus,6,3,18753
4312306004,Reus,6,4,21614
4312306005,Reus,6,5,13299
4312306006,Reus,6,6,20258
4312306007,Reus,6,7,16499
4312306008,Reus,6,8,17884
4312306009,Reus,6,9,10642
4312306011,Reus,6,11,23307
4312306012,Reus,6,12,17804
4312306013,Reus,6,13,21454
4312306014,,,,17321
4312307001,Reus,7,1,8097
4312307002,Reus,7,2,14291
4312307003,Reus,7,3,14379
4312307005,Reus,7,5,15213
4312308001,Reus,8,1,10961
4312308002,Reus,8,2,11999
4312308003,Reus,8,3,16464
4312308004,Reus,8,4,15086
4312308005,Reus,8,5,16379
4312308006,Reus,8,6,18751
4312308007,Reus,8,7,16098
4312308008,,,,28721
4312309001,Reus,9,1,23254
4312309002,Reus,9,2,15217
4312310001,Reus,10,1,17030
4312401001,La Riba,1,1,18920
4312501001,Riba-roja d'Ebre,1,1,16407
4312601001,La Riera de Gaià,1,1,15972
4312701001,Riudecanyes,1,1,16043
4312801001,Riudecols,1,1,15775
4312901001,Riudoms,1,1,13835
4312902001,Riudoms,2,1,13938
4312902002,Riudoms,2,2,15676
4312902003,Riudoms,2,3,17728
4313001001,Rocafort de Queralt,1,1,14927
4313101001,Roda de Berà,1,1,13769
4313101002,Roda de Berà,1,2,18463
4313101003,Roda de Berà,1,3,14171
4313101004,,,,16074
4313201001,Rodonyà,1,1,14947
4313301001,Roquetes,1,1,12797
4313301002,Roquetes,1,2,13156
4313302001,Roquetes,2,1,13587
4313302002,Roquetes,2,2,15619
4313401001,El Rourell,1,1,16210
4313501001,Salomó,1,1,14003
4313601001,Sant Carles de la Ràpita,1,1,13345
4313601002,Sant Carles de la Ràpita,1,2,13475
4313601003,Sant Carles de la Ràpita,1,3,13492
4313601004,Sant Carles de la Ràpita,1,4,12843
4313601005,Sant Carles de la Ràpita,1,5,12521
4313601006,,,,17634
4313601007,,,,13689
4313602001,Sant Carles de la Ràpita,2,1,14236
4313602002,Sant Carles de la Ràpita,2,2,
4313602003,Sant Carles de la Ràpita,2,3,12325
4313602004,Sant Carles de la Ràpita,2,4,16308
4313602005,Sant Carles de la Ràpita,2,5,15985
4313701001,Sant Jaume dels Domenys,1,1,14748
4313701002,,,,15863
4313801001,Santa Bàrbara,1,1,13208
4313802001,Santa Bàrbara,2,1,13380
4313901001,Santa Coloma de Queralt,1,1,15775
4313902001,Santa Coloma de Queralt,2,1,16096
4314001001,Santa Oliva,1,1,13920
4314001002,Santa Oliva,1,2,14074
4314101001,Pontils,1,1,14935
4314201001,Sarral,1,1,14640
4314301001,Savallà del Comtat,1,1,.
4314401001,La Secuita,1,1,17460
4314501001,La Selva del Camp,1,1,16161
4314502001,La Selva del Camp,2,1,17296
4314502002,La Selva del Camp,2,2,16495
4314601001,Senan,1,1,.
4314701001,Solivella,1,1,18275
4314801001,Tarragona,1,1,13654
4314802001,Tarragona,2,1,15749
4314803001,Tarragona,3,1,15550
4314803002,Tarragona,3,2,28807
4314803003,Tarragona,3,3,31936
4314804001,Tarragona,4,1,20191
4314804002,Tarragona,4,2,18555
4314804003,Tarragona,4,3,15404
4314804004,Tarragona,4,4,17862
4314804005,Tarragona,4,5,18988
4314804006,Tarragona,4,6,20325
4314804007,Tarragona,4,7,17510
4314804008,Tarragona,4,8,18271
4314804009,Tarragona,4,9,24179
4314804010,Tarragona,4,10,15068
4314804012,Tarragona,4,12,22072
4314804014,Tarragona,4,14,18547
4314804015,Tarragona,4,15,20323
4314804016,Tarragona,4,16,23436
4314805001,Tarragona,5,1,25195
4314805002,Tarragona,5,2,17924
4314805003,Tarragona,5,3,16361
4314805004,Tarragona,5,4,16849
4314805005,Tarragona,5,5,14508
4314805006,Tarragona,5,6,13108
4314805007,Tarragona,5,7,14107
4314805008,Tarragona,5,8,17162
4314806001,Tarragona,6,1,18204
4314806002,Tarragona,6,2,18231
4314806003,Tarragona,6,3,13078
4314806004,Tarragona,6,4,13205
4314806005,Tarragona,6,5,12621
4314806006,Tarragona,6,6,9025
4314806008,Tarragona,6,8,18789
4314806009,Tarragona,6,9,17194
4314806010,Tarragona,6,10,18035
4314806011,Tarragona,6,11,15859
4314806012,Tarragona,6,12,22363
4314806013,Tarragona,6,13,17346
4314806015,Tarragona,6,15,9763
4314806016,Tarragona,6,16,20267
4314806017,,,,22223
4314807001,Tarragona,7,1,16380
4314807002,Tarragona,7,2,18097
4314807003,Tarragona,7,3,14416
4314807004,Tarragona,7,4,17279
4314807005,Tarragona,7,5,7566
4314807006,Tarragona,7,6,10178
4314807007,Tarragona,7,7,25775
4314807008,Tarragona,7,8,23782
4314807010,Tarragona,7,10,11311
4314807011,Tarragona,7,11,15516
4314807012,Tarragona,7,12,11666
4314807013,Tarragona,7,13,24872
4314807014,Tarragona,7,14,25113
4314807015,Tarragona,7,15,15537
4314807016,Tarragona,7,16,24301
4314807017,Tarragona,7,17,21472
4314807018,Tarragona,7,18,18088
4314807019,Tarragona,7,19,14112
4314807020,Tarragona,7,20,22093
4314807021,Tarragona,7,21,17507
4314807022,Tarragona,7,22,17264
4314807023,Tarragona,7,23,23674
4314807024,,,,25025
4314807025,,,,20337
4314807026,,,,17503
4314808001,Tarragona,8,1,10063
4314808002,Tarragona,8,2,10310
4314808003,Tarragona,8,3,11028
4314808004,Tarragona,8,4,12105
4314808005,Tarragona,8,5,10951
4314808006,Tarragona,8,6,13624
4314808007,Tarragona,8,7,12684
4314808008,Tarragona,8,8,10055
4314808009,Tarragona,8,9,14154
4314808010,Tarragona,8,10,7896
4314808011,Tarragona,8,11,14618
4314808012,Tarragona,8,12,7462
4314808013,Tarragona,8,13,10410
4314808014,Tarragona,8,14,10245
4314809001,Tarragona,9,1,11710
4314809002,Tarragona,9,2,10047
4314809003,Tarragona,9,3,9648
4314809004,Tarragona,9,4,10585
4314809005,,,,
4314809006,,,,
4314809008,Tarragona,9,8,10471
4314809009,Tarragona,9,9,11324
4314809010,Tarragona,9,10,11842
4314901001,Tivenys,1,1,13733
4315001001,Tivissa,1,1,15380
4315101001,La Torre de Fontaubella,1,1,17619
4315201001,La Torre de l'Espanyol,1,1,13927
4315301001,Torredembarra,1,1,13061
4315301002,Torredembarra,1,2,19812
4315301003,Torredembarra,1,3,15044
4315301004,Torredembarra,1,4,17903
4315301005,Torredembarra,1,5,14680
4315301006,Torredembarra,1,6,12943
4315301007,Torredembarra,1,7,15057
4315301008,Torredembarra,1,8,16854
4315301009,,,,12674
4315401001,Torroja del Priorat,1,1,15676
4315501001,Tortosa,1,1,9693
4315501002,Tortosa,1,2,12420
4315501003,Tortosa,1,3,16656
4315501004,Tortosa,1,4,16078
4315501005,Tortosa,1,5,7275
4315501006,Tortosa,1,6,17246
4315501007,Tortosa,1,7,17613
4315502002,Tortosa,2,2,21104
4315502003,Tortosa,2,3,15504
4315502004,Tortosa,2,4,15138
4315502005,Tortosa,2,5,14198
4315503001,Tortosa,3,1,10663
4315503002,Tortosa,3,2,13544
4315503003,,,,
4315503004,Tortosa,3,4,16671
4315504001,Tortosa,4,1,16317
4315504002,Tortosa,4,2,12835
4315504003,Tortosa,4,3,10183
4315504004,Tortosa,4,4,12799
4315504005,Tortosa,4,5,15038
4315504006,Tortosa,4,6,13808
4315504007,Tortosa,4,7,13954
4315504008,Tortosa,4,8,17818
4315504009,Tortosa,4,9,14024
4315601001,Ulldecona,1,1,13530
4315601002,Ulldecona,1,2,12897
4315602001,Ulldecona,2,1,11446
4315701001,Ulldemolins,1,1,16354
4315801001,Vallclara,1,1,.
4315901001,Vallfogona de Riucorb,1,1,.
4316001001,Vallmoll,1,1,17198
4316101001,Valls,1,1,11177
4316102001,Valls,2,1,10646
4316103001,Valls,3,1,13364
4316104001,Valls,4,1,15185
4316104002,Valls,4,2,15808
4316104003,Valls,4,3,16166
4316105001,Valls,5,1,13466
4316105002,Valls,5,2,15959
4316105003,Valls,5,3,13655
4316106001,Valls,6,1,15402
4316106002,Valls,6,2,17560
4316106003,Valls,6,3,18000
4316106004,Valls,6,4,14675
4316106005,Valls,6,5,16690
4316106006,Valls,6,6,16682
4316201001,Vandellòs i l'Hospitalet de l'Infant,1,1,17377
4316201002,Vandellòs i l'Hospitalet de l'Infant,1,2,18926
4316201003,Vandellòs i l'Hospitalet de l'Infant,1,3,16641
4316201004,Vandellòs i l'Hospitalet de l'Infant,1,4,17426
4316301001,El Vendrell,1,1,16373
4316301002,El Vendrell,1,2,13371
4316301003,El Vendrell,1,3,14684
4316302001,El Vendrell,2,1,12470
4316302002,El Vendrell,2,2,11310
4316302003,El Vendrell,2,3,11938
4316302004,El Vendrell,2,4,13070
4316302005,El Vendrell,2,5,15529
4316302006,,,,16793
4316303001,El Vendrell,3,1,14624
4316303002,El Vendrell,3,2,13756
4316303003,El Vendrell,3,3,15770
4316303004,El Vendrell,3,4,14016
4316303005,El Vendrell,3,5,14223
4316303006,El Vendrell,3,6,15908
4316303007,El Vendrell,3,7,17748
4316303008,El Vendrell,3,8,14254
4316303009,El Vendrell,3,9,18572
4316303010,El Vendrell,3,10,16890
4316303011,El Vendrell,3,11,15969
4316303012,El Vendrell,3,12,16853
4316303013,El Vendrell,3,13,15767
4316401001,Vespella de Gaià,1,1,16121
4316501001,Vilabella,1,1,16152
4316601001,Vilallonga del Camp,1,1,15643
4316701001,Vilanova d'Escornalbou,1,1,15958
4316801001,Vilanova de Prades,1,1,.
4316901001,Vilaplana,1,1,19059
4317001001,Vila-rodona,1,1,14929
4317101001,Vila-seca,1,1,16216
4317101002,Vila-seca,1,2,15302
4317101003,Vila-seca,1,3,12404
4317101004,Vila-seca,1,4,15088
4317101005,Vila-seca,1,5,13544
4317101006,Vila-seca,1,6,14994
4317101007,Vila-seca,1,7,14727
4317101008,Vila-seca,1,8,13825
4317101009,Vila-seca,1,9,14898
4317101010,Vila-seca,1,10,14614
4317101011,Vila-seca,1,11,17483
4317101012,Vila-seca,1,12,11881
4317101013,,,,13425
4317201001,Vilaverd,1,1,15470
4317301001,La Vilella Alta,1,1,15608
4317401001,La Vilella Baixa,1,1,15653
4317501001,Vilalba dels Arcs,1,1,13478
4317601001,Vimbodí i Poblet,1,1,17410
4317701001,Vinebre,1,1,15035
4317801001,Vinyols i els Arcs,1,1,17883
4390101001,Deltebre,1,1,13770
4390101002,Deltebre,1,2,12641
4390101003,Deltebre,1,3,13369
4390101004,Deltebre,1,4,13724
4390101005,Deltebre,1,5,14179
4390101006,Deltebre,1,6,13926
4390201001,Sant Jaume d'Enveja,1,1,13543
4390201002,Sant Jaume d'Enveja,1,2,12776
4390301001,Camarles,1,1,13670
4390301002,Camarles,1,2,12968
4390401001,L'Aldea,1,1,12215
4390401002,L'Aldea,1,2,13219
4390501001,Salou,1,1,16264
4390501002,Salou,1,2,12446
4390501003,Salou,1,3,12857
4390501004,Salou,1,4,12657
4390501005,Salou,1,5,15228
4390501006,Salou,1,6,12818
4390501007,Salou,1,7,14677
4390501008,Salou,1,8,16019
4390501009,Salou,1,9,14964
4390501010,Salou,1,10,16802
4390501011,Salou,1,11,18220
4390501012,Salou,1,12,16223
4390501013,,,,17641
4390501014,,,,13630
4390601001,L'Ampolla,1,1,16008
4390601002,L'Ampolla,1,2,16017
4390701001,La Canonja,1,1,16183
4390701002,La Canonja,1,2,14374
4390701003,La Canonja,1,3,15627
4390701004,La Canonja,1,4,14777
2500101001,Abella de la Conca,1,1,14430
2500201001,Àger,1,1,16481
2500301001,Agramunt,1,1,14311
2500301002,Agramunt,1,2,14985
2500301003,Agramunt,1,3,15581
2500301004,Agramunt,1,4,16721
2500401001,Els Alamús,1,1,16848
2500501001,Alàs i Cerc,1,1,15119
2500601001,L'Albagés,1,1,14106
2500701001,Albatàrrec,1,1,15279
2500801001,Albesa,1,1,15473
2500901001,L'Albi,1,1,14645
2501001001,Alcanó,1,1,14347
2501101001,Alcarràs,1,1,13950
2501101002,Alcarràs,1,2,13396
2501101003,Alcarràs,1,3,12784
2501101004,Alcarràs,1,4,14456
2501201001,Alcoletge,1,1,15137
2501201002,Alcoletge,1,2,14802
2501301001,Alfarràs,1,1,14233
2501301002,Alfarràs,1,2,13836
2501401001,Alfés,1,1,16648
2501501001,Algerri,1,1,15793
2501601001,Alguaire,1,1,15335
2501601002,Alguaire,1,2,15658
2501701001,Alins,1,1,17842
2501901001,Almacelles,1,1,14821
2501901002,Almacelles,1,2,14715
2501902001,Almacelles,2,1,13632
2501902002,Almacelles,2,2,14864
2502001001,Almatret,1,1,17371
2502101001,Almenar,1,1,13456
2502102001,Almenar,2,1,15138
2502102002,Almenar,2,2,16478
2502201001,Alòs de Balaguer,1,1,17119
2502301001,Alpicat,1,1,16682
2502301002,Alpicat,1,2,20307
2502301003,Alpicat,1,3,24497
2502401001,Alt Àneu,1,1,20698
2502501001,Naut Aran,1,1,19500
2502701001,Anglesola,1,1,15048
2502901001,Arbeca,1,1,13903
2502901002,Arbeca,1,2,16640
2503001001,El Pont de Bar,1,1,15355
2503101001,Arres,1,1,23630
2503201001,Arsèguel,1,1,20589
2503301001,Artesa de Lleida,1,1,16185
2503401001,Artesa de Segre,1,1,14728
2503401002,Artesa de Segre,1,2,15148
2503501001,La Sentiu de Sió,1,1,16916
2503601001,Aspa,1,1,14425
2503701001,Les Avellanes i Santa Linya,1,1,16566
2503801001,Aitona,1,1,13229
2503801002,Aitona,1,2,12494
2503901001,Baix Pallars,1,1,19035
2504001001,Balaguer,1,1,10880
2504001002,Balaguer,1,2,13900
2504002001,Balaguer,2,1,9027
2504003001,Balaguer,3,1,13269
2504003002,Balaguer,3,2,12347
2504004001,Balaguer,4,1,14962
2504004002,Balaguer,4,2,12622
2504004003,Balaguer,4,3,16430
2504004004,Balaguer,4,4,17210
2504101001,Barbens,1,1,13705
2504201001,La Baronia de Rialb,1,1,19314
2504301001,La Vall de Boí,1,1,18315
2504401001,Bassella,1,1,16333
2504501001,Bausen,1,1,23630
2504601001,Belianes,1,1,14589
2504701001,Bellcaire d'Urgell,1,1,16067
2504801001,Bell-lloc d'Urgell,1,1,16320
2504801002,Bell-lloc d'Urgell,1,2,16001
2504901001,Bellmunt d'Urgell,1,1,15885
2505001001,Bellpuig,1,1,13102
2505001002,Bellpuig,1,2,14180
2505001003,Bellpuig,1,3,16295
2505101001,Bellver de Cerdanya,1,1,19143
2505201001,Bellvís,1,1,15611
2505301001,Benavent de Segrià,1,1,17575
2505501001,Biosca,1,1,15673
2505601001,Bovera,1,1,14442
2505701001,Es Bòrdes,1,1,21742
2505801001,Les Borges Blanques,1,1,13851
2505801002,Les Borges Blanques,1,2,15947
2505802001,Les Borges Blanques,2,1,16001
2505802002,Les Borges Blanques,2,2,12961
2505901001,Bossòst,1,1,16059
2506001001,Cabanabona,1,1,.
2506101001,Cabó,1,1,20589
2506201001,Camarasa,1,1,18523
2506301001,Canejan,1,1,23630
2506401001,Castellar de la Ribera,1,1,15548
2506701001,Castelldans,1,1,14894
2506801001,Castellnou de Seana,1,1,14310
2506901001,Castelló de Farfanya,1,1,14462
2507001001,Castellserà,1,1,15504
2507101001,Cava,1,1,20589
2507201001,Cervera,1,1,13920
2507202001,Cervera,2,1,16082
2507202002,Cervera,2,2,13832
2507202003,Cervera,2,3,18088
2507203001,Cervera,3,1,14794
2507301001,Cervià de les Garrigues,1,1,13496
2507401001,Ciutadilla,1,1,16708
2507501001,Clariana de Cardener,1,1,15952
2507601001,El Cogul,1,1,13553
2507701001,Coll de Nargó,1,1,16749
2507801001,Corbins,1,1,15939
2507901001,Cubells,1,1,16197
2508101001,L'Espluga Calba,1,1,13528
2508201001,Espot,1,1,20770
2508501001,Estaràs,1,1,17676
2508601001,Esterri d'Àneu,1,1,17437
2508701001,Esterri de Cardós,1,1,.
2508801001,Estamariu,1,1,14918
2508901001,Farrera,1,1,15748
2509201001,La Floresta,1,1,17497
2509301001,Fondarella,1,1,16549
2509401001,Foradada,1,1,15597
2509601001,La Fuliola,1,1,14685
2509701001,Fulleda,1,1,.
2509801001,Gavet de la Conca,1,1,16946
2509901001,Golmés,1,1,15969
2510001001,Gósol,1,1,18907
2510101001,La Granadella,1,1,15983
2510201001,La Granja d'Escarp,1,1,14359
2510301001,Granyanella,1,1,16221
2510401001,Granyena de Segarra,1,1,16257
2510501001,Granyena de les Garrigues,1,1,13069
2510901001,Guimerà,1,1,13941
2511001001,Guissona,1,1,13241
2511001002,Guissona,1,2,16939
2511001003,Guissona,1,3,13970
2511101001,Guixers,1,1,21507
2511201001,Ivars de Noguera,1,1,15526
2511301001,Ivars d'Urgell,1,1,16301
2511301002,Ivars d'Urgell,1,2,16220
2511401001,Ivorra,1,1,18663
2511501001,Isona i Conca Dellà,1,1,15638
2511801001,Juncosa,1,1,13102
2511901001,Juneda,1,1,15216
2511901002,Juneda,1,2,16389
2512001001,Lleida,1,1,16937
2512001003,Lleida,1,3,15205
2512001004,Lleida,1,4,18519
2512001005,Lleida,1,5,13046
2512001006,Lleida,1,6,12866
2512001007,Lleida,1,7,15280
2512001008,Lleida,1,8,15307
2512001009,Lleida,1,9,12764
2512001010,Lleida,1,10,12086
2512001011,Lleida,1,11,14824
2512001012,Lleida,1,12,12256
2512001013,Lleida,1,13,13895
2512001014,Lleida,1,14,16955
2512002002,Lleida,2,2,15031
2512002003,Lleida,2,3,16198
2512002004,Lleida,2,4,16577
2512002005,Lleida,2,5,19761
2512002006,Lleida,2,6,15610
2512002007,Lleida,2,7,14314
2512002008,Lleida,2,8,14809
2512002009,Lleida,2,9,21514
2512003001,Lleida,3,1,12465
2512003003,Lleida,3,3,14105
2512003004,Lleida,3,4,20983
2512003005,Lleida,3,5,
2512003006,Lleida,3,6,15646
2512003007,Lleida,3,7,16200
2512003008,Lleida,3,8,16356
2512004001,Lleida,4,1,9801
2512004003,Lleida,4,3,20088
2512004004,Lleida,4,4,14368
2512004005,Lleida,4,5,14368
2512004006,Lleida,4,6,15992
2512004007,Lleida,4,7,14980
2512004008,Lleida,4,8,10378
2512004010,Lleida,4,10,8060
2512004011,Lleida,4,11,8490
2512004013,Lleida,4,13,10574
2512004014,Lleida,4,14,12290
2512004015,Lleida,4,15,14236
2512004016,Lleida,4,16,14146
2512004017,Lleida,4,17,17256
2512005002,Lleida,5,2,14704
2512005003,Lleida,5,3,12924
2512005004,Lleida,5,4,18241
2512005005,Lleida,5,5,18901
2512005006,Lleida,5,6,26651
2512005007,Lleida,5,7,14129
2512005008,Lleida,5,8,23892
2512005009,Lleida,5,9,22151
2512005010,Lleida,5,10,20775
2512005011,Lleida,5,11,26034
2512005012,Lleida,5,12,23063
2512006001,Lleida,6,1,12333
2512006002,Lleida,6,2,13781
2512006003,Lleida,6,3,12880
2512006004,Lleida,6,4,16423
2512006005,Lleida,6,5,24007
2512006006,Lleida,6,6,15296
2512006007,Lleida,6,7,13451
2512006009,Lleida,6,9,12348
2512006010,Lleida,6,10,12375
2512006011,Lleida,6,11,16601
2512006012,Lleida,6,12,16017
2512006013,Lleida,6,13,19997
2512006014,Lleida,6,14,17283
2512006016,Lleida,6,16,23391
2512006017,Lleida,6,17,13074
2512007001,Lleida,7,1,15408
2512007002,Lleida,7,2,14735
2512007003,Lleida,7,3,16172
2512007004,Lleida,7,4,11860
2512007005,Lleida,7,5,14347
2512007006,Lleida,7,6,12909
2512007007,Lleida,7,7,14228
2512007008,,,,19015
2512008001,Lleida,8,1,16935
2512008002,Lleida,8,2,30360
2512008003,Lleida,8,3,19178
2512008004,Lleida,8,4,20951
2512009001,Lleida,9,1,26769
2512009002,Lleida,9,2,14769
2512101001,Les,1,1,17699
2512201001,Linyola,1,1,14890
2512201002,Linyola,1,2,14927
2512301001,Lladorre,1,1,18697
2512401001,Lladurs,1,1,17316
2512501001,Llardecans,1,1,16643
2512601001,Llavorsí,1,1,18661
2512701001,Lles de Cerdanya,1,1,19183
2512801001,Llimiana,1,1,16658
2512901001,Llobera,1,1,14504
2513001001,Maldà,1,1,16640
2513101001,Massalcoreig,1,1,12370
2513201001,Massoteres,1,1,16040
2513301001,Maials,1,1,14690
2513401001,Menàrguens,1,1,15087
2513501001,Miralcamp,1,1,14868
2513601001,La Molsosa,1,1,15385
2513701001,Mollerussa,1,1,13336
2513701002,Mollerussa,1,2,14762
2513701003,Mollerussa,1,3,12536
2513701004,Mollerussa,1,4,16203
2513701005,Mollerussa,1,5,13831
2513701006,Mollerussa,1,6,15165
2513801001,Montgai,1,1,16221
2513901001,Montellà i Martinet,1,1,16915
2514001001,Montferrer i Castellbò,1,1,15324
2514101001,Montoliu de Segarra,1,1,17830
2514201001,Montoliu de Lleida,1,1,16115
2514301001,Montornès de Segarra,1,1,.
2514501001,Nalec,1,1,.
2514601001,Navès,1,1,16217
2514801001,Odèn,1,1,17900
2514901001,Oliana,1,1,15736
2515001001,Oliola,1,1,20172
2515101001,Olius,1,1,18202
2515201001,Les Oluges,1,1,20373
2515301001,Els Omellons,1,1,16595
2515401001,Els Omells de na Gaia,1,1,15405
2515501001,Organyà,1,1,14942
2515601001,Os de Balaguer,1,1,16360
2515701001,Ossó de Sió,1,1,18329
2515801001,El Palau d'Anglesola,1,1,17162
2516101001,Conca de Dalt,1,1,19699
2516301001,La Coma i la Pedra,1,1,19242
2516401001,Penelles,1,1,18248
2516501001,Peramola,1,1,16985
2516601001,Pinell de Solsonès,1,1,16642
2516701001,Pinós,1,1,16544
2516801001,El Poal,1,1,16169
2516901001,La Pobla de Cérvoles,1,1,17495
2517001001,Bellaguarda,1,1,13914
2517101001,La Pobla de Segur,1,1,15674
2517101002,La Pobla de Segur,1,2,17320
2517201001,Ponts,1,1,15828
2517201002,Ponts,1,2,15206
2517301001,El Pont de Suert,1,1,16838
2517301002,El Pont de Suert,1,2,15629
2517401001,La Portella,1,1,15017
2517501001,Prats i Sansor,1,1,19636
2517601001,Preixana,1,1,17089
2517701001,Preixens,1,1,15047
2517901001,Prullans,1,1,16242
2518001001,Puiggròs,1,1,15457
2518101001,Puigverd d'Agramunt,1,1,16052
2518201001,Puigverd de Lleida,1,1,16239
2518301001,Rialp,1,1,18964
2518501001,Ribera d'Urgellet,1,1,14899
2518601001,Riner,1,1,17314
2518901001,Rosselló,1,1,15573
2519001001,Salàs de Pallars,1,1,18851
2519101001,Sanaüja,1,1,16563
2519201001,Sant Guim de Freixenet,1,1,15589
2519301001,Sant Llorenç de Morunys,1,1,18822
2519401001,Sant Ramon,1,1,17082
2519601001,Sant Esteve de la Sarga,1,1,19071
2519701001,Sant Guim de la Plana,1,1,19210
2520001001,Sarroca de Lleida,1,1,14788
2520101001,Sarroca de Bellera,1,1,22524
2520201001,Senterada,1,1,19643
2520301001,La Seu d'Urgell,1,1,11519
2520301002,La Seu d'Urgell,1,2,12989
2520301003,La Seu d'Urgell,1,3,13492
2520301004,La Seu d'Urgell,1,4,15326
2520301005,La Seu d'Urgell,1,5,12478
2520301006,La Seu d'Urgell,1,6,14605
2520301007,La Seu d'Urgell,1,7,14580
2520401001,Seròs,1,1,13621
2520401002,Seròs,1,2,13381
2520501001,Sidamon,1,1,16422
2520601001,El Soleràs,1,1,14103
2520701001,Solsona,1,1,15619
2520701002,Solsona,1,2,14044
2520701003,Solsona,1,3,13924
2520702001,Solsona,2,1,15316
2520702002,Solsona,2,2,14862
2520801001,Soriguera,1,1,16418
2520901001,Sort,1,1,16934
2521001001,Soses,1,1,15808
2521101001,Sudanell,1,1,16133
2521201001,Sunyer,1,1,15645
2521501001,Talarn,1,1,17438
2521601001,Talavera,1,1,19255
2521701001,Tàrrega,1,1,13917
2521701002,Tàrrega,1,2,14328
2521702001,Tàrrega,2,1,16506
2521702002,Tàrrega,2,2,15547
2521702003,Tàrrega,2,3,14665
2521703001,Tàrrega,3,1,12991
2521703002,Tàrrega,3,2,13432
2521703003,Tàrrega,3,3,13654
2521704001,Tàrrega,4,1,14591
2521704002,Tàrrega,4,2,14067
2521801001,Tarrés,1,1,16398
2521901001,Tarroja de Segarra,1,1,16838
2522001001,Térmens,1,1,16607
2522101001,Tírvia,1,1,15426
2522201001,Tiurana,1,1,.
2522301001,Torà,1,1,16496
2522401001,Els Torms,1,1,17116
2522501001,Tornabous,1,1,15380
2522601001,Torrebesses,1,1,14123
2522701001,La Torre de Cabdella,1,1,23079
2522801001,Torrefarrera,1,1,15509
2522801002,Torrefarrera,1,2,18621
2523001001,Torregrossa,1,1,15140
2523101001,Torrelameu,1,1,15400
2523201001,Torres de Segre,1,1,14192
2523301001,Torre-serona,1,1,17669
2523401001,Tremp,1,1,15996
2523401002,Tremp,1,2,16395
2523402001,Tremp,2,1,15642
2523402002,Tremp,2,2,16011
2523403001,Tremp,3,1,
2523801001,Vallbona de les Monges,1,1,17575
2523901001,Les Valls de Valira,1,1,13759
2524001001,Vallfogona de Balaguer,1,1,16287
2524201001,Verdú,1,1,15740
2524301001,Vielha e Mijaran,1,1,15683
2524301002,Vielha e Mijaran,1,2,17922
2524301003,Vielha e Mijaran,1,3,17697
2524401001,Vilagrassa,1,1,17108
2524501001,Vilaller,1,1,17168
2524701001,Vilamòs,1,1,25549
2524801001,Vilanova de Bellpuig,1,1,16559
2524901001,Vilanova de l'Aguda,1,1,17338
2525001001,Vilanova de Meià,1,1,18237
2525101001,Vilanova de Segrià,1,1,15744
2525201001,Vila-sana,1,1,17467
2525301001,El Vilosell,1,1,17534
2525401001,Vilanova de la Barca,1,1,16530
2525501001,Vinaixa,1,1,15284
2590101001,Vall de Cardós,1,1,18797
2590201001,Sant Martí de Riucorb,1,1,15206
2590301001,La Guingueta d'Àneu,1,1,19765
2590401001,Castell de Mur,1,1,19885
2590501001,Ribera d'Ondara,1,1,15675
2590601001,Les Valls d'Aguilar,1,1,15618
2590701001,Torrefeta i Florejacs,1,1,16872
2590801001,Fígols i Alinyà,1,1,15489
2590901001,La Vansa i Fórnols,1,1,16282
2591001001,Josa i Tuixén,1,1,17027
2591101001,Els Plans de Sió,1,1,18402
2591201001,Gimenells i el Pla de la Font,1,1,16407
2591301001,Riu de Cerdanya,1,1,20589